/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.2.2.0 (NJsonSchema v10.1.4.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export interface IClient {
    /**
     * @return Success
     */
    get(id: string): Promise<Account>;
    /**
     * @param body (optional) 
     * @return Success
     */
    post(body: AddAccountRequest | undefined): Promise<Account>;
    /**
     * @param body (optional) 
     * @return Success
     */
    approveAccountHolder(body: ApproveAccountCommandRequest | undefined): Promise<ApproveAccountCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAccounts(body: AccountFilterRequest | undefined): Promise<AccountFilterResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getPaymentMandates(body: PaymentMandateFilterRequest | undefined): Promise<PaymentMandateFilterResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getAccountById(body: GetAccountByIdRequest | undefined): Promise<SlimAccount>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getGuestAccount(body: GetGuestAccountByIdRequest | undefined): Promise<SlimAccount>;
    /**
     * @param body (optional) 
     * @return Success
     */
    isValidToken(body: TokenValidityQueryRequest | undefined): Promise<TokenValidityQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addJcsdAccountDummyMethod(body: WebAccountModel | undefined): Promise<AddJcsdAccountCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    addJcsdAccount(body: Blob | undefined): Promise<AddJcsdAccountCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editJcsdAccountDummyMethod(body: WebAccountModel | undefined): Promise<EditJcsdAccountCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editJcsdAccount(body: Blob | undefined): Promise<EditJcsdAccountCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    validateAccount(body: Blob | undefined): Promise<ValidateAccountCommandResponse>;
    /**
     * @return Success
     */
    file(id: string): Promise<GetFileByIdQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getClientApplicationsByFilter(body: GetAllApplicationsByFilterQueryRequest | undefined): Promise<GetAllApplicationsByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    verifyEligibility(body: VerifyEligibilityModel | undefined): Promise<VerifyEligibilityResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getSharesAvailableForApplication(body: GetSharesAvailableForApplicationQueryRequest | undefined): Promise<GetSharesAvailableForApplicationQueryResponse>;
    clientApplication(): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getOfferingsByFilterForCustomer(body: GetOfferingsByFilterForCustomerQueryRequest | undefined): Promise<GetOfferingsByFilterForCustomerQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getOfferingsByIdForCustomer(body: GetOfferingsByIdForCustomerQueryRequest | undefined): Promise<GetOfferingsByIdForCustomerQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getOfferingsViewModelByIdForCustomer(body: GetOfferingsViewModelByIdForCustomerQueryRequest | undefined): Promise<GetOfferingsViewModelByIdForCustomerQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getSharePoolsByOfferingId(body: GetSharePoolsByOfferingIdQueryRequest | undefined): Promise<GetSharePoolsByOfferingIdQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getJointHoldersForAccount(body: GetJointHoldersForAccountRequest | undefined): Promise<GetJointHoldersForAccountResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getJointHoldersForGuestAccount(body: GetJointHoldersForGuestAccountRequest | undefined): Promise<GetJointHoldersForGuestAccountResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    saveOfferingApplication(body: GetSharePoolsByOfferingIdQueryRequest | undefined): Promise<GetSharePoolsByOfferingIdQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    processSubscriptionDummyMethod(body: WebApplicationModel | undefined): Promise<ProcessSubscriptionCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    processSubscription(body: Blob | undefined): Promise<ProcessSubscriptionCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    saveDraftApplicationDummyMethod(body: WebApplicationModel | undefined): Promise<ProcessSubscriptionCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    resumeGuestApplication(body: ResumeGuestApplicationCommandRequest | undefined): Promise<ResumeGuestApplicationCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    saveDraftApplication(body: Blob | undefined): Promise<ProcessSubscriptionCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editApplication(body: Blob | undefined): Promise<EditApplicationCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    cancelApplication(body: CancelApplicationCommandRequest | undefined): Promise<CancelApplicationCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getApplicationsByFilterForCustomer(body: GetApplicationsByFilterForCustomerQueryRequest | undefined): Promise<GetApplicationsByFilterForCustomerQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getApplicationByIdForCustomer(body: GetApplicationByIdForCustomerQueryRequest | undefined): Promise<ApplicationViewModel>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getFiservUrl(body: CreateFiservPaymentCommandRequest | undefined): Promise<CreateFiservPaymentCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    fiservSuccess(body: Blob | undefined): Promise<GetAllApplicationsByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    fiservSuccess2(body: Blob | undefined): Promise<GetAllApplicationsByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    fiservFailure(body: Blob | undefined): Promise<GetAllApplicationsByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    fiservFailure2(body: Blob | undefined): Promise<GetAllApplicationsByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    fiservSuccessJson(body: FiservSuccessResponseModel | undefined): Promise<GetAllApplicationsByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    fiservSuccessJson2(body: FiservSuccessResponseModel | undefined): Promise<GetAllApplicationsByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    fiservFailureJson(body: FiservFailureResponseModel | undefined): Promise<GetAllApplicationsByFilterQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    fiservFailureJson2(body: FiservFailureResponseModel | undefined): Promise<GetAllApplicationsByFilterQueryResponse>;
    /**
     * @return Success
     */
    getAllReports(): Promise<GetAllReportsQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getReportById(body: GetReportByQueryRequest | undefined): Promise<GetReportByQueryResponse>;
    /**
     * @return Success
     */
    logout(): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    login(body: LoginCommandRequest | undefined): Promise<LoginCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    verifyLogin(body: VerifyLoginCommandRequest | undefined): Promise<VerifyLoginCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterUserCommandRequest | undefined): Promise<RegisterUserCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    registerGuest(body: RegisterGuestCommandRequest | undefined): Promise<RegisterGuestCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    validateGuestOTP(body: ValidateGuestOTPCommandRequest | undefined): Promise<LoginResponseModel>;
    /**
     * @param body (optional) 
     * @return Success
     */
    resendOTP(body: ResendOTPCommandRequest | undefined): Promise<ResendOTPCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    confirmRegistration(body: ConfirmRegistrationCommandRequest | undefined): Promise<ConfirmRegistrationCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    ressetPassword(body: ResetPasswordCommandRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getSecurityQuestions(body: GetSecurityQuestionsQueryRequest | undefined): Promise<GetSecurityQuestionsQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    updateSecurityQuestions(body: UpdateSecurityQuestionsCommandRequest | undefined): Promise<UpdateSecurityQuestionsCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getFilteredCountries(body: CountryFilterRequest | undefined): Promise<CountryFilterResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getPaymentMethodDescription(body: GetPaymentMethodDescriptionCommandRequest | undefined): Promise<GetPaymentMethodDescriptionCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getBrokers(body: BrokerFilterRequest | undefined): Promise<BrokerFilterResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getBanks(body: BankFilterRequest | undefined): Promise<BankFilterResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    requestPasswordReset(body: RequestPasswordResetCommandRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    resendActivationEmail(body: ResendActivationEmailCommandRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordCommandRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordCommandRequest | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    getMyUserProfile(body: GetMyUserProfileQueryRequest | undefined): Promise<GetMyUserProfileQueryResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    editMyUserProfile(body: UserEditOwnProfileCommandRequest | undefined): Promise<UserEditOwnProfileCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    uploadUserDocuments(body: Blob | undefined): Promise<UploadUserDocumentsCommandResponse>;
    /**
     * @param body (optional) 
     * @return Success
     */
    uploadUserDocumentsDummyMethod(body: ClientDocumentViewModel | undefined): Promise<UploadUserDocumentsCommandResponse>;
}

export class Client implements IClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    get(id: string): Promise<Account> {
        let url_ = this.baseUrl + "/api/Account/Get/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<Account> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Account.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Account>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    post(body: AddAccountRequest | undefined): Promise<Account> {
        let url_ = this.baseUrl + "/api/Account/Post/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<Account> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Account.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Account>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approveAccountHolder(body: ApproveAccountCommandRequest | undefined): Promise<ApproveAccountCommandResponse> {
        let url_ = this.baseUrl + "/api/Account/ApproveAccountHolder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processApproveAccountHolder(_response);
        });
    }

    protected processApproveAccountHolder(response: AxiosResponse): Promise<ApproveAccountCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApproveAccountCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApproveAccountCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAccounts(body: AccountFilterRequest | undefined): Promise<AccountFilterResponse> {
        let url_ = this.baseUrl + "/api/Account/GetAccounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAccounts(_response);
        });
    }

    protected processGetAccounts(response: AxiosResponse): Promise<AccountFilterResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountFilterResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountFilterResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaymentMandates(body: PaymentMandateFilterRequest | undefined): Promise<PaymentMandateFilterResponse> {
        let url_ = this.baseUrl + "/api/Account/GetPaymentMandates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPaymentMandates(_response);
        });
    }

    protected processGetPaymentMandates(response: AxiosResponse): Promise<PaymentMandateFilterResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaymentMandateFilterResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentMandateFilterResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAccountById(body: GetAccountByIdRequest | undefined): Promise<SlimAccount> {
        let url_ = this.baseUrl + "/api/Account/GetAccountById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAccountById(_response);
        });
    }

    protected processGetAccountById(response: AxiosResponse): Promise<SlimAccount> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SlimAccount.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SlimAccount>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getGuestAccount(body: GetGuestAccountByIdRequest | undefined): Promise<SlimAccount> {
        let url_ = this.baseUrl + "/api/Account/GetGuestAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetGuestAccount(_response);
        });
    }

    protected processGetGuestAccount(response: AxiosResponse): Promise<SlimAccount> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SlimAccount.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SlimAccount>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isValidToken(body: TokenValidityQueryRequest | undefined): Promise<TokenValidityQueryResponse> {
        let url_ = this.baseUrl + "/api/Account/IsValidToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processIsValidToken(_response);
        });
    }

    protected processIsValidToken(response: AxiosResponse): Promise<TokenValidityQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TokenValidityQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TokenValidityQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addJcsdAccountDummyMethod(body: WebAccountModel | undefined): Promise<AddJcsdAccountCommandResponse> {
        let url_ = this.baseUrl + "/api/Account/AddJcsdAccountDummyMethod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddJcsdAccountDummyMethod(_response);
        });
    }

    protected processAddJcsdAccountDummyMethod(response: AxiosResponse): Promise<AddJcsdAccountCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddJcsdAccountCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddJcsdAccountCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addJcsdAccount(body: Blob | undefined): Promise<AddJcsdAccountCommandResponse> {
        let url_ = this.baseUrl + "/api/Account/AddJcsdAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "multipart/form-data", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processAddJcsdAccount(_response);
        });
    }

    protected processAddJcsdAccount(response: AxiosResponse): Promise<AddJcsdAccountCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddJcsdAccountCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddJcsdAccountCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editJcsdAccountDummyMethod(body: WebAccountModel | undefined): Promise<EditJcsdAccountCommandResponse> {
        let url_ = this.baseUrl + "/api/Account/EditJcsdAccountDummyMethod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEditJcsdAccountDummyMethod(_response);
        });
    }

    protected processEditJcsdAccountDummyMethod(response: AxiosResponse): Promise<EditJcsdAccountCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditJcsdAccountCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditJcsdAccountCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editJcsdAccount(body: Blob | undefined): Promise<EditJcsdAccountCommandResponse> {
        let url_ = this.baseUrl + "/api/Account/EditJcsdAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "multipart/form-data", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEditJcsdAccount(_response);
        });
    }

    protected processEditJcsdAccount(response: AxiosResponse): Promise<EditJcsdAccountCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditJcsdAccountCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditJcsdAccountCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateAccount(body: Blob | undefined): Promise<ValidateAccountCommandResponse> {
        let url_ = this.baseUrl + "/api/Account/ValidateAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "multipart/form-data", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processValidateAccount(_response);
        });
    }

    protected processValidateAccount(response: AxiosResponse): Promise<ValidateAccountCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidateAccountCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateAccountCommandResponse>(<any>null);
    }

    /**
     * @return Success
     */
    file(id: string): Promise<GetFileByIdQueryResponse> {
        let url_ = this.baseUrl + "/api/File/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFile(_response);
        });
    }

    protected processFile(response: AxiosResponse): Promise<GetFileByIdQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFileByIdQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFileByIdQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getClientApplicationsByFilter(body: GetAllApplicationsByFilterQueryRequest | undefined): Promise<GetAllApplicationsByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/Offering/GetClientApplicationsByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetClientApplicationsByFilter(_response);
        });
    }

    protected processGetClientApplicationsByFilter(response: AxiosResponse): Promise<GetAllApplicationsByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllApplicationsByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllApplicationsByFilterQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifyEligibility(body: VerifyEligibilityModel | undefined): Promise<VerifyEligibilityResponse> {
        let url_ = this.baseUrl + "/api/Offering/VerifyEligibility";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVerifyEligibility(_response);
        });
    }

    protected processVerifyEligibility(response: AxiosResponse): Promise<VerifyEligibilityResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VerifyEligibilityResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VerifyEligibilityResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSharesAvailableForApplication(body: GetSharesAvailableForApplicationQueryRequest | undefined): Promise<GetSharesAvailableForApplicationQueryResponse> {
        let url_ = this.baseUrl + "/api/Offering/GetSharesAvailableForApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetSharesAvailableForApplication(_response);
        });
    }

    protected processGetSharesAvailableForApplication(response: AxiosResponse): Promise<GetSharesAvailableForApplicationQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSharesAvailableForApplicationQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSharesAvailableForApplicationQueryResponse>(<any>null);
    }

    clientApplication(): Promise<void> {
        let url_ = this.baseUrl + "/api/Offering/ClientApplication";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processClientApplication(_response);
        });
    }

    protected processClientApplication(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getOfferingsByFilterForCustomer(body: GetOfferingsByFilterForCustomerQueryRequest | undefined): Promise<GetOfferingsByFilterForCustomerQueryResponse> {
        let url_ = this.baseUrl + "/api/Offering/GetOfferingsByFilterForCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetOfferingsByFilterForCustomer(_response);
        });
    }

    protected processGetOfferingsByFilterForCustomer(response: AxiosResponse): Promise<GetOfferingsByFilterForCustomerQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOfferingsByFilterForCustomerQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOfferingsByFilterForCustomerQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getOfferingsByIdForCustomer(body: GetOfferingsByIdForCustomerQueryRequest | undefined): Promise<GetOfferingsByIdForCustomerQueryResponse> {
        let url_ = this.baseUrl + "/api/Offering/GetOfferingsByIdForCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetOfferingsByIdForCustomer(_response);
        });
    }

    protected processGetOfferingsByIdForCustomer(response: AxiosResponse): Promise<GetOfferingsByIdForCustomerQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOfferingsByIdForCustomerQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOfferingsByIdForCustomerQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getOfferingsViewModelByIdForCustomer(body: GetOfferingsViewModelByIdForCustomerQueryRequest | undefined): Promise<GetOfferingsViewModelByIdForCustomerQueryResponse> {
        let url_ = this.baseUrl + "/api/Offering/GetOfferingsViewModelByIdForCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetOfferingsViewModelByIdForCustomer(_response);
        });
    }

    protected processGetOfferingsViewModelByIdForCustomer(response: AxiosResponse): Promise<GetOfferingsViewModelByIdForCustomerQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetOfferingsViewModelByIdForCustomerQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetOfferingsViewModelByIdForCustomerQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSharePoolsByOfferingId(body: GetSharePoolsByOfferingIdQueryRequest | undefined): Promise<GetSharePoolsByOfferingIdQueryResponse> {
        let url_ = this.baseUrl + "/api/Offering/GetSharePoolsByOfferingId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetSharePoolsByOfferingId(_response);
        });
    }

    protected processGetSharePoolsByOfferingId(response: AxiosResponse): Promise<GetSharePoolsByOfferingIdQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSharePoolsByOfferingIdQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSharePoolsByOfferingIdQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getJointHoldersForAccount(body: GetJointHoldersForAccountRequest | undefined): Promise<GetJointHoldersForAccountResponse> {
        let url_ = this.baseUrl + "/api/Offering/GetJointHoldersForAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetJointHoldersForAccount(_response);
        });
    }

    protected processGetJointHoldersForAccount(response: AxiosResponse): Promise<GetJointHoldersForAccountResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetJointHoldersForAccountResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetJointHoldersForAccountResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getJointHoldersForGuestAccount(body: GetJointHoldersForGuestAccountRequest | undefined): Promise<GetJointHoldersForGuestAccountResponse> {
        let url_ = this.baseUrl + "/api/Offering/GetJointHoldersForGuestAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetJointHoldersForGuestAccount(_response);
        });
    }

    protected processGetJointHoldersForGuestAccount(response: AxiosResponse): Promise<GetJointHoldersForGuestAccountResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetJointHoldersForGuestAccountResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetJointHoldersForGuestAccountResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveOfferingApplication(body: GetSharePoolsByOfferingIdQueryRequest | undefined): Promise<GetSharePoolsByOfferingIdQueryResponse> {
        let url_ = this.baseUrl + "/api/Offering/SaveOfferingApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveOfferingApplication(_response);
        });
    }

    protected processSaveOfferingApplication(response: AxiosResponse): Promise<GetSharePoolsByOfferingIdQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSharePoolsByOfferingIdQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSharePoolsByOfferingIdQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    processSubscriptionDummyMethod(body: WebApplicationModel | undefined): Promise<ProcessSubscriptionCommandResponse> {
        let url_ = this.baseUrl + "/api/Offering/ProcessSubscriptionDummyMethod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processProcessSubscriptionDummyMethod(_response);
        });
    }

    protected processProcessSubscriptionDummyMethod(response: AxiosResponse): Promise<ProcessSubscriptionCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProcessSubscriptionCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessSubscriptionCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    processSubscription(body: Blob | undefined): Promise<ProcessSubscriptionCommandResponse> {
        let url_ = this.baseUrl + "/api/Offering/ProcessSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "multipart/form-data", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processProcessSubscription(_response);
        });
    }

    protected processProcessSubscription(response: AxiosResponse): Promise<ProcessSubscriptionCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProcessSubscriptionCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessSubscriptionCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveDraftApplicationDummyMethod(body: WebApplicationModel | undefined): Promise<ProcessSubscriptionCommandResponse> {
        let url_ = this.baseUrl + "/api/Offering/SaveDraftApplicationDummyMethod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveDraftApplicationDummyMethod(_response);
        });
    }

    protected processSaveDraftApplicationDummyMethod(response: AxiosResponse): Promise<ProcessSubscriptionCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProcessSubscriptionCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessSubscriptionCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resumeGuestApplication(body: ResumeGuestApplicationCommandRequest | undefined): Promise<ResumeGuestApplicationCommandResponse> {
        let url_ = this.baseUrl + "/api/Offering/ResumeGuestApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processResumeGuestApplication(_response);
        });
    }

    protected processResumeGuestApplication(response: AxiosResponse): Promise<ResumeGuestApplicationCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResumeGuestApplicationCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResumeGuestApplicationCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveDraftApplication(body: Blob | undefined): Promise<ProcessSubscriptionCommandResponse> {
        let url_ = this.baseUrl + "/api/Offering/SaveDraftApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "multipart/form-data", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processSaveDraftApplication(_response);
        });
    }

    protected processSaveDraftApplication(response: AxiosResponse): Promise<ProcessSubscriptionCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProcessSubscriptionCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProcessSubscriptionCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editApplication(body: Blob | undefined): Promise<EditApplicationCommandResponse> {
        let url_ = this.baseUrl + "/api/Offering/EditApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "multipart/form-data", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEditApplication(_response);
        });
    }

    protected processEditApplication(response: AxiosResponse): Promise<EditApplicationCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditApplicationCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditApplicationCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelApplication(body: CancelApplicationCommandRequest | undefined): Promise<CancelApplicationCommandResponse> {
        let url_ = this.baseUrl + "/api/Offering/CancelApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCancelApplication(_response);
        });
    }

    protected processCancelApplication(response: AxiosResponse): Promise<CancelApplicationCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CancelApplicationCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CancelApplicationCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getApplicationsByFilterForCustomer(body: GetApplicationsByFilterForCustomerQueryRequest | undefined): Promise<GetApplicationsByFilterForCustomerQueryResponse> {
        let url_ = this.baseUrl + "/api/Offering/GetApplicationsByFilterForCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetApplicationsByFilterForCustomer(_response);
        });
    }

    protected processGetApplicationsByFilterForCustomer(response: AxiosResponse): Promise<GetApplicationsByFilterForCustomerQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetApplicationsByFilterForCustomerQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetApplicationsByFilterForCustomerQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getApplicationByIdForCustomer(body: GetApplicationByIdForCustomerQueryRequest | undefined): Promise<ApplicationViewModel> {
        let url_ = this.baseUrl + "/api/Offering/GetApplicationByIdForCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetApplicationByIdForCustomer(_response);
        });
    }

    protected processGetApplicationByIdForCustomer(response: AxiosResponse): Promise<ApplicationViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApplicationViewModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationViewModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFiservUrl(body: CreateFiservPaymentCommandRequest | undefined): Promise<CreateFiservPaymentCommandResponse> {
        let url_ = this.baseUrl + "/api/Payments/GetFiservUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetFiservUrl(_response);
        });
    }

    protected processGetFiservUrl(response: AxiosResponse): Promise<CreateFiservPaymentCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateFiservPaymentCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateFiservPaymentCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    fiservSuccess(body: Blob | undefined): Promise<GetAllApplicationsByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/Payments/FiservSuccess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "multipart/form-data", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFiservSuccess(_response);
        });
    }

    protected processFiservSuccess(response: AxiosResponse): Promise<GetAllApplicationsByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllApplicationsByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllApplicationsByFilterQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    fiservSuccess2(body: Blob | undefined): Promise<GetAllApplicationsByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/Payments/FiservSuccess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "multipart/form-data", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFiservSuccess2(_response);
        });
    }

    protected processFiservSuccess2(response: AxiosResponse): Promise<GetAllApplicationsByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllApplicationsByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllApplicationsByFilterQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    fiservFailure(body: Blob | undefined): Promise<GetAllApplicationsByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/Payments/FiservFailure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "multipart/form-data", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFiservFailure(_response);
        });
    }

    protected processFiservFailure(response: AxiosResponse): Promise<GetAllApplicationsByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllApplicationsByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllApplicationsByFilterQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    fiservFailure2(body: Blob | undefined): Promise<GetAllApplicationsByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/Payments/FiservFailure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "multipart/form-data", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFiservFailure2(_response);
        });
    }

    protected processFiservFailure2(response: AxiosResponse): Promise<GetAllApplicationsByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllApplicationsByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllApplicationsByFilterQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    fiservSuccessJson(body: FiservSuccessResponseModel | undefined): Promise<GetAllApplicationsByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/Payments/FiservSuccessJson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFiservSuccessJson(_response);
        });
    }

    protected processFiservSuccessJson(response: AxiosResponse): Promise<GetAllApplicationsByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllApplicationsByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllApplicationsByFilterQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    fiservSuccessJson2(body: FiservSuccessResponseModel | undefined): Promise<GetAllApplicationsByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/Payments/FiservSuccessJson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFiservSuccessJson2(_response);
        });
    }

    protected processFiservSuccessJson2(response: AxiosResponse): Promise<GetAllApplicationsByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllApplicationsByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllApplicationsByFilterQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    fiservFailureJson(body: FiservFailureResponseModel | undefined): Promise<GetAllApplicationsByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/Payments/FiservFailureJson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFiservFailureJson(_response);
        });
    }

    protected processFiservFailureJson(response: AxiosResponse): Promise<GetAllApplicationsByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllApplicationsByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllApplicationsByFilterQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    fiservFailureJson2(body: FiservFailureResponseModel | undefined): Promise<GetAllApplicationsByFilterQueryResponse> {
        let url_ = this.baseUrl + "/api/Payments/FiservFailureJson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFiservFailureJson2(_response);
        });
    }

    protected processFiservFailureJson2(response: AxiosResponse): Promise<GetAllApplicationsByFilterQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllApplicationsByFilterQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllApplicationsByFilterQueryResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getAllReports(): Promise<GetAllReportsQueryResponse> {
        let url_ = this.baseUrl + "/api/Report/GetAllReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetAllReports(_response);
        });
    }

    protected processGetAllReports(response: AxiosResponse): Promise<GetAllReportsQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetAllReportsQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetAllReportsQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getReportById(body: GetReportByQueryRequest | undefined): Promise<GetReportByQueryResponse> {
        let url_ = this.baseUrl + "/api/Report/GetReportById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetReportById(_response);
        });
    }

    protected processGetReportById(response: AxiosResponse): Promise<GetReportByQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetReportByQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetReportByQueryResponse>(<any>null);
    }

    /**
     * @return Success
     */
    logout(): Promise<void> {
        let url_ = this.baseUrl + "/api/Security/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    login(body: LoginCommandRequest | undefined): Promise<LoginCommandResponse> {
        let url_ = this.baseUrl + "/api/Security/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<LoginCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoginCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoginCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifyLogin(body: VerifyLoginCommandRequest | undefined): Promise<VerifyLoginCommandResponse> {
        let url_ = this.baseUrl + "/api/Security/VerifyLogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processVerifyLogin(_response);
        });
    }

    protected processVerifyLogin(response: AxiosResponse): Promise<VerifyLoginCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VerifyLoginCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VerifyLoginCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterUserCommandRequest | undefined): Promise<RegisterUserCommandResponse> {
        let url_ = this.baseUrl + "/api/Security/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<RegisterUserCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegisterUserCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegisterUserCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerGuest(body: RegisterGuestCommandRequest | undefined): Promise<RegisterGuestCommandResponse> {
        let url_ = this.baseUrl + "/api/Security/RegisterGuest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRegisterGuest(_response);
        });
    }

    protected processRegisterGuest(response: AxiosResponse): Promise<RegisterGuestCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegisterGuestCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegisterGuestCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validateGuestOTP(body: ValidateGuestOTPCommandRequest | undefined): Promise<LoginResponseModel> {
        let url_ = this.baseUrl + "/api/Security/ValidateGuestOTP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processValidateGuestOTP(_response);
        });
    }

    protected processValidateGuestOTP(response: AxiosResponse): Promise<LoginResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LoginResponseModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LoginResponseModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resendOTP(body: ResendOTPCommandRequest | undefined): Promise<ResendOTPCommandResponse> {
        let url_ = this.baseUrl + "/api/Security/ResendOTP";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processResendOTP(_response);
        });
    }

    protected processResendOTP(response: AxiosResponse): Promise<ResendOTPCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResendOTPCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResendOTPCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    confirmRegistration(body: ConfirmRegistrationCommandRequest | undefined): Promise<ConfirmRegistrationCommandResponse> {
        let url_ = this.baseUrl + "/api/Security/ConfirmRegistration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processConfirmRegistration(_response);
        });
    }

    protected processConfirmRegistration(response: AxiosResponse): Promise<ConfirmRegistrationCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConfirmRegistrationCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfirmRegistrationCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    ressetPassword(body: ResetPasswordCommandRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Security/RessetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRessetPassword(_response);
        });
    }

    protected processRessetPassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSecurityQuestions(body: GetSecurityQuestionsQueryRequest | undefined): Promise<GetSecurityQuestionsQueryResponse> {
        let url_ = this.baseUrl + "/api/Security/GetSecurityQuestions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetSecurityQuestions(_response);
        });
    }

    protected processGetSecurityQuestions(response: AxiosResponse): Promise<GetSecurityQuestionsQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetSecurityQuestionsQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetSecurityQuestionsQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSecurityQuestions(body: UpdateSecurityQuestionsCommandRequest | undefined): Promise<UpdateSecurityQuestionsCommandResponse> {
        let url_ = this.baseUrl + "/api/Security/UpdateSecurityQuestions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdateSecurityQuestions(_response);
        });
    }

    protected processUpdateSecurityQuestions(response: AxiosResponse): Promise<UpdateSecurityQuestionsCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpdateSecurityQuestionsCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpdateSecurityQuestionsCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFilteredCountries(body: CountryFilterRequest | undefined): Promise<CountryFilterResponse> {
        let url_ = this.baseUrl + "/api/Shared/GetFilteredCountries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetFilteredCountries(_response);
        });
    }

    protected processGetFilteredCountries(response: AxiosResponse): Promise<CountryFilterResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CountryFilterResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CountryFilterResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaymentMethodDescription(body: GetPaymentMethodDescriptionCommandRequest | undefined): Promise<GetPaymentMethodDescriptionCommandResponse> {
        let url_ = this.baseUrl + "/api/Shared/GetPaymentMethodDescription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetPaymentMethodDescription(_response);
        });
    }

    protected processGetPaymentMethodDescription(response: AxiosResponse): Promise<GetPaymentMethodDescriptionCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPaymentMethodDescriptionCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPaymentMethodDescriptionCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBrokers(body: BrokerFilterRequest | undefined): Promise<BrokerFilterResponse> {
        let url_ = this.baseUrl + "/api/Shared/GetBrokers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetBrokers(_response);
        });
    }

    protected processGetBrokers(response: AxiosResponse): Promise<BrokerFilterResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BrokerFilterResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BrokerFilterResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBanks(body: BankFilterRequest | undefined): Promise<BankFilterResponse> {
        let url_ = this.baseUrl + "/api/Shared/GetBanks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetBanks(_response);
        });
    }

    protected processGetBanks(response: AxiosResponse): Promise<BankFilterResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BankFilterResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BankFilterResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    requestPasswordReset(body: RequestPasswordResetCommandRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserProfile/RequestPasswordReset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processRequestPasswordReset(_response);
        });
    }

    protected processRequestPasswordReset(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resendActivationEmail(body: ResendActivationEmailCommandRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserProfile/ResendActivationEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processResendActivationEmail(_response);
        });
    }

    protected processResendActivationEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordCommandRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserProfile/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordCommandRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserProfile/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMyUserProfile(body: GetMyUserProfileQueryRequest | undefined): Promise<GetMyUserProfileQueryResponse> {
        let url_ = this.baseUrl + "/api/UserProfile/GetMyUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetMyUserProfile(_response);
        });
    }

    protected processGetMyUserProfile(response: AxiosResponse): Promise<GetMyUserProfileQueryResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetMyUserProfileQueryResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetMyUserProfileQueryResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editMyUserProfile(body: UserEditOwnProfileCommandRequest | undefined): Promise<UserEditOwnProfileCommandResponse> {
        let url_ = this.baseUrl + "/api/UserProfile/EditMyUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processEditMyUserProfile(_response);
        });
    }

    protected processEditMyUserProfile(response: AxiosResponse): Promise<UserEditOwnProfileCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserEditOwnProfileCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserEditOwnProfileCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadUserDocuments(body: Blob | undefined): Promise<UploadUserDocumentsCommandResponse> {
        let url_ = this.baseUrl + "/api/UserProfile/UploadUserDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "multipart/form-data", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUploadUserDocuments(_response);
        });
    }

    protected processUploadUserDocuments(response: AxiosResponse): Promise<UploadUserDocumentsCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UploadUserDocumentsCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadUserDocumentsCommandResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadUserDocumentsDummyMethod(body: ClientDocumentViewModel | undefined): Promise<UploadUserDocumentsCommandResponse> {
        let url_ = this.baseUrl + "/api/UserProfile/UploadUserDocumentsDummyMethod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUploadUserDocumentsDummyMethod(_response);
        });
    }

    protected processUploadUserDocumentsDummyMethod(response: AxiosResponse): Promise<UploadUserDocumentsCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UploadUserDocumentsCommandResponse.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadUserDocumentsCommandResponse>(<any>null);
    }
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data; 
    }

    clone(): ProblemDetails {
        const json = this.toJSON();
        let result = new ProblemDetails();
        result.init(json);
        return result;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
}

export enum AccountType {
    Personal = "Personal",
    Business = "Business",
}

export class Broker implements IBroker {
    name?: string | undefined;
    brokerCode?: string | undefined;
    shortName?: string | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IBroker) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.brokerCode = _data["brokerCode"];
            this.shortName = _data["shortName"];
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): Broker {
        data = typeof data === 'object' ? data : {};
        let result = new Broker();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["brokerCode"] = this.brokerCode;
        data["shortName"] = this.shortName;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): Broker {
        const json = this.toJSON();
        let result = new Broker();
        result.init(json);
        return result;
    }
}

export interface IBroker {
    name?: string | undefined;
    brokerCode?: string | undefined;
    shortName?: string | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export enum UserStatus {
    Disabled = "Disabled",
    Active = "Active",
}

export enum ClientType {
    Individual = "Individual",
    Company = "Company",
    GuestIndividual = "GuestIndividual",
    GuestCompany = "GuestCompany",
}

export enum RoleStatus {
    Disabled = "Disabled",
    Active = "Active",
}

export class Role implements IRole {
    description?: string | undefined;
    status?: RoleStatus;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    userRoles?: UserRole[] | undefined;
    id?: string;
    name?: string | undefined;
    normalizedName?: string | undefined;
    concurrencyStamp?: string | undefined;

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.userRoles) {
                this.userRoles = [];
                for (let i = 0; i < data.userRoles.length; i++) {
                    let item = data.userRoles[i];
                    this.userRoles[i] = item && !(<any>item).toJSON ? new UserRole(item) : <UserRole>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.status = _data["status"];
            this.createdBy = _data["createdBy"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(UserRole.fromJS(item));
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.normalizedName = _data["normalizedName"];
            this.concurrencyStamp = _data["concurrencyStamp"];
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["status"] = this.status;
        data["createdBy"] = this.createdBy;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["normalizedName"] = this.normalizedName;
        data["concurrencyStamp"] = this.concurrencyStamp;
        return data; 
    }

    clone(): Role {
        const json = this.toJSON();
        let result = new Role();
        result.init(json);
        return result;
    }
}

export interface IRole {
    description?: string | undefined;
    status?: RoleStatus;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
    userRoles?: IUserRole[] | undefined;
    id?: string;
    name?: string | undefined;
    normalizedName?: string | undefined;
    concurrencyStamp?: string | undefined;
}

export class UserRole implements IUserRole {
    userId?: string;
    user?: User | undefined;
    roleId?: string;
    role?: Role | undefined;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user; 
            this.role = data.role && !(<any>data.role).toJSON ? new Role(data.role) : <Role>this.role; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.roleId = _data["roleId"];
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["roleId"] = this.roleId;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        return data; 
    }

    clone(): UserRole {
        const json = this.toJSON();
        let result = new UserRole();
        result.init(json);
        return result;
    }
}

export interface IUserRole {
    userId?: string;
    user?: IUser | undefined;
    roleId?: string;
    role?: IRole | undefined;
}

export class SecurityQuestion implements ISecurityQuestion {
    question?: string | undefined;
    answer?: string | undefined;
    clientId?: string;
    clientInfo?: ClientInfo | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: ISecurityQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.clientInfo = data.clientInfo && !(<any>data.clientInfo).toJSON ? new ClientInfo(data.clientInfo) : <ClientInfo>this.clientInfo; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.question = _data["question"];
            this.answer = _data["answer"];
            this.clientId = _data["clientId"];
            this.clientInfo = _data["clientInfo"] ? ClientInfo.fromJS(_data["clientInfo"]) : <any>undefined;
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): SecurityQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question;
        data["answer"] = this.answer;
        data["clientId"] = this.clientId;
        data["clientInfo"] = this.clientInfo ? this.clientInfo.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): SecurityQuestion {
        const json = this.toJSON();
        let result = new SecurityQuestion();
        result.init(json);
        return result;
    }
}

export interface ISecurityQuestion {
    question?: string | undefined;
    answer?: string | undefined;
    clientId?: string;
    clientInfo?: IClientInfo | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export enum ClientDocumentType {
    ProofOfIdentity = "ProofOfIdentity",
    ProofOfAddress = "ProofOfAddress",
    ProofOfBankAccount = "ProofOfBankAccount",
    ProofOfChange = "ProofOfChange",
    TaxIdentification = "TaxIdentification",
    CorporateDocuments = "CorporateDocuments",
    PowerOfAttorney = "PowerOfAttorney",
    LegalAuthorization = "LegalAuthorization",
    InvestmentMandate = "InvestmentMandate",
    Other = "Other",
}

export class DataFile implements IDataFile {
    fileId?: string | undefined;
    name?: string | undefined;
    extension?: string | undefined;
    mimeType?: string | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IDataFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.mimeType = _data["mimeType"];
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): DataFile {
        data = typeof data === 'object' ? data : {};
        let result = new DataFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["mimeType"] = this.mimeType;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): DataFile {
        const json = this.toJSON();
        let result = new DataFile();
        result.init(json);
        return result;
    }
}

export interface IDataFile {
    fileId?: string | undefined;
    name?: string | undefined;
    extension?: string | undefined;
    mimeType?: string | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class ClientDocument implements IClientDocument {
    documentType?: ClientDocumentType;
    expiryDate?: string | undefined;
    isActive?: boolean;
    clientInfoId?: string;
    clientInfo?: ClientInfo | undefined;
    userId?: string;
    user?: User | undefined;
    documentId?: string | undefined;
    document?: DataFile | undefined;
    comments?: string | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IClientDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.clientInfo = data.clientInfo && !(<any>data.clientInfo).toJSON ? new ClientInfo(data.clientInfo) : <ClientInfo>this.clientInfo; 
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user; 
            this.document = data.document && !(<any>data.document).toJSON ? new DataFile(data.document) : <DataFile>this.document; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentType = _data["documentType"];
            this.expiryDate = _data["expiryDate"];
            this.isActive = _data["isActive"];
            this.clientInfoId = _data["clientInfoId"];
            this.clientInfo = _data["clientInfo"] ? ClientInfo.fromJS(_data["clientInfo"]) : <any>undefined;
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.documentId = _data["documentId"];
            this.document = _data["document"] ? DataFile.fromJS(_data["document"]) : <any>undefined;
            this.comments = _data["comments"];
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): ClientDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["expiryDate"] = this.expiryDate;
        data["isActive"] = this.isActive;
        data["clientInfoId"] = this.clientInfoId;
        data["clientInfo"] = this.clientInfo ? this.clientInfo.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["documentId"] = this.documentId;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["comments"] = this.comments;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): ClientDocument {
        const json = this.toJSON();
        let result = new ClientDocument();
        result.init(json);
        return result;
    }
}

export interface IClientDocument {
    documentType?: ClientDocumentType;
    expiryDate?: string | undefined;
    isActive?: boolean;
    clientInfoId?: string;
    clientInfo?: IClientInfo | undefined;
    userId?: string;
    user?: IUser | undefined;
    documentId?: string | undefined;
    document?: IDataFile | undefined;
    comments?: string | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class ClientInfo implements IClientInfo {
    userId?: string;
    user?: User | undefined;
    idType?: string | undefined;
    idNumber?: string | undefined;
    contactFirstName?: string | undefined;
    contactLastName?: string | undefined;
    trn?: string | undefined;
    dateOfBirth?: string | undefined;
    securityQuestions?: SecurityQuestion[] | undefined;
    clientDocuments?: ClientDocument[] | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IClientInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user; 
            if (data.securityQuestions) {
                this.securityQuestions = [];
                for (let i = 0; i < data.securityQuestions.length; i++) {
                    let item = data.securityQuestions[i];
                    this.securityQuestions[i] = item && !(<any>item).toJSON ? new SecurityQuestion(item) : <SecurityQuestion>item;
                }
            }
            if (data.clientDocuments) {
                this.clientDocuments = [];
                for (let i = 0; i < data.clientDocuments.length; i++) {
                    let item = data.clientDocuments[i];
                    this.clientDocuments[i] = item && !(<any>item).toJSON ? new ClientDocument(item) : <ClientDocument>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.idType = _data["idType"];
            this.idNumber = _data["idNumber"];
            this.contactFirstName = _data["contactFirstName"];
            this.contactLastName = _data["contactLastName"];
            this.trn = _data["trn"];
            this.dateOfBirth = _data["dateOfBirth"];
            if (Array.isArray(_data["securityQuestions"])) {
                this.securityQuestions = [] as any;
                for (let item of _data["securityQuestions"])
                    this.securityQuestions!.push(SecurityQuestion.fromJS(item));
            }
            if (Array.isArray(_data["clientDocuments"])) {
                this.clientDocuments = [] as any;
                for (let item of _data["clientDocuments"])
                    this.clientDocuments!.push(ClientDocument.fromJS(item));
            }
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): ClientInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ClientInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["idType"] = this.idType;
        data["idNumber"] = this.idNumber;
        data["contactFirstName"] = this.contactFirstName;
        data["contactLastName"] = this.contactLastName;
        data["trn"] = this.trn;
        data["dateOfBirth"] = this.dateOfBirth;
        if (Array.isArray(this.securityQuestions)) {
            data["securityQuestions"] = [];
            for (let item of this.securityQuestions)
                data["securityQuestions"].push(item.toJSON());
        }
        if (Array.isArray(this.clientDocuments)) {
            data["clientDocuments"] = [];
            for (let item of this.clientDocuments)
                data["clientDocuments"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): ClientInfo {
        const json = this.toJSON();
        let result = new ClientInfo();
        result.init(json);
        return result;
    }
}

export interface IClientInfo {
    userId?: string;
    user?: IUser | undefined;
    idType?: string | undefined;
    idNumber?: string | undefined;
    contactFirstName?: string | undefined;
    contactLastName?: string | undefined;
    trn?: string | undefined;
    dateOfBirth?: string | undefined;
    securityQuestions?: ISecurityQuestion[] | undefined;
    clientDocuments?: IClientDocument[] | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class User implements IUser {
    firstName?: string | undefined;
    lastName?: string | undefined;
    status?: UserStatus;
    clientSideConfig?: string | undefined;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    clientType?: ClientType;
    rowVersion?: string | undefined;
    userRoles?: UserRole[] | undefined;
    clientInfo?: ClientInfo | undefined;
    otp?: string | undefined;
    otpExpiry?: string | undefined;
    id?: string;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: string | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.userRoles) {
                this.userRoles = [];
                for (let i = 0; i < data.userRoles.length; i++) {
                    let item = data.userRoles[i];
                    this.userRoles[i] = item && !(<any>item).toJSON ? new UserRole(item) : <UserRole>item;
                }
            }
            this.clientInfo = data.clientInfo && !(<any>data.clientInfo).toJSON ? new ClientInfo(data.clientInfo) : <ClientInfo>this.clientInfo; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.status = _data["status"];
            this.clientSideConfig = _data["clientSideConfig"];
            this.createdBy = _data["createdBy"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modificationDate = _data["modificationDate"];
            this.clientType = _data["clientType"];
            this.rowVersion = _data["rowVersion"];
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(UserRole.fromJS(item));
            }
            this.clientInfo = _data["clientInfo"] ? ClientInfo.fromJS(_data["clientInfo"]) : <any>undefined;
            this.otp = _data["otp"];
            this.otpExpiry = _data["otpExpiry"];
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.email = _data["email"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.passwordHash = _data["passwordHash"];
            this.securityStamp = _data["securityStamp"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"];
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["status"] = this.status;
        data["clientSideConfig"] = this.clientSideConfig;
        data["createdBy"] = this.createdBy;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modificationDate"] = this.modificationDate;
        data["clientType"] = this.clientType;
        data["rowVersion"] = this.rowVersion;
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item.toJSON());
        }
        data["clientInfo"] = this.clientInfo ? this.clientInfo.toJSON() : <any>undefined;
        data["otp"] = this.otp;
        data["otpExpiry"] = this.otpExpiry;
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        return data; 
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    firstName?: string | undefined;
    lastName?: string | undefined;
    status?: UserStatus;
    clientSideConfig?: string | undefined;
    createdBy?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modificationDate?: string | undefined;
    clientType?: ClientType;
    rowVersion?: string | undefined;
    userRoles?: IUserRole[] | undefined;
    clientInfo?: IClientInfo | undefined;
    otp?: string | undefined;
    otpExpiry?: string | undefined;
    id?: string;
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    email?: string | undefined;
    normalizedEmail?: string | undefined;
    emailConfirmed?: boolean;
    passwordHash?: string | undefined;
    securityStamp?: string | undefined;
    concurrencyStamp?: string | undefined;
    phoneNumber?: string | undefined;
    phoneNumberConfirmed?: boolean;
    twoFactorEnabled?: boolean;
    lockoutEnd?: string | undefined;
    lockoutEnabled?: boolean;
    accessFailedCount?: number;
}

export enum AccountHolderType {
    Person = "Person",
    Business = "Business",
}

export enum AccountHolderStatus {
    PendingAuthorization = "PendingAuthorization",
    Authorized = "Authorized",
    Disabled = "Disabled",
}

export class AccountHolder implements IAccountHolder {
    firstName?: string | undefined;
    lastName?: string | undefined;
    trn?: string | undefined;
    birthday?: string | undefined;
    accountHolderType?: AccountHolderType;
    isVMBSClient?: boolean;
    isPrimaryHolder?: boolean;
    accountId?: string;
    account?: Account | undefined;
    primaryAccountId?: string | undefined;
    primaryAccount?: Account | undefined;
    status?: AccountHolderStatus;
    email?: string | undefined;
    token?: string | undefined;
    tokenExpirationDate?: string;
    readonly fullName?: string | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IAccountHolder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.account = data.account && !(<any>data.account).toJSON ? new Account(data.account) : <Account>this.account; 
            this.primaryAccount = data.primaryAccount && !(<any>data.primaryAccount).toJSON ? new Account(data.primaryAccount) : <Account>this.primaryAccount; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.trn = _data["trn"];
            this.birthday = _data["birthday"];
            this.accountHolderType = _data["accountHolderType"];
            this.isVMBSClient = _data["isVMBSClient"];
            this.isPrimaryHolder = _data["isPrimaryHolder"];
            this.accountId = _data["accountId"];
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : <any>undefined;
            this.primaryAccountId = _data["primaryAccountId"];
            this.primaryAccount = _data["primaryAccount"] ? Account.fromJS(_data["primaryAccount"]) : <any>undefined;
            this.status = _data["status"];
            this.email = _data["email"];
            this.token = _data["token"];
            this.tokenExpirationDate = _data["tokenExpirationDate"];
            (<any>this).fullName = _data["fullName"];
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): AccountHolder {
        data = typeof data === 'object' ? data : {};
        let result = new AccountHolder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["trn"] = this.trn;
        data["birthday"] = this.birthday;
        data["accountHolderType"] = this.accountHolderType;
        data["isVMBSClient"] = this.isVMBSClient;
        data["isPrimaryHolder"] = this.isPrimaryHolder;
        data["accountId"] = this.accountId;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["primaryAccountId"] = this.primaryAccountId;
        data["primaryAccount"] = this.primaryAccount ? this.primaryAccount.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["email"] = this.email;
        data["token"] = this.token;
        data["tokenExpirationDate"] = this.tokenExpirationDate;
        data["fullName"] = this.fullName;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): AccountHolder {
        const json = this.toJSON();
        let result = new AccountHolder();
        result.init(json);
        return result;
    }
}

export interface IAccountHolder {
    firstName?: string | undefined;
    lastName?: string | undefined;
    trn?: string | undefined;
    birthday?: string | undefined;
    accountHolderType?: AccountHolderType;
    isVMBSClient?: boolean;
    isPrimaryHolder?: boolean;
    accountId?: string;
    account?: IAccount | undefined;
    primaryAccountId?: string | undefined;
    primaryAccount?: IAccount | undefined;
    status?: AccountHolderStatus;
    email?: string | undefined;
    token?: string | undefined;
    tokenExpirationDate?: string;
    fullName?: string | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class AccountVirtualNumber implements IAccountVirtualNumber {
    accountId?: string;
    account?: Account | undefined;
    currency?: string | undefined;
    virtualAccountNumber?: string | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IAccountVirtualNumber) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.account = data.account && !(<any>data.account).toJSON ? new Account(data.account) : <Account>this.account; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : <any>undefined;
            this.currency = _data["currency"];
            this.virtualAccountNumber = _data["virtualAccountNumber"];
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): AccountVirtualNumber {
        data = typeof data === 'object' ? data : {};
        let result = new AccountVirtualNumber();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["currency"] = this.currency;
        data["virtualAccountNumber"] = this.virtualAccountNumber;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): AccountVirtualNumber {
        const json = this.toJSON();
        let result = new AccountVirtualNumber();
        result.init(json);
        return result;
    }
}

export interface IAccountVirtualNumber {
    accountId?: string;
    account?: IAccount | undefined;
    currency?: string | undefined;
    virtualAccountNumber?: string | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export enum AccountStatus {
    Pending = "Pending",
    Rejected = "Rejected",
    Suspended = "Suspended",
    Active = "Active",
}

export class Account implements IAccount {
    name?: string | undefined;
    jcsdNumber?: string | undefined;
    accountType?: AccountType;
    brokerId?: string;
    broker?: Broker | undefined;
    primaryAccountHolderId?: string;
    userId?: string | undefined;
    user?: User | undefined;
    accountHolders?: AccountHolder[] | undefined;
    accountVirtualNumbers?: AccountVirtualNumber[] | undefined;
    status?: AccountStatus;
    idCardId?: string | undefined;
    idCard?: DataFile | undefined;
    readonly primaryAccountHolder?: AccountHolder | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.broker = data.broker && !(<any>data.broker).toJSON ? new Broker(data.broker) : <Broker>this.broker; 
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user; 
            if (data.accountHolders) {
                this.accountHolders = [];
                for (let i = 0; i < data.accountHolders.length; i++) {
                    let item = data.accountHolders[i];
                    this.accountHolders[i] = item && !(<any>item).toJSON ? new AccountHolder(item) : <AccountHolder>item;
                }
            }
            if (data.accountVirtualNumbers) {
                this.accountVirtualNumbers = [];
                for (let i = 0; i < data.accountVirtualNumbers.length; i++) {
                    let item = data.accountVirtualNumbers[i];
                    this.accountVirtualNumbers[i] = item && !(<any>item).toJSON ? new AccountVirtualNumber(item) : <AccountVirtualNumber>item;
                }
            }
            this.idCard = data.idCard && !(<any>data.idCard).toJSON ? new DataFile(data.idCard) : <DataFile>this.idCard; 
            this.primaryAccountHolder = data.primaryAccountHolder && !(<any>data.primaryAccountHolder).toJSON ? new AccountHolder(data.primaryAccountHolder) : <AccountHolder>this.primaryAccountHolder; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.jcsdNumber = _data["jcsdNumber"];
            this.accountType = _data["accountType"];
            this.brokerId = _data["brokerId"];
            this.broker = _data["broker"] ? Broker.fromJS(_data["broker"]) : <any>undefined;
            this.primaryAccountHolderId = _data["primaryAccountHolderId"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["accountHolders"])) {
                this.accountHolders = [] as any;
                for (let item of _data["accountHolders"])
                    this.accountHolders!.push(AccountHolder.fromJS(item));
            }
            if (Array.isArray(_data["accountVirtualNumbers"])) {
                this.accountVirtualNumbers = [] as any;
                for (let item of _data["accountVirtualNumbers"])
                    this.accountVirtualNumbers!.push(AccountVirtualNumber.fromJS(item));
            }
            this.status = _data["status"];
            this.idCardId = _data["idCardId"];
            this.idCard = _data["idCard"] ? DataFile.fromJS(_data["idCard"]) : <any>undefined;
            (<any>this).primaryAccountHolder = _data["primaryAccountHolder"] ? AccountHolder.fromJS(_data["primaryAccountHolder"]) : <any>undefined;
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): Account {
        data = typeof data === 'object' ? data : {};
        let result = new Account();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["jcsdNumber"] = this.jcsdNumber;
        data["accountType"] = this.accountType;
        data["brokerId"] = this.brokerId;
        data["broker"] = this.broker ? this.broker.toJSON() : <any>undefined;
        data["primaryAccountHolderId"] = this.primaryAccountHolderId;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.accountHolders)) {
            data["accountHolders"] = [];
            for (let item of this.accountHolders)
                data["accountHolders"].push(item.toJSON());
        }
        if (Array.isArray(this.accountVirtualNumbers)) {
            data["accountVirtualNumbers"] = [];
            for (let item of this.accountVirtualNumbers)
                data["accountVirtualNumbers"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["idCardId"] = this.idCardId;
        data["idCard"] = this.idCard ? this.idCard.toJSON() : <any>undefined;
        data["primaryAccountHolder"] = this.primaryAccountHolder ? this.primaryAccountHolder.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): Account {
        const json = this.toJSON();
        let result = new Account();
        result.init(json);
        return result;
    }
}

export interface IAccount {
    name?: string | undefined;
    jcsdNumber?: string | undefined;
    accountType?: AccountType;
    brokerId?: string;
    broker?: IBroker | undefined;
    primaryAccountHolderId?: string;
    userId?: string | undefined;
    user?: IUser | undefined;
    accountHolders?: IAccountHolder[] | undefined;
    accountVirtualNumbers?: IAccountVirtualNumber[] | undefined;
    status?: AccountStatus;
    idCardId?: string | undefined;
    idCard?: IDataFile | undefined;
    primaryAccountHolder?: IAccountHolder | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class AddAccountRequest implements IAddAccountRequest {
    name?: string | undefined;
    jsdNumber?: string | undefined;
    accountType?: AccountType;
    brokerId?: string;
    primaryAccountHolder?: AccountHolder | undefined;
    jointAccountHolders?: AccountHolder[] | undefined;

    constructor(data?: IAddAccountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.primaryAccountHolder = data.primaryAccountHolder && !(<any>data.primaryAccountHolder).toJSON ? new AccountHolder(data.primaryAccountHolder) : <AccountHolder>this.primaryAccountHolder; 
            if (data.jointAccountHolders) {
                this.jointAccountHolders = [];
                for (let i = 0; i < data.jointAccountHolders.length; i++) {
                    let item = data.jointAccountHolders[i];
                    this.jointAccountHolders[i] = item && !(<any>item).toJSON ? new AccountHolder(item) : <AccountHolder>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.jsdNumber = _data["jsdNumber"];
            this.accountType = _data["accountType"];
            this.brokerId = _data["brokerId"];
            this.primaryAccountHolder = _data["primaryAccountHolder"] ? AccountHolder.fromJS(_data["primaryAccountHolder"]) : <any>undefined;
            if (Array.isArray(_data["jointAccountHolders"])) {
                this.jointAccountHolders = [] as any;
                for (let item of _data["jointAccountHolders"])
                    this.jointAccountHolders!.push(AccountHolder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["jsdNumber"] = this.jsdNumber;
        data["accountType"] = this.accountType;
        data["brokerId"] = this.brokerId;
        data["primaryAccountHolder"] = this.primaryAccountHolder ? this.primaryAccountHolder.toJSON() : <any>undefined;
        if (Array.isArray(this.jointAccountHolders)) {
            data["jointAccountHolders"] = [];
            for (let item of this.jointAccountHolders)
                data["jointAccountHolders"].push(item.toJSON());
        }
        return data; 
    }

    clone(): AddAccountRequest {
        const json = this.toJSON();
        let result = new AddAccountRequest();
        result.init(json);
        return result;
    }
}

export interface IAddAccountRequest {
    name?: string | undefined;
    jsdNumber?: string | undefined;
    accountType?: AccountType;
    brokerId?: string;
    primaryAccountHolder?: IAccountHolder | undefined;
    jointAccountHolders?: IAccountHolder[] | undefined;
}

export class ApproveAccountCommandRequest implements IApproveAccountCommandRequest {
    linkedToken?: string | undefined;
    trn?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: IApproveAccountCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linkedToken = _data["linkedToken"];
            this.trn = _data["trn"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): ApproveAccountCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveAccountCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkedToken"] = this.linkedToken;
        data["trn"] = this.trn;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data; 
    }

    clone(): ApproveAccountCommandRequest {
        const json = this.toJSON();
        let result = new ApproveAccountCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IApproveAccountCommandRequest {
    linkedToken?: string | undefined;
    trn?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class ApproveAccountCommandResponse implements IApproveAccountCommandResponse {
    isApproved?: boolean;

    constructor(data?: IApproveAccountCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isApproved = _data["isApproved"];
        }
    }

    static fromJS(data: any): ApproveAccountCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveAccountCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isApproved"] = this.isApproved;
        return data; 
    }

    clone(): ApproveAccountCommandResponse {
        const json = this.toJSON();
        let result = new ApproveAccountCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IApproveAccountCommandResponse {
    isApproved?: boolean;
}

export enum FilterType {
    Contains = "Contains",
    GreaterThan = "GreaterThan",
    GreaterThanOrEqualTo = "GreaterThanOrEqualTo",
    LessThan = "LessThan",
    LessThanOrEqualTo = "LessThanOrEqualTo",
    Equal = "Equal",
    Group = "Group",
}

export enum JoinType {
    And = "and",
    Or = "or",
}

export class Filter implements IFilter {
    field?: string | undefined;
    filterType?: FilterType;
    value?: string | undefined;
    joinType?: JoinType;
    groupFilters?: Filter[] | undefined;

    constructor(data?: IFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.groupFilters) {
                this.groupFilters = [];
                for (let i = 0; i < data.groupFilters.length; i++) {
                    let item = data.groupFilters[i];
                    this.groupFilters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.filterType = _data["filterType"];
            this.value = _data["value"];
            this.joinType = _data["joinType"];
            if (Array.isArray(_data["groupFilters"])) {
                this.groupFilters = [] as any;
                for (let item of _data["groupFilters"])
                    this.groupFilters!.push(Filter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Filter {
        data = typeof data === 'object' ? data : {};
        let result = new Filter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["filterType"] = this.filterType;
        data["value"] = this.value;
        data["joinType"] = this.joinType;
        if (Array.isArray(this.groupFilters)) {
            data["groupFilters"] = [];
            for (let item of this.groupFilters)
                data["groupFilters"].push(item.toJSON());
        }
        return data; 
    }

    clone(): Filter {
        const json = this.toJSON();
        let result = new Filter();
        result.init(json);
        return result;
    }
}

export interface IFilter {
    field?: string | undefined;
    filterType?: FilterType;
    value?: string | undefined;
    joinType?: JoinType;
    groupFilters?: IFilter[] | undefined;
}

export class OrderBy implements IOrderBy {
    field?: string | undefined;
    ascending?: boolean;

    constructor(data?: IOrderBy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.ascending = _data["ascending"];
        }
    }

    static fromJS(data: any): OrderBy {
        data = typeof data === 'object' ? data : {};
        let result = new OrderBy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["ascending"] = this.ascending;
        return data; 
    }

    clone(): OrderBy {
        const json = this.toJSON();
        let result = new OrderBy();
        result.init(json);
        return result;
    }
}

export interface IOrderBy {
    field?: string | undefined;
    ascending?: boolean;
}

export class AccountFilterRequest implements IAccountFilterRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IAccountFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccountFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): AccountFilterRequest {
        const json = this.toJSON();
        let result = new AccountFilterRequest();
        result.init(json);
        return result;
    }
}

export interface IAccountFilterRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class AccountFilterResponse implements IAccountFilterResponse {
    results?: Account[] | undefined;
    count?: number;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IAccountFilterResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new Account(item) : <Account>item;
                }
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(Account.fromJS(item));
            }
            this.count = _data["count"];
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountFilterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccountFilterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): AccountFilterResponse {
        const json = this.toJSON();
        let result = new AccountFilterResponse();
        result.init(json);
        return result;
    }
}

export interface IAccountFilterResponse {
    results?: IAccount[] | undefined;
    count?: number;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class PaymentMandateFilterRequest implements IPaymentMandateFilterRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IPaymentMandateFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaymentMandateFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMandateFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PaymentMandateFilterRequest {
        const json = this.toJSON();
        let result = new PaymentMandateFilterRequest();
        result.init(json);
        return result;
    }
}

export interface IPaymentMandateFilterRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class PaymentMandate implements IPaymentMandate {
    bank?: string | undefined;
    branch?: string | undefined;
    accountType?: string | undefined;
    currency?: string | undefined;
    nameOnAccount?: string | undefined;
    accountNumber?: string | undefined;
    accountNickname?: string | undefined;
    userId?: string;
    user?: User | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IPaymentMandate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bank = _data["bank"];
            this.branch = _data["branch"];
            this.accountType = _data["accountType"];
            this.currency = _data["currency"];
            this.nameOnAccount = _data["nameOnAccount"];
            this.accountNumber = _data["accountNumber"];
            this.accountNickname = _data["accountNickname"];
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): PaymentMandate {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMandate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bank"] = this.bank;
        data["branch"] = this.branch;
        data["accountType"] = this.accountType;
        data["currency"] = this.currency;
        data["nameOnAccount"] = this.nameOnAccount;
        data["accountNumber"] = this.accountNumber;
        data["accountNickname"] = this.accountNickname;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): PaymentMandate {
        const json = this.toJSON();
        let result = new PaymentMandate();
        result.init(json);
        return result;
    }
}

export interface IPaymentMandate {
    bank?: string | undefined;
    branch?: string | undefined;
    accountType?: string | undefined;
    currency?: string | undefined;
    nameOnAccount?: string | undefined;
    accountNumber?: string | undefined;
    accountNickname?: string | undefined;
    userId?: string;
    user?: IUser | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class PaymentMandateFilterResponse implements IPaymentMandateFilterResponse {
    results?: PaymentMandate[] | undefined;
    count?: number;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IPaymentMandateFilterResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new PaymentMandate(item) : <PaymentMandate>item;
                }
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(PaymentMandate.fromJS(item));
            }
            this.count = _data["count"];
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaymentMandateFilterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMandateFilterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PaymentMandateFilterResponse {
        const json = this.toJSON();
        let result = new PaymentMandateFilterResponse();
        result.init(json);
        return result;
    }
}

export interface IPaymentMandateFilterResponse {
    results?: IPaymentMandate[] | undefined;
    count?: number;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetAccountByIdRequest implements IGetAccountByIdRequest {
    id?: string | undefined;

    constructor(data?: IGetAccountByIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetAccountByIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountByIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): GetAccountByIdRequest {
        const json = this.toJSON();
        let result = new GetAccountByIdRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAccountByIdRequest {
    id?: string | undefined;
}

export class SlimAccount implements ISlimAccount {
    id?: string;
    accountName?: string | undefined;
    jcsdNumber?: string | undefined;
    accountType?: AccountType;
    brokerId?: string;
    brokerName?: string | undefined;
    primaryAccountHolder?: string | undefined;
    status?: AccountStatus;
    idCardId?: string | undefined;
    idCardMime?: string | undefined;
    idCardUrl?: string | undefined;

    constructor(data?: ISlimAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountName = _data["accountName"];
            this.jcsdNumber = _data["jcsdNumber"];
            this.accountType = _data["accountType"];
            this.brokerId = _data["brokerId"];
            this.brokerName = _data["brokerName"];
            this.primaryAccountHolder = _data["primaryAccountHolder"];
            this.status = _data["status"];
            this.idCardId = _data["idCardId"];
            this.idCardMime = _data["idCardMime"];
            this.idCardUrl = _data["idCardUrl"];
        }
    }

    static fromJS(data: any): SlimAccount {
        data = typeof data === 'object' ? data : {};
        let result = new SlimAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountName"] = this.accountName;
        data["jcsdNumber"] = this.jcsdNumber;
        data["accountType"] = this.accountType;
        data["brokerId"] = this.brokerId;
        data["brokerName"] = this.brokerName;
        data["primaryAccountHolder"] = this.primaryAccountHolder;
        data["status"] = this.status;
        data["idCardId"] = this.idCardId;
        data["idCardMime"] = this.idCardMime;
        data["idCardUrl"] = this.idCardUrl;
        return data; 
    }

    clone(): SlimAccount {
        const json = this.toJSON();
        let result = new SlimAccount();
        result.init(json);
        return result;
    }
}

export interface ISlimAccount {
    id?: string;
    accountName?: string | undefined;
    jcsdNumber?: string | undefined;
    accountType?: AccountType;
    brokerId?: string;
    brokerName?: string | undefined;
    primaryAccountHolder?: string | undefined;
    status?: AccountStatus;
    idCardId?: string | undefined;
    idCardMime?: string | undefined;
    idCardUrl?: string | undefined;
}

export class GetGuestAccountByIdRequest implements IGetGuestAccountByIdRequest {
    id?: string | undefined;

    constructor(data?: IGetGuestAccountByIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetGuestAccountByIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetGuestAccountByIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): GetGuestAccountByIdRequest {
        const json = this.toJSON();
        let result = new GetGuestAccountByIdRequest();
        result.init(json);
        return result;
    }
}

export interface IGetGuestAccountByIdRequest {
    id?: string | undefined;
}

export class TokenValidityQueryRequest implements ITokenValidityQueryRequest {
    readonly linkedToken?: string | undefined;

    constructor(data?: ITokenValidityQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).linkedToken = _data["linkedToken"];
        }
    }

    static fromJS(data: any): TokenValidityQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TokenValidityQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkedToken"] = this.linkedToken;
        return data; 
    }

    clone(): TokenValidityQueryRequest {
        const json = this.toJSON();
        let result = new TokenValidityQueryRequest();
        result.init(json);
        return result;
    }
}

export interface ITokenValidityQueryRequest {
    linkedToken?: string | undefined;
}

export class TokenValidityQueryResponse implements ITokenValidityQueryResponse {
    isValid?: boolean;

    constructor(data?: ITokenValidityQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): TokenValidityQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TokenValidityQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        return data; 
    }

    clone(): TokenValidityQueryResponse {
        const json = this.toJSON();
        let result = new TokenValidityQueryResponse();
        result.init(json);
        return result;
    }
}

export interface ITokenValidityQueryResponse {
    isValid?: boolean;
}

export class WebAccountModel implements IWebAccountModel {
    id?: string;
    accountName?: string | undefined;
    jcsdNumber?: string | undefined;
    accountType?: AccountType;
    brokerCode?: string | undefined;
    primaryBusinessName?: string | undefined;
    primaryFirstName?: string | undefined;
    primaryLastName?: string | undefined;
    primaryTrn?: string | undefined;
    primaryDob?: string | undefined;
    clientTypeHolder1?: AccountHolderType | undefined;
    firstNameHolder1?: string | undefined;
    lastNameHolder1?: string | undefined;
    businessNameHolder1?: string | undefined;
    dobHolder1?: string | undefined;
    trnHolder1?: string | undefined;
    clientTypeHolder2?: AccountHolderType | undefined;
    firstNameHolder2?: string | undefined;
    lastNameHolder2?: string | undefined;
    businessNameHolder2?: string | undefined;
    dobHolder2?: string | undefined;
    trnHolder2?: string | undefined;
    clientTypeHolder3?: AccountHolderType | undefined;
    firstNameHolder3?: string | undefined;
    lastNameHolder3?: string | undefined;
    businessNameHolder3?: string | undefined;
    dobHolder3?: string | undefined;
    trnHolder3?: string | undefined;
    idFile?: string | undefined;
    hasJointHolders?: boolean | undefined;

    constructor(data?: IWebAccountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountName = _data["accountName"];
            this.jcsdNumber = _data["jcsdNumber"];
            this.accountType = _data["accountType"];
            this.brokerCode = _data["brokerCode"];
            this.primaryBusinessName = _data["primaryBusinessName"];
            this.primaryFirstName = _data["primaryFirstName"];
            this.primaryLastName = _data["primaryLastName"];
            this.primaryTrn = _data["primaryTrn"];
            this.primaryDob = _data["primaryDob"];
            this.clientTypeHolder1 = _data["clientTypeHolder1"];
            this.firstNameHolder1 = _data["firstNameHolder1"];
            this.lastNameHolder1 = _data["lastNameHolder1"];
            this.businessNameHolder1 = _data["businessNameHolder1"];
            this.dobHolder1 = _data["dobHolder1"];
            this.trnHolder1 = _data["trnHolder1"];
            this.clientTypeHolder2 = _data["clientTypeHolder2"];
            this.firstNameHolder2 = _data["firstNameHolder2"];
            this.lastNameHolder2 = _data["lastNameHolder2"];
            this.businessNameHolder2 = _data["businessNameHolder2"];
            this.dobHolder2 = _data["dobHolder2"];
            this.trnHolder2 = _data["trnHolder2"];
            this.clientTypeHolder3 = _data["clientTypeHolder3"];
            this.firstNameHolder3 = _data["firstNameHolder3"];
            this.lastNameHolder3 = _data["lastNameHolder3"];
            this.businessNameHolder3 = _data["businessNameHolder3"];
            this.dobHolder3 = _data["dobHolder3"];
            this.trnHolder3 = _data["trnHolder3"];
            this.idFile = _data["idFile"];
            this.hasJointHolders = _data["hasJointHolders"];
        }
    }

    static fromJS(data: any): WebAccountModel {
        data = typeof data === 'object' ? data : {};
        let result = new WebAccountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountName"] = this.accountName;
        data["jcsdNumber"] = this.jcsdNumber;
        data["accountType"] = this.accountType;
        data["brokerCode"] = this.brokerCode;
        data["primaryBusinessName"] = this.primaryBusinessName;
        data["primaryFirstName"] = this.primaryFirstName;
        data["primaryLastName"] = this.primaryLastName;
        data["primaryTrn"] = this.primaryTrn;
        data["primaryDob"] = this.primaryDob;
        data["clientTypeHolder1"] = this.clientTypeHolder1;
        data["firstNameHolder1"] = this.firstNameHolder1;
        data["lastNameHolder1"] = this.lastNameHolder1;
        data["businessNameHolder1"] = this.businessNameHolder1;
        data["dobHolder1"] = this.dobHolder1;
        data["trnHolder1"] = this.trnHolder1;
        data["clientTypeHolder2"] = this.clientTypeHolder2;
        data["firstNameHolder2"] = this.firstNameHolder2;
        data["lastNameHolder2"] = this.lastNameHolder2;
        data["businessNameHolder2"] = this.businessNameHolder2;
        data["dobHolder2"] = this.dobHolder2;
        data["trnHolder2"] = this.trnHolder2;
        data["clientTypeHolder3"] = this.clientTypeHolder3;
        data["firstNameHolder3"] = this.firstNameHolder3;
        data["lastNameHolder3"] = this.lastNameHolder3;
        data["businessNameHolder3"] = this.businessNameHolder3;
        data["dobHolder3"] = this.dobHolder3;
        data["trnHolder3"] = this.trnHolder3;
        data["idFile"] = this.idFile;
        data["hasJointHolders"] = this.hasJointHolders;
        return data; 
    }

    clone(): WebAccountModel {
        const json = this.toJSON();
        let result = new WebAccountModel();
        result.init(json);
        return result;
    }
}

export interface IWebAccountModel {
    id?: string;
    accountName?: string | undefined;
    jcsdNumber?: string | undefined;
    accountType?: AccountType;
    brokerCode?: string | undefined;
    primaryBusinessName?: string | undefined;
    primaryFirstName?: string | undefined;
    primaryLastName?: string | undefined;
    primaryTrn?: string | undefined;
    primaryDob?: string | undefined;
    clientTypeHolder1?: AccountHolderType | undefined;
    firstNameHolder1?: string | undefined;
    lastNameHolder1?: string | undefined;
    businessNameHolder1?: string | undefined;
    dobHolder1?: string | undefined;
    trnHolder1?: string | undefined;
    clientTypeHolder2?: AccountHolderType | undefined;
    firstNameHolder2?: string | undefined;
    lastNameHolder2?: string | undefined;
    businessNameHolder2?: string | undefined;
    dobHolder2?: string | undefined;
    trnHolder2?: string | undefined;
    clientTypeHolder3?: AccountHolderType | undefined;
    firstNameHolder3?: string | undefined;
    lastNameHolder3?: string | undefined;
    businessNameHolder3?: string | undefined;
    dobHolder3?: string | undefined;
    trnHolder3?: string | undefined;
    idFile?: string | undefined;
    hasJointHolders?: boolean | undefined;
}

export class AddJcsdAccountCommandResponse implements IAddJcsdAccountCommandResponse {
    accountName?: string | undefined;

    constructor(data?: IAddJcsdAccountCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"];
        }
    }

    static fromJS(data: any): AddJcsdAccountCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddJcsdAccountCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        return data; 
    }

    clone(): AddJcsdAccountCommandResponse {
        const json = this.toJSON();
        let result = new AddJcsdAccountCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IAddJcsdAccountCommandResponse {
    accountName?: string | undefined;
}

export class EditJcsdAccountCommandResponse implements IEditJcsdAccountCommandResponse {
    accountName?: string | undefined;

    constructor(data?: IEditJcsdAccountCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountName = _data["accountName"];
        }
    }

    static fromJS(data: any): EditJcsdAccountCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditJcsdAccountCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        return data; 
    }

    clone(): EditJcsdAccountCommandResponse {
        const json = this.toJSON();
        let result = new EditJcsdAccountCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IEditJcsdAccountCommandResponse {
    accountName?: string | undefined;
}

export class ValidateAccountCommandResponse implements IValidateAccountCommandResponse {
    isValid?: boolean;
    hasJointHolders?: boolean | undefined;

    constructor(data?: IValidateAccountCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.hasJointHolders = _data["hasJointHolders"];
        }
    }

    static fromJS(data: any): ValidateAccountCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateAccountCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["hasJointHolders"] = this.hasJointHolders;
        return data; 
    }

    clone(): ValidateAccountCommandResponse {
        const json = this.toJSON();
        let result = new ValidateAccountCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IValidateAccountCommandResponse {
    isValid?: boolean;
    hasJointHolders?: boolean | undefined;
}

export class MemoryStream implements IMemoryStream {
    readonly canRead?: boolean;
    readonly canSeek?: boolean;
    readonly canWrite?: boolean;
    capacity?: number;
    readonly length?: number;
    position?: number;
    readonly canTimeout?: boolean;
    readTimeout?: number;
    writeTimeout?: number;

    constructor(data?: IMemoryStream) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).canRead = _data["canRead"];
            (<any>this).canSeek = _data["canSeek"];
            (<any>this).canWrite = _data["canWrite"];
            this.capacity = _data["capacity"];
            (<any>this).length = _data["length"];
            this.position = _data["position"];
            (<any>this).canTimeout = _data["canTimeout"];
            this.readTimeout = _data["readTimeout"];
            this.writeTimeout = _data["writeTimeout"];
        }
    }

    static fromJS(data: any): MemoryStream {
        data = typeof data === 'object' ? data : {};
        let result = new MemoryStream();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canRead"] = this.canRead;
        data["canSeek"] = this.canSeek;
        data["canWrite"] = this.canWrite;
        data["capacity"] = this.capacity;
        data["length"] = this.length;
        data["position"] = this.position;
        data["canTimeout"] = this.canTimeout;
        data["readTimeout"] = this.readTimeout;
        data["writeTimeout"] = this.writeTimeout;
        return data; 
    }

    clone(): MemoryStream {
        const json = this.toJSON();
        let result = new MemoryStream();
        result.init(json);
        return result;
    }
}

export interface IMemoryStream {
    canRead?: boolean;
    canSeek?: boolean;
    canWrite?: boolean;
    capacity?: number;
    length?: number;
    position?: number;
    canTimeout?: boolean;
    readTimeout?: number;
    writeTimeout?: number;
}

export class GetFileByIdQueryResponse implements IGetFileByIdQueryResponse {
    file?: MemoryStream | undefined;
    readonly name?: string | undefined;
    readonly mimeType?: string | undefined;

    constructor(data?: IGetFileByIdQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.file = data.file && !(<any>data.file).toJSON ? new MemoryStream(data.file) : <MemoryStream>this.file; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"] ? MemoryStream.fromJS(_data["file"]) : <any>undefined;
            (<any>this).name = _data["name"];
            (<any>this).mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): GetFileByIdQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFileByIdQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["mimeType"] = this.mimeType;
        return data; 
    }

    clone(): GetFileByIdQueryResponse {
        const json = this.toJSON();
        let result = new GetFileByIdQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetFileByIdQueryResponse {
    file?: IMemoryStream | undefined;
    name?: string | undefined;
    mimeType?: string | undefined;
}

export class GetAllApplicationsByFilterQueryRequest implements IGetAllApplicationsByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetAllApplicationsByFilterQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllApplicationsByFilterQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllApplicationsByFilterQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetAllApplicationsByFilterQueryRequest {
        const json = this.toJSON();
        let result = new GetAllApplicationsByFilterQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetAllApplicationsByFilterQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export enum PaymentMethod {
    CardPayment = "CardPayment",
    ElectronicFundTransfer = "ElectronicFundTransfer",
    BrokerageTransfer = "BrokerageTransfer",
    MarginLoans = "MarginLoans",
    Transfer = "Transfer",
    VMWealthSettlement = "VMWealthSettlement",
}

export enum ApplicationStatus {
    Draft = "Draft",
    Submitted = "Submitted",
    PaymentProcessing = "PaymentProcessing",
    PaymentVerified = "PaymentVerified",
    UpdateRequired = "UpdateRequired",
    AwaitingPayment = "AwaitingPayment",
    CardPaymentMade = "CardPaymentMade",
    Allocated = "Allocated",
    Rejected = "Rejected",
    Cancelled = "Cancelled",
    PaymentFailedForApplication = "PaymentFailedForApplication",
}

export class SlimApplication implements ISlimApplication {
    id?: string;
    applicationNumber?: string | undefined;
    offeringName?: string | undefined;
    accountNumber?: string | undefined;
    sharePoolName?: string | undefined;
    sharesRequested?: number;
    amountDue?: number;
    price?: number | undefined;
    paymentMethod?: PaymentMethod | undefined;
    status?: ApplicationStatus;
    submittedDate?: string | undefined;
    isGuestApplication?: boolean;

    constructor(data?: ISlimApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicationNumber = _data["applicationNumber"];
            this.offeringName = _data["offeringName"];
            this.accountNumber = _data["accountNumber"];
            this.sharePoolName = _data["sharePoolName"];
            this.sharesRequested = _data["sharesRequested"];
            this.amountDue = _data["amountDue"];
            this.price = _data["price"];
            this.paymentMethod = _data["paymentMethod"];
            this.status = _data["status"];
            this.submittedDate = _data["submittedDate"];
            this.isGuestApplication = _data["isGuestApplication"];
        }
    }

    static fromJS(data: any): SlimApplication {
        data = typeof data === 'object' ? data : {};
        let result = new SlimApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicationNumber"] = this.applicationNumber;
        data["offeringName"] = this.offeringName;
        data["accountNumber"] = this.accountNumber;
        data["sharePoolName"] = this.sharePoolName;
        data["sharesRequested"] = this.sharesRequested;
        data["amountDue"] = this.amountDue;
        data["price"] = this.price;
        data["paymentMethod"] = this.paymentMethod;
        data["status"] = this.status;
        data["submittedDate"] = this.submittedDate;
        data["isGuestApplication"] = this.isGuestApplication;
        return data; 
    }

    clone(): SlimApplication {
        const json = this.toJSON();
        let result = new SlimApplication();
        result.init(json);
        return result;
    }
}

export interface ISlimApplication {
    id?: string;
    applicationNumber?: string | undefined;
    offeringName?: string | undefined;
    accountNumber?: string | undefined;
    sharePoolName?: string | undefined;
    sharesRequested?: number;
    amountDue?: number;
    price?: number | undefined;
    paymentMethod?: PaymentMethod | undefined;
    status?: ApplicationStatus;
    submittedDate?: string | undefined;
    isGuestApplication?: boolean;
}

export class GetAllApplicationsByFilterQueryResponse implements IGetAllApplicationsByFilterQueryResponse {
    results?: SlimApplication[] | undefined;
    count?: number;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetAllApplicationsByFilterQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new SlimApplication(item) : <SlimApplication>item;
                }
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SlimApplication.fromJS(item));
            }
            this.count = _data["count"];
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllApplicationsByFilterQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllApplicationsByFilterQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetAllApplicationsByFilterQueryResponse {
        const json = this.toJSON();
        let result = new GetAllApplicationsByFilterQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllApplicationsByFilterQueryResponse {
    results?: ISlimApplication[] | undefined;
    count?: number;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class VerifyEligibilityModel implements IVerifyEligibilityModel {
    requestorId?: string | undefined;
    sharePoolId?: string | undefined;

    constructor(data?: IVerifyEligibilityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestorId = _data["requestorId"];
            this.sharePoolId = _data["sharePoolId"];
        }
    }

    static fromJS(data: any): VerifyEligibilityModel {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyEligibilityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestorId"] = this.requestorId;
        data["sharePoolId"] = this.sharePoolId;
        return data; 
    }

    clone(): VerifyEligibilityModel {
        const json = this.toJSON();
        let result = new VerifyEligibilityModel();
        result.init(json);
        return result;
    }
}

export interface IVerifyEligibilityModel {
    requestorId?: string | undefined;
    sharePoolId?: string | undefined;
}

export class VerifyEligibilityResponse implements IVerifyEligibilityResponse {
    isEligible?: boolean;

    constructor(data?: IVerifyEligibilityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEligible = _data["isEligible"];
        }
    }

    static fromJS(data: any): VerifyEligibilityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyEligibilityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEligible"] = this.isEligible;
        return data; 
    }

    clone(): VerifyEligibilityResponse {
        const json = this.toJSON();
        let result = new VerifyEligibilityResponse();
        result.init(json);
        return result;
    }
}

export interface IVerifyEligibilityResponse {
    isEligible?: boolean;
}

export class GetSharesAvailableForApplicationQueryRequest implements IGetSharesAvailableForApplicationQueryRequest {
    accountId?: string | undefined;
    sharePoolId?: string | undefined;

    constructor(data?: IGetSharesAvailableForApplicationQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"];
            this.sharePoolId = _data["sharePoolId"];
        }
    }

    static fromJS(data: any): GetSharesAvailableForApplicationQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSharesAvailableForApplicationQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId;
        data["sharePoolId"] = this.sharePoolId;
        return data; 
    }

    clone(): GetSharesAvailableForApplicationQueryRequest {
        const json = this.toJSON();
        let result = new GetSharesAvailableForApplicationQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetSharesAvailableForApplicationQueryRequest {
    accountId?: string | undefined;
    sharePoolId?: string | undefined;
}

export class GetSharesAvailableForApplicationQueryResponse implements IGetSharesAvailableForApplicationQueryResponse {
    found?: boolean;
    sharesAvailable?: number | undefined;
    sharesOwned?: number | undefined;

    constructor(data?: IGetSharesAvailableForApplicationQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.found = _data["found"];
            this.sharesAvailable = _data["sharesAvailable"];
            this.sharesOwned = _data["sharesOwned"];
        }
    }

    static fromJS(data: any): GetSharesAvailableForApplicationQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSharesAvailableForApplicationQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["found"] = this.found;
        data["sharesAvailable"] = this.sharesAvailable;
        data["sharesOwned"] = this.sharesOwned;
        return data; 
    }

    clone(): GetSharesAvailableForApplicationQueryResponse {
        const json = this.toJSON();
        let result = new GetSharesAvailableForApplicationQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetSharesAvailableForApplicationQueryResponse {
    found?: boolean;
    sharesAvailable?: number | undefined;
    sharesOwned?: number | undefined;
}

export class GetOfferingsByFilterForCustomerQueryRequest implements IGetOfferingsByFilterForCustomerQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetOfferingsByFilterForCustomerQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOfferingsByFilterForCustomerQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetOfferingsByFilterForCustomerQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetOfferingsByFilterForCustomerQueryRequest {
        const json = this.toJSON();
        let result = new GetOfferingsByFilterForCustomerQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetOfferingsByFilterForCustomerQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export enum OfferingStatus {
    Draft = "Draft",
    Rejected = "Rejected",
    Submitted = "Submitted",
    Approved = "Approved",
    PreOpen = "PreOpen",
    Opened = "Opened",
    Suspended = "Suspended",
    Closed = "Closed",
}

export enum OfferingType {
    IPO = "IPO",
    RightsIssue = "RightsIssue",
    PreferenceShares = "PreferenceShares",
    Bonds = "Bonds",
}

export class SlimOffering implements ISlimOffering {
    id?: string;
    title?: string | undefined;
    fileUrl?: string | undefined;
    prospectusUrl?: string | undefined;
    shortDescription?: string | undefined;
    longDescription?: string | undefined;
    prospectusId?: string | undefined;
    status?: OfferingStatus;
    offeringType?: OfferingType | undefined;
    closingDate?: string | undefined;
    openingDate?: string | undefined;
    generalSharePrice?: number | undefined;
    generalShareAmount?: number | undefined;
    currency?: string | undefined;
    readonly arrangerName?: string | undefined;
    readonly leadBrokerName?: string | undefined;
    readonly arrangerId?: string | undefined;
    readonly leadBrokerId?: string | undefined;
    processingFee?: number | undefined;
    isPrivateListing?: boolean;

    constructor(data?: ISlimOffering) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.fileUrl = _data["fileUrl"];
            this.prospectusUrl = _data["prospectusUrl"];
            this.shortDescription = _data["shortDescription"];
            this.longDescription = _data["longDescription"];
            this.prospectusId = _data["prospectusId"];
            this.status = _data["status"];
            this.offeringType = _data["offeringType"];
            this.closingDate = _data["closingDate"];
            this.openingDate = _data["openingDate"];
            this.generalSharePrice = _data["generalSharePrice"];
            this.generalShareAmount = _data["generalShareAmount"];
            this.currency = _data["currency"];
            (<any>this).arrangerName = _data["arrangerName"];
            (<any>this).leadBrokerName = _data["leadBrokerName"];
            (<any>this).arrangerId = _data["arrangerId"];
            (<any>this).leadBrokerId = _data["leadBrokerId"];
            this.processingFee = _data["processingFee"];
            this.isPrivateListing = _data["isPrivateListing"];
        }
    }

    static fromJS(data: any): SlimOffering {
        data = typeof data === 'object' ? data : {};
        let result = new SlimOffering();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["fileUrl"] = this.fileUrl;
        data["prospectusUrl"] = this.prospectusUrl;
        data["shortDescription"] = this.shortDescription;
        data["longDescription"] = this.longDescription;
        data["prospectusId"] = this.prospectusId;
        data["status"] = this.status;
        data["offeringType"] = this.offeringType;
        data["closingDate"] = this.closingDate;
        data["openingDate"] = this.openingDate;
        data["generalSharePrice"] = this.generalSharePrice;
        data["generalShareAmount"] = this.generalShareAmount;
        data["currency"] = this.currency;
        data["arrangerName"] = this.arrangerName;
        data["leadBrokerName"] = this.leadBrokerName;
        data["arrangerId"] = this.arrangerId;
        data["leadBrokerId"] = this.leadBrokerId;
        data["processingFee"] = this.processingFee;
        data["isPrivateListing"] = this.isPrivateListing;
        return data; 
    }

    clone(): SlimOffering {
        const json = this.toJSON();
        let result = new SlimOffering();
        result.init(json);
        return result;
    }
}

export interface ISlimOffering {
    id?: string;
    title?: string | undefined;
    fileUrl?: string | undefined;
    prospectusUrl?: string | undefined;
    shortDescription?: string | undefined;
    longDescription?: string | undefined;
    prospectusId?: string | undefined;
    status?: OfferingStatus;
    offeringType?: OfferingType | undefined;
    closingDate?: string | undefined;
    openingDate?: string | undefined;
    generalSharePrice?: number | undefined;
    generalShareAmount?: number | undefined;
    currency?: string | undefined;
    arrangerName?: string | undefined;
    leadBrokerName?: string | undefined;
    arrangerId?: string | undefined;
    leadBrokerId?: string | undefined;
    processingFee?: number | undefined;
    isPrivateListing?: boolean;
}

export class GetOfferingsByFilterForCustomerQueryResponse implements IGetOfferingsByFilterForCustomerQueryResponse {
    results?: SlimOffering[] | undefined;
    count?: number;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetOfferingsByFilterForCustomerQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new SlimOffering(item) : <SlimOffering>item;
                }
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SlimOffering.fromJS(item));
            }
            this.count = _data["count"];
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOfferingsByFilterForCustomerQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOfferingsByFilterForCustomerQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetOfferingsByFilterForCustomerQueryResponse {
        const json = this.toJSON();
        let result = new GetOfferingsByFilterForCustomerQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetOfferingsByFilterForCustomerQueryResponse {
    results?: ISlimOffering[] | undefined;
    count?: number;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetOfferingsByIdForCustomerQueryRequest implements IGetOfferingsByIdForCustomerQueryRequest {
    id?: string;

    constructor(data?: IGetOfferingsByIdForCustomerQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetOfferingsByIdForCustomerQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetOfferingsByIdForCustomerQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): GetOfferingsByIdForCustomerQueryRequest {
        const json = this.toJSON();
        let result = new GetOfferingsByIdForCustomerQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetOfferingsByIdForCustomerQueryRequest {
    id?: string;
}

export class GetOfferingsByIdForCustomerQueryResponse implements IGetOfferingsByIdForCustomerQueryResponse {
    offering?: SlimOffering | undefined;

    constructor(data?: IGetOfferingsByIdForCustomerQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.offering = data.offering && !(<any>data.offering).toJSON ? new SlimOffering(data.offering) : <SlimOffering>this.offering; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offering = _data["offering"] ? SlimOffering.fromJS(_data["offering"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOfferingsByIdForCustomerQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOfferingsByIdForCustomerQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offering"] = this.offering ? this.offering.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetOfferingsByIdForCustomerQueryResponse {
        const json = this.toJSON();
        let result = new GetOfferingsByIdForCustomerQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetOfferingsByIdForCustomerQueryResponse {
    offering?: ISlimOffering | undefined;
}

export class GetOfferingsViewModelByIdForCustomerQueryRequest implements IGetOfferingsViewModelByIdForCustomerQueryRequest {
    id?: string;

    constructor(data?: IGetOfferingsViewModelByIdForCustomerQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetOfferingsViewModelByIdForCustomerQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetOfferingsViewModelByIdForCustomerQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): GetOfferingsViewModelByIdForCustomerQueryRequest {
        const json = this.toJSON();
        let result = new GetOfferingsViewModelByIdForCustomerQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetOfferingsViewModelByIdForCustomerQueryRequest {
    id?: string;
}

export class Stream implements IStream {
    readonly canRead?: boolean;
    readonly canSeek?: boolean;
    readonly canWrite?: boolean;
    readonly length?: number;
    position?: number;
    readonly canTimeout?: boolean;
    readTimeout?: number;
    writeTimeout?: number;

    constructor(data?: IStream) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).canRead = _data["canRead"];
            (<any>this).canSeek = _data["canSeek"];
            (<any>this).canWrite = _data["canWrite"];
            (<any>this).length = _data["length"];
            this.position = _data["position"];
            (<any>this).canTimeout = _data["canTimeout"];
            this.readTimeout = _data["readTimeout"];
            this.writeTimeout = _data["writeTimeout"];
        }
    }

    static fromJS(data: any): Stream {
        data = typeof data === 'object' ? data : {};
        let result = new Stream();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canRead"] = this.canRead;
        data["canSeek"] = this.canSeek;
        data["canWrite"] = this.canWrite;
        data["length"] = this.length;
        data["position"] = this.position;
        data["canTimeout"] = this.canTimeout;
        data["readTimeout"] = this.readTimeout;
        data["writeTimeout"] = this.writeTimeout;
        return data; 
    }

    clone(): Stream {
        const json = this.toJSON();
        let result = new Stream();
        result.init(json);
        return result;
    }
}

export interface IStream {
    canRead?: boolean;
    canSeek?: boolean;
    canWrite?: boolean;
    length?: number;
    position?: number;
    canTimeout?: boolean;
    readTimeout?: number;
    writeTimeout?: number;
}

export class DataFileModel implements IDataFileModel {
    id?: string | undefined;
    fileName?: string | undefined;
    dataStream?: Stream | undefined;
    extension?: string | undefined;
    mimeType?: string | undefined;
    fileUrl?: string | undefined;

    constructor(data?: IDataFileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.dataStream = data.dataStream && !(<any>data.dataStream).toJSON ? new Stream(data.dataStream) : <Stream>this.dataStream; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.dataStream = _data["dataStream"] ? Stream.fromJS(_data["dataStream"]) : <any>undefined;
            this.extension = _data["extension"];
            this.mimeType = _data["mimeType"];
            this.fileUrl = _data["fileUrl"];
        }
    }

    static fromJS(data: any): DataFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataFileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["dataStream"] = this.dataStream ? this.dataStream.toJSON() : <any>undefined;
        data["extension"] = this.extension;
        data["mimeType"] = this.mimeType;
        data["fileUrl"] = this.fileUrl;
        return data; 
    }

    clone(): DataFileModel {
        const json = this.toJSON();
        let result = new DataFileModel();
        result.init(json);
        return result;
    }
}

export interface IDataFileModel {
    id?: string | undefined;
    fileName?: string | undefined;
    dataStream?: IStream | undefined;
    extension?: string | undefined;
    mimeType?: string | undefined;
    fileUrl?: string | undefined;
}

export enum SharePoolType {
    General = "General",
    RightsIssue = "RightsIssue",
    Gift = "Gift",
}

export class SharePoolModel implements ISharePoolModel {
    name?: string | undefined;
    price?: number | undefined;
    allocation?: number | undefined;
    requireVerification?: boolean;
    verificationLabel?: string | undefined;
    verificationListId?: string | undefined;
    totalApplications?: number;
    settledApplications?: number;
    unsettleApplications?: number;
    verificationList?: DataFileModel | undefined;
    offeringId?: string | undefined;
    id?: string;
    batchNumber?: number | undefined;
    appType?: number | undefined;
    readonly isGiftPool?: boolean;
    sharePoolType?: SharePoolType | undefined;

    constructor(data?: ISharePoolModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.verificationList = data.verificationList && !(<any>data.verificationList).toJSON ? new DataFileModel(data.verificationList) : <DataFileModel>this.verificationList; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.price = _data["price"];
            this.allocation = _data["allocation"];
            this.requireVerification = _data["requireVerification"];
            this.verificationLabel = _data["verificationLabel"];
            this.verificationListId = _data["verificationListId"];
            this.totalApplications = _data["totalApplications"];
            this.settledApplications = _data["settledApplications"];
            this.unsettleApplications = _data["unsettleApplications"];
            this.verificationList = _data["verificationList"] ? DataFileModel.fromJS(_data["verificationList"]) : <any>undefined;
            this.offeringId = _data["offeringId"];
            this.id = _data["id"];
            this.batchNumber = _data["batchNumber"];
            this.appType = _data["appType"];
            (<any>this).isGiftPool = _data["isGiftPool"];
            this.sharePoolType = _data["sharePoolType"];
        }
    }

    static fromJS(data: any): SharePoolModel {
        data = typeof data === 'object' ? data : {};
        let result = new SharePoolModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["price"] = this.price;
        data["allocation"] = this.allocation;
        data["requireVerification"] = this.requireVerification;
        data["verificationLabel"] = this.verificationLabel;
        data["verificationListId"] = this.verificationListId;
        data["totalApplications"] = this.totalApplications;
        data["settledApplications"] = this.settledApplications;
        data["unsettleApplications"] = this.unsettleApplications;
        data["verificationList"] = this.verificationList ? this.verificationList.toJSON() : <any>undefined;
        data["offeringId"] = this.offeringId;
        data["id"] = this.id;
        data["batchNumber"] = this.batchNumber;
        data["appType"] = this.appType;
        data["isGiftPool"] = this.isGiftPool;
        data["sharePoolType"] = this.sharePoolType;
        return data; 
    }

    clone(): SharePoolModel {
        const json = this.toJSON();
        let result = new SharePoolModel();
        result.init(json);
        return result;
    }
}

export interface ISharePoolModel {
    name?: string | undefined;
    price?: number | undefined;
    allocation?: number | undefined;
    requireVerification?: boolean;
    verificationLabel?: string | undefined;
    verificationListId?: string | undefined;
    totalApplications?: number;
    settledApplications?: number;
    unsettleApplications?: number;
    verificationList?: IDataFileModel | undefined;
    offeringId?: string | undefined;
    id?: string;
    batchNumber?: number | undefined;
    appType?: number | undefined;
    isGiftPool?: boolean;
    sharePoolType?: SharePoolType | undefined;
}

export class OfferingCoBroker implements IOfferingCoBroker {
    offeringId?: string;
    offering?: Offering | undefined;
    brokerId?: string;
    broker?: Broker | undefined;

    constructor(data?: IOfferingCoBroker) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.offering = data.offering && !(<any>data.offering).toJSON ? new Offering(data.offering) : <Offering>this.offering; 
            this.broker = data.broker && !(<any>data.broker).toJSON ? new Broker(data.broker) : <Broker>this.broker; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offeringId = _data["offeringId"];
            this.offering = _data["offering"] ? Offering.fromJS(_data["offering"]) : <any>undefined;
            this.brokerId = _data["brokerId"];
            this.broker = _data["broker"] ? Broker.fromJS(_data["broker"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OfferingCoBroker {
        data = typeof data === 'object' ? data : {};
        let result = new OfferingCoBroker();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offeringId"] = this.offeringId;
        data["offering"] = this.offering ? this.offering.toJSON() : <any>undefined;
        data["brokerId"] = this.brokerId;
        data["broker"] = this.broker ? this.broker.toJSON() : <any>undefined;
        return data; 
    }

    clone(): OfferingCoBroker {
        const json = this.toJSON();
        let result = new OfferingCoBroker();
        result.init(json);
        return result;
    }
}

export interface IOfferingCoBroker {
    offeringId?: string;
    offering?: IOffering | undefined;
    brokerId?: string;
    broker?: IBroker | undefined;
}

export class VerificationListItems implements IVerificationListItems {
    verificationListId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    taxRegistrationNumber?: string | undefined;
    accountNumber?: string | undefined;
    specialNumber?: string | undefined;
    dateOfBirth?: string | undefined;
    sharesOwned?: number | undefined;
    sharesAvailable?: number | undefined;
    verificationList?: VerificationList | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IVerificationListItems) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.verificationList = data.verificationList && !(<any>data.verificationList).toJSON ? new VerificationList(data.verificationList) : <VerificationList>this.verificationList; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verificationListId = _data["verificationListId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.taxRegistrationNumber = _data["taxRegistrationNumber"];
            this.accountNumber = _data["accountNumber"];
            this.specialNumber = _data["specialNumber"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.sharesOwned = _data["sharesOwned"];
            this.sharesAvailable = _data["sharesAvailable"];
            this.verificationList = _data["verificationList"] ? VerificationList.fromJS(_data["verificationList"]) : <any>undefined;
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): VerificationListItems {
        data = typeof data === 'object' ? data : {};
        let result = new VerificationListItems();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verificationListId"] = this.verificationListId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["taxRegistrationNumber"] = this.taxRegistrationNumber;
        data["accountNumber"] = this.accountNumber;
        data["specialNumber"] = this.specialNumber;
        data["dateOfBirth"] = this.dateOfBirth;
        data["sharesOwned"] = this.sharesOwned;
        data["sharesAvailable"] = this.sharesAvailable;
        data["verificationList"] = this.verificationList ? this.verificationList.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): VerificationListItems {
        const json = this.toJSON();
        let result = new VerificationListItems();
        result.init(json);
        return result;
    }
}

export interface IVerificationListItems {
    verificationListId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    taxRegistrationNumber?: string | undefined;
    accountNumber?: string | undefined;
    specialNumber?: string | undefined;
    dateOfBirth?: string | undefined;
    sharesOwned?: number | undefined;
    sharesAvailable?: number | undefined;
    verificationList?: IVerificationList | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class VerificationList implements IVerificationList {
    members?: VerificationListItems[] | undefined;
    sharePool?: SharePool | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IVerificationList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.members) {
                this.members = [];
                for (let i = 0; i < data.members.length; i++) {
                    let item = data.members[i];
                    this.members[i] = item && !(<any>item).toJSON ? new VerificationListItems(item) : <VerificationListItems>item;
                }
            }
            this.sharePool = data.sharePool && !(<any>data.sharePool).toJSON ? new SharePool(data.sharePool) : <SharePool>this.sharePool; 
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(VerificationListItems.fromJS(item));
            }
            this.sharePool = _data["sharePool"] ? SharePool.fromJS(_data["sharePool"]) : <any>undefined;
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): VerificationList {
        data = typeof data === 'object' ? data : {};
        let result = new VerificationList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        data["sharePool"] = this.sharePool ? this.sharePool.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): VerificationList {
        const json = this.toJSON();
        let result = new VerificationList();
        result.init(json);
        return result;
    }
}

export interface IVerificationList {
    members?: IVerificationListItems[] | undefined;
    sharePool?: ISharePool | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class SharePool implements ISharePool {
    name?: string | undefined;
    price?: number;
    allocation?: number;
    requireVerification?: boolean;
    verificationLabel?: string | undefined;
    verificationListId?: string | undefined;
    verificationList?: VerificationList | undefined;
    offeringId?: string;
    offering?: Offering | undefined;
    batchNumber?: number | undefined;
    appType?: number | undefined;
    sharePoolType?: SharePoolType | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: ISharePool) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.verificationList = data.verificationList && !(<any>data.verificationList).toJSON ? new VerificationList(data.verificationList) : <VerificationList>this.verificationList; 
            this.offering = data.offering && !(<any>data.offering).toJSON ? new Offering(data.offering) : <Offering>this.offering; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.price = _data["price"];
            this.allocation = _data["allocation"];
            this.requireVerification = _data["requireVerification"];
            this.verificationLabel = _data["verificationLabel"];
            this.verificationListId = _data["verificationListId"];
            this.verificationList = _data["verificationList"] ? VerificationList.fromJS(_data["verificationList"]) : <any>undefined;
            this.offeringId = _data["offeringId"];
            this.offering = _data["offering"] ? Offering.fromJS(_data["offering"]) : <any>undefined;
            this.batchNumber = _data["batchNumber"];
            this.appType = _data["appType"];
            this.sharePoolType = _data["sharePoolType"];
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): SharePool {
        data = typeof data === 'object' ? data : {};
        let result = new SharePool();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["price"] = this.price;
        data["allocation"] = this.allocation;
        data["requireVerification"] = this.requireVerification;
        data["verificationLabel"] = this.verificationLabel;
        data["verificationListId"] = this.verificationListId;
        data["verificationList"] = this.verificationList ? this.verificationList.toJSON() : <any>undefined;
        data["offeringId"] = this.offeringId;
        data["offering"] = this.offering ? this.offering.toJSON() : <any>undefined;
        data["batchNumber"] = this.batchNumber;
        data["appType"] = this.appType;
        data["sharePoolType"] = this.sharePoolType;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): SharePool {
        const json = this.toJSON();
        let result = new SharePool();
        result.init(json);
        return result;
    }
}

export interface ISharePool {
    name?: string | undefined;
    price?: number;
    allocation?: number;
    requireVerification?: boolean;
    verificationLabel?: string | undefined;
    verificationListId?: string | undefined;
    verificationList?: IVerificationList | undefined;
    offeringId?: string;
    offering?: IOffering | undefined;
    batchNumber?: number | undefined;
    appType?: number | undefined;
    sharePoolType?: SharePoolType | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class OfferingDocuments implements IOfferingDocuments {
    displayName?: string | undefined;
    requiresClientUpload?: boolean;
    documentId?: string | undefined;
    document?: DataFile | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IOfferingDocuments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.document = data.document && !(<any>data.document).toJSON ? new DataFile(data.document) : <DataFile>this.document; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.requiresClientUpload = _data["requiresClientUpload"];
            this.documentId = _data["documentId"];
            this.document = _data["document"] ? DataFile.fromJS(_data["document"]) : <any>undefined;
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): OfferingDocuments {
        data = typeof data === 'object' ? data : {};
        let result = new OfferingDocuments();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["requiresClientUpload"] = this.requiresClientUpload;
        data["documentId"] = this.documentId;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): OfferingDocuments {
        const json = this.toJSON();
        let result = new OfferingDocuments();
        result.init(json);
        return result;
    }
}

export interface IOfferingDocuments {
    displayName?: string | undefined;
    requiresClientUpload?: boolean;
    documentId?: string | undefined;
    document?: IDataFile | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class Offering implements IOffering {
    title?: string | undefined;
    logoId?: string | undefined;
    logo?: DataFile | undefined;
    shortName?: string | undefined;
    arrangerId?: string | undefined;
    arranger?: Broker | undefined;
    leadBrokerId?: string | undefined;
    leadBroker?: Broker | undefined;
    coBrokers?: OfferingCoBroker[] | undefined;
    shortDescription?: string | undefined;
    summary?: string | undefined;
    totalAllotment?: number | undefined;
    openingDate?: string | undefined;
    closingDate?: string | undefined;
    currency?: string | undefined;
    shareIncrements?: number | undefined;
    refundInstructions?: string | undefined;
    termsAndConditions?: string | undefined;
    processingFee?: number | undefined;
    prospectusId?: string | undefined;
    prospectus?: DataFile | undefined;
    dividendMandate?: string | undefined;
    additionalInstructions?: string | undefined;
    minimumQuantity?: number | undefined;
    sharePools?: SharePool[] | undefined;
    rejectionReasons?: OfferingRejectionReason[] | undefined;
    status?: OfferingStatus;
    offeringType?: OfferingType | undefined;
    requiresAccreditedInvestor?: boolean;
    offeringDocuments?: OfferingDocuments[] | undefined;
    sharePoolCategoryName?: string | undefined;
    externalId?: number | undefined;
    isPrivateListing?: boolean;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IOffering) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.logo = data.logo && !(<any>data.logo).toJSON ? new DataFile(data.logo) : <DataFile>this.logo; 
            this.arranger = data.arranger && !(<any>data.arranger).toJSON ? new Broker(data.arranger) : <Broker>this.arranger; 
            this.leadBroker = data.leadBroker && !(<any>data.leadBroker).toJSON ? new Broker(data.leadBroker) : <Broker>this.leadBroker; 
            if (data.coBrokers) {
                this.coBrokers = [];
                for (let i = 0; i < data.coBrokers.length; i++) {
                    let item = data.coBrokers[i];
                    this.coBrokers[i] = item && !(<any>item).toJSON ? new OfferingCoBroker(item) : <OfferingCoBroker>item;
                }
            }
            this.prospectus = data.prospectus && !(<any>data.prospectus).toJSON ? new DataFile(data.prospectus) : <DataFile>this.prospectus; 
            if (data.sharePools) {
                this.sharePools = [];
                for (let i = 0; i < data.sharePools.length; i++) {
                    let item = data.sharePools[i];
                    this.sharePools[i] = item && !(<any>item).toJSON ? new SharePool(item) : <SharePool>item;
                }
            }
            if (data.rejectionReasons) {
                this.rejectionReasons = [];
                for (let i = 0; i < data.rejectionReasons.length; i++) {
                    let item = data.rejectionReasons[i];
                    this.rejectionReasons[i] = item && !(<any>item).toJSON ? new OfferingRejectionReason(item) : <OfferingRejectionReason>item;
                }
            }
            if (data.offeringDocuments) {
                this.offeringDocuments = [];
                for (let i = 0; i < data.offeringDocuments.length; i++) {
                    let item = data.offeringDocuments[i];
                    this.offeringDocuments[i] = item && !(<any>item).toJSON ? new OfferingDocuments(item) : <OfferingDocuments>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.logoId = _data["logoId"];
            this.logo = _data["logo"] ? DataFile.fromJS(_data["logo"]) : <any>undefined;
            this.shortName = _data["shortName"];
            this.arrangerId = _data["arrangerId"];
            this.arranger = _data["arranger"] ? Broker.fromJS(_data["arranger"]) : <any>undefined;
            this.leadBrokerId = _data["leadBrokerId"];
            this.leadBroker = _data["leadBroker"] ? Broker.fromJS(_data["leadBroker"]) : <any>undefined;
            if (Array.isArray(_data["coBrokers"])) {
                this.coBrokers = [] as any;
                for (let item of _data["coBrokers"])
                    this.coBrokers!.push(OfferingCoBroker.fromJS(item));
            }
            this.shortDescription = _data["shortDescription"];
            this.summary = _data["summary"];
            this.totalAllotment = _data["totalAllotment"];
            this.openingDate = _data["openingDate"];
            this.closingDate = _data["closingDate"];
            this.currency = _data["currency"];
            this.shareIncrements = _data["shareIncrements"];
            this.refundInstructions = _data["refundInstructions"];
            this.termsAndConditions = _data["termsAndConditions"];
            this.processingFee = _data["processingFee"];
            this.prospectusId = _data["prospectusId"];
            this.prospectus = _data["prospectus"] ? DataFile.fromJS(_data["prospectus"]) : <any>undefined;
            this.dividendMandate = _data["dividendMandate"];
            this.additionalInstructions = _data["additionalInstructions"];
            this.minimumQuantity = _data["minimumQuantity"];
            if (Array.isArray(_data["sharePools"])) {
                this.sharePools = [] as any;
                for (let item of _data["sharePools"])
                    this.sharePools!.push(SharePool.fromJS(item));
            }
            if (Array.isArray(_data["rejectionReasons"])) {
                this.rejectionReasons = [] as any;
                for (let item of _data["rejectionReasons"])
                    this.rejectionReasons!.push(OfferingRejectionReason.fromJS(item));
            }
            this.status = _data["status"];
            this.offeringType = _data["offeringType"];
            this.requiresAccreditedInvestor = _data["requiresAccreditedInvestor"];
            if (Array.isArray(_data["offeringDocuments"])) {
                this.offeringDocuments = [] as any;
                for (let item of _data["offeringDocuments"])
                    this.offeringDocuments!.push(OfferingDocuments.fromJS(item));
            }
            this.sharePoolCategoryName = _data["sharePoolCategoryName"];
            this.externalId = _data["externalId"];
            this.isPrivateListing = _data["isPrivateListing"];
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): Offering {
        data = typeof data === 'object' ? data : {};
        let result = new Offering();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["logoId"] = this.logoId;
        data["logo"] = this.logo ? this.logo.toJSON() : <any>undefined;
        data["shortName"] = this.shortName;
        data["arrangerId"] = this.arrangerId;
        data["arranger"] = this.arranger ? this.arranger.toJSON() : <any>undefined;
        data["leadBrokerId"] = this.leadBrokerId;
        data["leadBroker"] = this.leadBroker ? this.leadBroker.toJSON() : <any>undefined;
        if (Array.isArray(this.coBrokers)) {
            data["coBrokers"] = [];
            for (let item of this.coBrokers)
                data["coBrokers"].push(item.toJSON());
        }
        data["shortDescription"] = this.shortDescription;
        data["summary"] = this.summary;
        data["totalAllotment"] = this.totalAllotment;
        data["openingDate"] = this.openingDate;
        data["closingDate"] = this.closingDate;
        data["currency"] = this.currency;
        data["shareIncrements"] = this.shareIncrements;
        data["refundInstructions"] = this.refundInstructions;
        data["termsAndConditions"] = this.termsAndConditions;
        data["processingFee"] = this.processingFee;
        data["prospectusId"] = this.prospectusId;
        data["prospectus"] = this.prospectus ? this.prospectus.toJSON() : <any>undefined;
        data["dividendMandate"] = this.dividendMandate;
        data["additionalInstructions"] = this.additionalInstructions;
        data["minimumQuantity"] = this.minimumQuantity;
        if (Array.isArray(this.sharePools)) {
            data["sharePools"] = [];
            for (let item of this.sharePools)
                data["sharePools"].push(item.toJSON());
        }
        if (Array.isArray(this.rejectionReasons)) {
            data["rejectionReasons"] = [];
            for (let item of this.rejectionReasons)
                data["rejectionReasons"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["offeringType"] = this.offeringType;
        data["requiresAccreditedInvestor"] = this.requiresAccreditedInvestor;
        if (Array.isArray(this.offeringDocuments)) {
            data["offeringDocuments"] = [];
            for (let item of this.offeringDocuments)
                data["offeringDocuments"].push(item.toJSON());
        }
        data["sharePoolCategoryName"] = this.sharePoolCategoryName;
        data["externalId"] = this.externalId;
        data["isPrivateListing"] = this.isPrivateListing;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): Offering {
        const json = this.toJSON();
        let result = new Offering();
        result.init(json);
        return result;
    }
}

export interface IOffering {
    title?: string | undefined;
    logoId?: string | undefined;
    logo?: IDataFile | undefined;
    shortName?: string | undefined;
    arrangerId?: string | undefined;
    arranger?: IBroker | undefined;
    leadBrokerId?: string | undefined;
    leadBroker?: IBroker | undefined;
    coBrokers?: IOfferingCoBroker[] | undefined;
    shortDescription?: string | undefined;
    summary?: string | undefined;
    totalAllotment?: number | undefined;
    openingDate?: string | undefined;
    closingDate?: string | undefined;
    currency?: string | undefined;
    shareIncrements?: number | undefined;
    refundInstructions?: string | undefined;
    termsAndConditions?: string | undefined;
    processingFee?: number | undefined;
    prospectusId?: string | undefined;
    prospectus?: IDataFile | undefined;
    dividendMandate?: string | undefined;
    additionalInstructions?: string | undefined;
    minimumQuantity?: number | undefined;
    sharePools?: ISharePool[] | undefined;
    rejectionReasons?: IOfferingRejectionReason[] | undefined;
    status?: OfferingStatus;
    offeringType?: OfferingType | undefined;
    requiresAccreditedInvestor?: boolean;
    offeringDocuments?: IOfferingDocuments[] | undefined;
    sharePoolCategoryName?: string | undefined;
    externalId?: number | undefined;
    isPrivateListing?: boolean;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class OfferingRejectionReason implements IOfferingRejectionReason {
    offeringId?: string;
    offering?: Offering | undefined;
    reason?: string | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IOfferingRejectionReason) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.offering = data.offering && !(<any>data.offering).toJSON ? new Offering(data.offering) : <Offering>this.offering; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offeringId = _data["offeringId"];
            this.offering = _data["offering"] ? Offering.fromJS(_data["offering"]) : <any>undefined;
            this.reason = _data["reason"];
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): OfferingRejectionReason {
        data = typeof data === 'object' ? data : {};
        let result = new OfferingRejectionReason();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offeringId"] = this.offeringId;
        data["offering"] = this.offering ? this.offering.toJSON() : <any>undefined;
        data["reason"] = this.reason;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): OfferingRejectionReason {
        const json = this.toJSON();
        let result = new OfferingRejectionReason();
        result.init(json);
        return result;
    }
}

export interface IOfferingRejectionReason {
    offeringId?: string;
    offering?: IOffering | undefined;
    reason?: string | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class OfferingDocumentModel implements IOfferingDocumentModel {
    id?: string | undefined;
    displayName?: string | undefined;
    requiresClientUpload?: boolean;
    documentId?: string | undefined;
    document?: DataFileModel | undefined;
    readonly fileName?: string | undefined;

    constructor(data?: IOfferingDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.document = data.document && !(<any>data.document).toJSON ? new DataFileModel(data.document) : <DataFileModel>this.document; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.requiresClientUpload = _data["requiresClientUpload"];
            this.documentId = _data["documentId"];
            this.document = _data["document"] ? DataFileModel.fromJS(_data["document"]) : <any>undefined;
            (<any>this).fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): OfferingDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfferingDocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["requiresClientUpload"] = this.requiresClientUpload;
        data["documentId"] = this.documentId;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["fileName"] = this.fileName;
        return data; 
    }

    clone(): OfferingDocumentModel {
        const json = this.toJSON();
        let result = new OfferingDocumentModel();
        result.init(json);
        return result;
    }
}

export interface IOfferingDocumentModel {
    id?: string | undefined;
    displayName?: string | undefined;
    requiresClientUpload?: boolean;
    documentId?: string | undefined;
    document?: IDataFileModel | undefined;
    fileName?: string | undefined;
}

export class OfferingViewModel implements IOfferingViewModel {
    id?: string;
    title?: string | undefined;
    logo?: DataFileModel | undefined;
    shortDescription?: string | undefined;
    summary?: string | undefined;
    totalAllotment?: number | undefined;
    openingDate?: string | undefined;
    closingDate?: string | undefined;
    currency?: string | undefined;
    minimumQuantityValue?: number | undefined;
    shareIncrements?: number | undefined;
    refundInstructions?: string | undefined;
    termsAndConditions?: string | undefined;
    processingFee?: number | undefined;
    prospectusId?: string;
    prospectus?: DataFileModel | undefined;
    dividendMandate?: string | undefined;
    additionalInstructions?: string | undefined;
    sharePools?: SharePoolModel[] | undefined;
    status?: OfferingStatus;
    arrangerId?: string | undefined;
    arrangerName?: string | undefined;
    shortName?: string | undefined;
    leadBrokerId?: string | undefined;
    leadBrokerName?: string | undefined;
    coBrokersIds?: string[] | undefined;
    coBrokersNames?: string[] | undefined;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rejectionReasons?: OfferingRejectionReason[] | undefined;
    offeringType?: OfferingType | undefined;
    requiresAccreditedInvestor?: boolean;
    sharePoolCategoryName?: string | undefined;
    documents?: OfferingDocumentModel[] | undefined;
    readonly offeringHasGiftPool?: boolean;
    isPrivateListing?: boolean;

    constructor(data?: IOfferingViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.logo = data.logo && !(<any>data.logo).toJSON ? new DataFileModel(data.logo) : <DataFileModel>this.logo; 
            this.prospectus = data.prospectus && !(<any>data.prospectus).toJSON ? new DataFileModel(data.prospectus) : <DataFileModel>this.prospectus; 
            if (data.sharePools) {
                this.sharePools = [];
                for (let i = 0; i < data.sharePools.length; i++) {
                    let item = data.sharePools[i];
                    this.sharePools[i] = item && !(<any>item).toJSON ? new SharePoolModel(item) : <SharePoolModel>item;
                }
            }
            if (data.rejectionReasons) {
                this.rejectionReasons = [];
                for (let i = 0; i < data.rejectionReasons.length; i++) {
                    let item = data.rejectionReasons[i];
                    this.rejectionReasons[i] = item && !(<any>item).toJSON ? new OfferingRejectionReason(item) : <OfferingRejectionReason>item;
                }
            }
            if (data.documents) {
                this.documents = [];
                for (let i = 0; i < data.documents.length; i++) {
                    let item = data.documents[i];
                    this.documents[i] = item && !(<any>item).toJSON ? new OfferingDocumentModel(item) : <OfferingDocumentModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.logo = _data["logo"] ? DataFileModel.fromJS(_data["logo"]) : <any>undefined;
            this.shortDescription = _data["shortDescription"];
            this.summary = _data["summary"];
            this.totalAllotment = _data["totalAllotment"];
            this.openingDate = _data["openingDate"];
            this.closingDate = _data["closingDate"];
            this.currency = _data["currency"];
            this.minimumQuantityValue = _data["minimumQuantityValue"];
            this.shareIncrements = _data["shareIncrements"];
            this.refundInstructions = _data["refundInstructions"];
            this.termsAndConditions = _data["termsAndConditions"];
            this.processingFee = _data["processingFee"];
            this.prospectusId = _data["prospectusId"];
            this.prospectus = _data["prospectus"] ? DataFileModel.fromJS(_data["prospectus"]) : <any>undefined;
            this.dividendMandate = _data["dividendMandate"];
            this.additionalInstructions = _data["additionalInstructions"];
            if (Array.isArray(_data["sharePools"])) {
                this.sharePools = [] as any;
                for (let item of _data["sharePools"])
                    this.sharePools!.push(SharePoolModel.fromJS(item));
            }
            this.status = _data["status"];
            this.arrangerId = _data["arrangerId"];
            this.arrangerName = _data["arrangerName"];
            this.shortName = _data["shortName"];
            this.leadBrokerId = _data["leadBrokerId"];
            this.leadBrokerName = _data["leadBrokerName"];
            if (Array.isArray(_data["coBrokersIds"])) {
                this.coBrokersIds = [] as any;
                for (let item of _data["coBrokersIds"])
                    this.coBrokersIds!.push(item);
            }
            if (Array.isArray(_data["coBrokersNames"])) {
                this.coBrokersNames = [] as any;
                for (let item of _data["coBrokersNames"])
                    this.coBrokersNames!.push(item);
            }
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            if (Array.isArray(_data["rejectionReasons"])) {
                this.rejectionReasons = [] as any;
                for (let item of _data["rejectionReasons"])
                    this.rejectionReasons!.push(OfferingRejectionReason.fromJS(item));
            }
            this.offeringType = _data["offeringType"];
            this.requiresAccreditedInvestor = _data["requiresAccreditedInvestor"];
            this.sharePoolCategoryName = _data["sharePoolCategoryName"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(OfferingDocumentModel.fromJS(item));
            }
            (<any>this).offeringHasGiftPool = _data["offeringHasGiftPool"];
            this.isPrivateListing = _data["isPrivateListing"];
        }
    }

    static fromJS(data: any): OfferingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfferingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["logo"] = this.logo ? this.logo.toJSON() : <any>undefined;
        data["shortDescription"] = this.shortDescription;
        data["summary"] = this.summary;
        data["totalAllotment"] = this.totalAllotment;
        data["openingDate"] = this.openingDate;
        data["closingDate"] = this.closingDate;
        data["currency"] = this.currency;
        data["minimumQuantityValue"] = this.minimumQuantityValue;
        data["shareIncrements"] = this.shareIncrements;
        data["refundInstructions"] = this.refundInstructions;
        data["termsAndConditions"] = this.termsAndConditions;
        data["processingFee"] = this.processingFee;
        data["prospectusId"] = this.prospectusId;
        data["prospectus"] = this.prospectus ? this.prospectus.toJSON() : <any>undefined;
        data["dividendMandate"] = this.dividendMandate;
        data["additionalInstructions"] = this.additionalInstructions;
        if (Array.isArray(this.sharePools)) {
            data["sharePools"] = [];
            for (let item of this.sharePools)
                data["sharePools"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["arrangerId"] = this.arrangerId;
        data["arrangerName"] = this.arrangerName;
        data["shortName"] = this.shortName;
        data["leadBrokerId"] = this.leadBrokerId;
        data["leadBrokerName"] = this.leadBrokerName;
        if (Array.isArray(this.coBrokersIds)) {
            data["coBrokersIds"] = [];
            for (let item of this.coBrokersIds)
                data["coBrokersIds"].push(item);
        }
        if (Array.isArray(this.coBrokersNames)) {
            data["coBrokersNames"] = [];
            for (let item of this.coBrokersNames)
                data["coBrokersNames"].push(item);
        }
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        if (Array.isArray(this.rejectionReasons)) {
            data["rejectionReasons"] = [];
            for (let item of this.rejectionReasons)
                data["rejectionReasons"].push(item.toJSON());
        }
        data["offeringType"] = this.offeringType;
        data["requiresAccreditedInvestor"] = this.requiresAccreditedInvestor;
        data["sharePoolCategoryName"] = this.sharePoolCategoryName;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["offeringHasGiftPool"] = this.offeringHasGiftPool;
        data["isPrivateListing"] = this.isPrivateListing;
        return data; 
    }

    clone(): OfferingViewModel {
        const json = this.toJSON();
        let result = new OfferingViewModel();
        result.init(json);
        return result;
    }
}

export interface IOfferingViewModel {
    id?: string;
    title?: string | undefined;
    logo?: IDataFileModel | undefined;
    shortDescription?: string | undefined;
    summary?: string | undefined;
    totalAllotment?: number | undefined;
    openingDate?: string | undefined;
    closingDate?: string | undefined;
    currency?: string | undefined;
    minimumQuantityValue?: number | undefined;
    shareIncrements?: number | undefined;
    refundInstructions?: string | undefined;
    termsAndConditions?: string | undefined;
    processingFee?: number | undefined;
    prospectusId?: string;
    prospectus?: IDataFileModel | undefined;
    dividendMandate?: string | undefined;
    additionalInstructions?: string | undefined;
    sharePools?: ISharePoolModel[] | undefined;
    status?: OfferingStatus;
    arrangerId?: string | undefined;
    arrangerName?: string | undefined;
    shortName?: string | undefined;
    leadBrokerId?: string | undefined;
    leadBrokerName?: string | undefined;
    coBrokersIds?: string[] | undefined;
    coBrokersNames?: string[] | undefined;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rejectionReasons?: IOfferingRejectionReason[] | undefined;
    offeringType?: OfferingType | undefined;
    requiresAccreditedInvestor?: boolean;
    sharePoolCategoryName?: string | undefined;
    documents?: IOfferingDocumentModel[] | undefined;
    offeringHasGiftPool?: boolean;
    isPrivateListing?: boolean;
}

export class GetOfferingsViewModelByIdForCustomerQueryResponse implements IGetOfferingsViewModelByIdForCustomerQueryResponse {
    offering?: OfferingViewModel | undefined;

    constructor(data?: IGetOfferingsViewModelByIdForCustomerQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.offering = data.offering && !(<any>data.offering).toJSON ? new OfferingViewModel(data.offering) : <OfferingViewModel>this.offering; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offering = _data["offering"] ? OfferingViewModel.fromJS(_data["offering"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetOfferingsViewModelByIdForCustomerQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetOfferingsViewModelByIdForCustomerQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offering"] = this.offering ? this.offering.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetOfferingsViewModelByIdForCustomerQueryResponse {
        const json = this.toJSON();
        let result = new GetOfferingsViewModelByIdForCustomerQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetOfferingsViewModelByIdForCustomerQueryResponse {
    offering?: IOfferingViewModel | undefined;
}

export class GetSharePoolsByOfferingIdQueryRequest implements IGetSharePoolsByOfferingIdQueryRequest {
    offeringId?: string;

    constructor(data?: IGetSharePoolsByOfferingIdQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.offeringId = _data["offeringId"];
        }
    }

    static fromJS(data: any): GetSharePoolsByOfferingIdQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSharePoolsByOfferingIdQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["offeringId"] = this.offeringId;
        return data; 
    }

    clone(): GetSharePoolsByOfferingIdQueryRequest {
        const json = this.toJSON();
        let result = new GetSharePoolsByOfferingIdQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetSharePoolsByOfferingIdQueryRequest {
    offeringId?: string;
}

export class GetSharePoolsByOfferingIdQueryResponse implements IGetSharePoolsByOfferingIdQueryResponse {
    sharePools?: SharePoolModel[] | undefined;

    constructor(data?: IGetSharePoolsByOfferingIdQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.sharePools) {
                this.sharePools = [];
                for (let i = 0; i < data.sharePools.length; i++) {
                    let item = data.sharePools[i];
                    this.sharePools[i] = item && !(<any>item).toJSON ? new SharePoolModel(item) : <SharePoolModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sharePools"])) {
                this.sharePools = [] as any;
                for (let item of _data["sharePools"])
                    this.sharePools!.push(SharePoolModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSharePoolsByOfferingIdQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSharePoolsByOfferingIdQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sharePools)) {
            data["sharePools"] = [];
            for (let item of this.sharePools)
                data["sharePools"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetSharePoolsByOfferingIdQueryResponse {
        const json = this.toJSON();
        let result = new GetSharePoolsByOfferingIdQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetSharePoolsByOfferingIdQueryResponse {
    sharePools?: ISharePoolModel[] | undefined;
}

export class GetJointHoldersForAccountRequest implements IGetJointHoldersForAccountRequest {
    id?: string | undefined;

    constructor(data?: IGetJointHoldersForAccountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetJointHoldersForAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointHoldersForAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): GetJointHoldersForAccountRequest {
        const json = this.toJSON();
        let result = new GetJointHoldersForAccountRequest();
        result.init(json);
        return result;
    }
}

export interface IGetJointHoldersForAccountRequest {
    id?: string | undefined;
}

export class GetJointHoldersForAccountResponse implements IGetJointHoldersForAccountResponse {
    accountHolders?: AccountHolder[] | undefined;

    constructor(data?: IGetJointHoldersForAccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.accountHolders) {
                this.accountHolders = [];
                for (let i = 0; i < data.accountHolders.length; i++) {
                    let item = data.accountHolders[i];
                    this.accountHolders[i] = item && !(<any>item).toJSON ? new AccountHolder(item) : <AccountHolder>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accountHolders"])) {
                this.accountHolders = [] as any;
                for (let item of _data["accountHolders"])
                    this.accountHolders!.push(AccountHolder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJointHoldersForAccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointHoldersForAccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accountHolders)) {
            data["accountHolders"] = [];
            for (let item of this.accountHolders)
                data["accountHolders"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetJointHoldersForAccountResponse {
        const json = this.toJSON();
        let result = new GetJointHoldersForAccountResponse();
        result.init(json);
        return result;
    }
}

export interface IGetJointHoldersForAccountResponse {
    accountHolders?: IAccountHolder[] | undefined;
}

export class GetJointHoldersForGuestAccountRequest implements IGetJointHoldersForGuestAccountRequest {
    id?: string | undefined;

    constructor(data?: IGetJointHoldersForGuestAccountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetJointHoldersForGuestAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointHoldersForGuestAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): GetJointHoldersForGuestAccountRequest {
        const json = this.toJSON();
        let result = new GetJointHoldersForGuestAccountRequest();
        result.init(json);
        return result;
    }
}

export interface IGetJointHoldersForGuestAccountRequest {
    id?: string | undefined;
}

export class GetJointHoldersForGuestAccountResponse implements IGetJointHoldersForGuestAccountResponse {
    accountHolders?: AccountHolder[] | undefined;

    constructor(data?: IGetJointHoldersForGuestAccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.accountHolders) {
                this.accountHolders = [];
                for (let i = 0; i < data.accountHolders.length; i++) {
                    let item = data.accountHolders[i];
                    this.accountHolders[i] = item && !(<any>item).toJSON ? new AccountHolder(item) : <AccountHolder>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accountHolders"])) {
                this.accountHolders = [] as any;
                for (let item of _data["accountHolders"])
                    this.accountHolders!.push(AccountHolder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetJointHoldersForGuestAccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetJointHoldersForGuestAccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accountHolders)) {
            data["accountHolders"] = [];
            for (let item of this.accountHolders)
                data["accountHolders"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetJointHoldersForGuestAccountResponse {
        const json = this.toJSON();
        let result = new GetJointHoldersForGuestAccountResponse();
        result.init(json);
        return result;
    }
}

export interface IGetJointHoldersForGuestAccountResponse {
    accountHolders?: IAccountHolder[] | undefined;
}

export class WebGiftedSharesModel implements IWebGiftedSharesModel {
    name?: string | undefined;
    email?: string | undefined;
    jcsdNumber?: string | undefined;
    numberOfShares?: number | undefined;

    constructor(data?: IWebGiftedSharesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.jcsdNumber = _data["jcsdNumber"];
            this.numberOfShares = _data["numberOfShares"];
        }
    }

    static fromJS(data: any): WebGiftedSharesModel {
        data = typeof data === 'object' ? data : {};
        let result = new WebGiftedSharesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["jcsdNumber"] = this.jcsdNumber;
        data["numberOfShares"] = this.numberOfShares;
        return data; 
    }

    clone(): WebGiftedSharesModel {
        const json = this.toJSON();
        let result = new WebGiftedSharesModel();
        result.init(json);
        return result;
    }
}

export interface IWebGiftedSharesModel {
    name?: string | undefined;
    email?: string | undefined;
    jcsdNumber?: string | undefined;
    numberOfShares?: number | undefined;
}

export class ApplicationDocumentUploadModel implements IApplicationDocumentUploadModel {
    id?: string;
    document?: string | undefined;
    inUse?: boolean;

    constructor(data?: IApplicationDocumentUploadModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.document = _data["document"];
            this.inUse = _data["inUse"];
        }
    }

    static fromJS(data: any): ApplicationDocumentUploadModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationDocumentUploadModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["document"] = this.document;
        data["inUse"] = this.inUse;
        return data; 
    }

    clone(): ApplicationDocumentUploadModel {
        const json = this.toJSON();
        let result = new ApplicationDocumentUploadModel();
        result.init(json);
        return result;
    }
}

export interface IApplicationDocumentUploadModel {
    id?: string;
    document?: string | undefined;
    inUse?: boolean;
}

export class WebApplicationModel implements IWebApplicationModel {
    applicationId?: string | undefined;
    sharePoolId?: string | undefined;
    offeringId?: string | undefined;
    accountId?: string | undefined;
    paymentMethod?: PaymentMethod | undefined;
    proofOfPayment?: string | undefined;
    sharesRequested?: number;
    amountPayable?: number;
    referenceNumber?: string | undefined;
    currency?: string | undefined;
    comments?: string | undefined;
    bankName?: string | undefined;
    branchName?: string | undefined;
    holderId1?: string | undefined;
    holderId2?: string | undefined;
    holderId3?: string | undefined;
    holderId4?: string | undefined;
    signatureFile1?: string | undefined;
    signatureFile2?: string | undefined;
    signatureFile3?: string | undefined;
    signatureFile4?: string | undefined;
    giftedShares?: WebGiftedSharesModel[] | undefined;
    paymentOrderId?: string | undefined;
    documents?: ApplicationDocumentUploadModel[] | undefined;
    isGuestApplication?: boolean;
    paymentMandateId?: string | undefined;
    paymentMandateBank?: string | undefined;
    paymentMandateBranch?: string | undefined;
    paymentMandateAccountType?: string | undefined;
    paymentMandateCurrency?: string | undefined;
    paymentMandateNameOnAccount?: string | undefined;
    paymentMandateAccountNumber?: string | undefined;
    paymentMandateAccountNickname?: string | undefined;

    constructor(data?: IWebApplicationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.giftedShares) {
                this.giftedShares = [];
                for (let i = 0; i < data.giftedShares.length; i++) {
                    let item = data.giftedShares[i];
                    this.giftedShares[i] = item && !(<any>item).toJSON ? new WebGiftedSharesModel(item) : <WebGiftedSharesModel>item;
                }
            }
            if (data.documents) {
                this.documents = [];
                for (let i = 0; i < data.documents.length; i++) {
                    let item = data.documents[i];
                    this.documents[i] = item && !(<any>item).toJSON ? new ApplicationDocumentUploadModel(item) : <ApplicationDocumentUploadModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.sharePoolId = _data["sharePoolId"];
            this.offeringId = _data["offeringId"];
            this.accountId = _data["accountId"];
            this.paymentMethod = _data["paymentMethod"];
            this.proofOfPayment = _data["proofOfPayment"];
            this.sharesRequested = _data["sharesRequested"];
            this.amountPayable = _data["amountPayable"];
            this.referenceNumber = _data["referenceNumber"];
            this.currency = _data["currency"];
            this.comments = _data["comments"];
            this.bankName = _data["bankName"];
            this.branchName = _data["branchName"];
            this.holderId1 = _data["holderId1"];
            this.holderId2 = _data["holderId2"];
            this.holderId3 = _data["holderId3"];
            this.holderId4 = _data["holderId4"];
            this.signatureFile1 = _data["signatureFile1"];
            this.signatureFile2 = _data["signatureFile2"];
            this.signatureFile3 = _data["signatureFile3"];
            this.signatureFile4 = _data["signatureFile4"];
            if (Array.isArray(_data["giftedShares"])) {
                this.giftedShares = [] as any;
                for (let item of _data["giftedShares"])
                    this.giftedShares!.push(WebGiftedSharesModel.fromJS(item));
            }
            this.paymentOrderId = _data["paymentOrderId"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(ApplicationDocumentUploadModel.fromJS(item));
            }
            this.isGuestApplication = _data["isGuestApplication"];
            this.paymentMandateId = _data["paymentMandateId"];
            this.paymentMandateBank = _data["paymentMandateBank"];
            this.paymentMandateBranch = _data["paymentMandateBranch"];
            this.paymentMandateAccountType = _data["paymentMandateAccountType"];
            this.paymentMandateCurrency = _data["paymentMandateCurrency"];
            this.paymentMandateNameOnAccount = _data["paymentMandateNameOnAccount"];
            this.paymentMandateAccountNumber = _data["paymentMandateAccountNumber"];
            this.paymentMandateAccountNickname = _data["paymentMandateAccountNickname"];
        }
    }

    static fromJS(data: any): WebApplicationModel {
        data = typeof data === 'object' ? data : {};
        let result = new WebApplicationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["sharePoolId"] = this.sharePoolId;
        data["offeringId"] = this.offeringId;
        data["accountId"] = this.accountId;
        data["paymentMethod"] = this.paymentMethod;
        data["proofOfPayment"] = this.proofOfPayment;
        data["sharesRequested"] = this.sharesRequested;
        data["amountPayable"] = this.amountPayable;
        data["referenceNumber"] = this.referenceNumber;
        data["currency"] = this.currency;
        data["comments"] = this.comments;
        data["bankName"] = this.bankName;
        data["branchName"] = this.branchName;
        data["holderId1"] = this.holderId1;
        data["holderId2"] = this.holderId2;
        data["holderId3"] = this.holderId3;
        data["holderId4"] = this.holderId4;
        data["signatureFile1"] = this.signatureFile1;
        data["signatureFile2"] = this.signatureFile2;
        data["signatureFile3"] = this.signatureFile3;
        data["signatureFile4"] = this.signatureFile4;
        if (Array.isArray(this.giftedShares)) {
            data["giftedShares"] = [];
            for (let item of this.giftedShares)
                data["giftedShares"].push(item.toJSON());
        }
        data["paymentOrderId"] = this.paymentOrderId;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["isGuestApplication"] = this.isGuestApplication;
        data["paymentMandateId"] = this.paymentMandateId;
        data["paymentMandateBank"] = this.paymentMandateBank;
        data["paymentMandateBranch"] = this.paymentMandateBranch;
        data["paymentMandateAccountType"] = this.paymentMandateAccountType;
        data["paymentMandateCurrency"] = this.paymentMandateCurrency;
        data["paymentMandateNameOnAccount"] = this.paymentMandateNameOnAccount;
        data["paymentMandateAccountNumber"] = this.paymentMandateAccountNumber;
        data["paymentMandateAccountNickname"] = this.paymentMandateAccountNickname;
        return data; 
    }

    clone(): WebApplicationModel {
        const json = this.toJSON();
        let result = new WebApplicationModel();
        result.init(json);
        return result;
    }
}

export interface IWebApplicationModel {
    applicationId?: string | undefined;
    sharePoolId?: string | undefined;
    offeringId?: string | undefined;
    accountId?: string | undefined;
    paymentMethod?: PaymentMethod | undefined;
    proofOfPayment?: string | undefined;
    sharesRequested?: number;
    amountPayable?: number;
    referenceNumber?: string | undefined;
    currency?: string | undefined;
    comments?: string | undefined;
    bankName?: string | undefined;
    branchName?: string | undefined;
    holderId1?: string | undefined;
    holderId2?: string | undefined;
    holderId3?: string | undefined;
    holderId4?: string | undefined;
    signatureFile1?: string | undefined;
    signatureFile2?: string | undefined;
    signatureFile3?: string | undefined;
    signatureFile4?: string | undefined;
    giftedShares?: IWebGiftedSharesModel[] | undefined;
    paymentOrderId?: string | undefined;
    documents?: IApplicationDocumentUploadModel[] | undefined;
    isGuestApplication?: boolean;
    paymentMandateId?: string | undefined;
    paymentMandateBank?: string | undefined;
    paymentMandateBranch?: string | undefined;
    paymentMandateAccountType?: string | undefined;
    paymentMandateCurrency?: string | undefined;
    paymentMandateNameOnAccount?: string | undefined;
    paymentMandateAccountNumber?: string | undefined;
    paymentMandateAccountNickname?: string | undefined;
}

export class ProcessSubscriptionCommandResponse implements IProcessSubscriptionCommandResponse {
    referenceNumber?: string | undefined;
    success?: boolean;

    constructor(data?: IProcessSubscriptionCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceNumber = _data["referenceNumber"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): ProcessSubscriptionCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessSubscriptionCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceNumber"] = this.referenceNumber;
        data["success"] = this.success;
        return data; 
    }

    clone(): ProcessSubscriptionCommandResponse {
        const json = this.toJSON();
        let result = new ProcessSubscriptionCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IProcessSubscriptionCommandResponse {
    referenceNumber?: string | undefined;
    success?: boolean;
}

export class ResumeGuestApplicationCommandRequest implements IResumeGuestApplicationCommandRequest {
    applicationId?: number | undefined;
    email?: string | undefined;

    constructor(data?: IResumeGuestApplicationCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ResumeGuestApplicationCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeGuestApplicationCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["email"] = this.email;
        return data; 
    }

    clone(): ResumeGuestApplicationCommandRequest {
        const json = this.toJSON();
        let result = new ResumeGuestApplicationCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IResumeGuestApplicationCommandRequest {
    applicationId?: number | undefined;
    email?: string | undefined;
}

export class ResumeGuestApplicationCommandResponse implements IResumeGuestApplicationCommandResponse {
    id?: string | undefined;
    appId?: string | undefined;
    offeringId?: string | undefined;
    success?: boolean;

    constructor(data?: IResumeGuestApplicationCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.appId = _data["appId"];
            this.offeringId = _data["offeringId"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): ResumeGuestApplicationCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResumeGuestApplicationCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["appId"] = this.appId;
        data["offeringId"] = this.offeringId;
        data["success"] = this.success;
        return data; 
    }

    clone(): ResumeGuestApplicationCommandResponse {
        const json = this.toJSON();
        let result = new ResumeGuestApplicationCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IResumeGuestApplicationCommandResponse {
    id?: string | undefined;
    appId?: string | undefined;
    offeringId?: string | undefined;
    success?: boolean;
}

export class EditApplicationCommandResponse implements IEditApplicationCommandResponse {
    success?: boolean;

    constructor(data?: IEditApplicationCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): EditApplicationCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditApplicationCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data; 
    }

    clone(): EditApplicationCommandResponse {
        const json = this.toJSON();
        let result = new EditApplicationCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IEditApplicationCommandResponse {
    success?: boolean;
}

export class CancelApplicationCommandRequest implements ICancelApplicationCommandRequest {
    applicationId?: string | undefined;

    constructor(data?: ICancelApplicationCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
        }
    }

    static fromJS(data: any): CancelApplicationCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CancelApplicationCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        return data; 
    }

    clone(): CancelApplicationCommandRequest {
        const json = this.toJSON();
        let result = new CancelApplicationCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ICancelApplicationCommandRequest {
    applicationId?: string | undefined;
}

export class PaymentConfirmation implements IPaymentConfirmation {
    confirmationOfPayment?: DataFile | undefined;
    confirmationOfPaymentId?: string | undefined;
    paymentDate?: string | undefined;
    confirmedPaymentAmount?: number | undefined;
    confirmedReferenceNumber?: string | undefined;
    secondApprovalRequired?: boolean;
    secondApprover?: string | undefined;
    secondApprovalDate?: string | undefined;
    secondApproverId?: string | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IPaymentConfirmation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.confirmationOfPayment = data.confirmationOfPayment && !(<any>data.confirmationOfPayment).toJSON ? new DataFile(data.confirmationOfPayment) : <DataFile>this.confirmationOfPayment; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.confirmationOfPayment = _data["confirmationOfPayment"] ? DataFile.fromJS(_data["confirmationOfPayment"]) : <any>undefined;
            this.confirmationOfPaymentId = _data["confirmationOfPaymentId"];
            this.paymentDate = _data["paymentDate"];
            this.confirmedPaymentAmount = _data["confirmedPaymentAmount"];
            this.confirmedReferenceNumber = _data["confirmedReferenceNumber"];
            this.secondApprovalRequired = _data["secondApprovalRequired"];
            this.secondApprover = _data["secondApprover"];
            this.secondApprovalDate = _data["secondApprovalDate"];
            this.secondApproverId = _data["secondApproverId"];
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): PaymentConfirmation {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentConfirmation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confirmationOfPayment"] = this.confirmationOfPayment ? this.confirmationOfPayment.toJSON() : <any>undefined;
        data["confirmationOfPaymentId"] = this.confirmationOfPaymentId;
        data["paymentDate"] = this.paymentDate;
        data["confirmedPaymentAmount"] = this.confirmedPaymentAmount;
        data["confirmedReferenceNumber"] = this.confirmedReferenceNumber;
        data["secondApprovalRequired"] = this.secondApprovalRequired;
        data["secondApprover"] = this.secondApprover;
        data["secondApprovalDate"] = this.secondApprovalDate;
        data["secondApproverId"] = this.secondApproverId;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): PaymentConfirmation {
        const json = this.toJSON();
        let result = new PaymentConfirmation();
        result.init(json);
        return result;
    }
}

export interface IPaymentConfirmation {
    confirmationOfPayment?: IDataFile | undefined;
    confirmationOfPaymentId?: string | undefined;
    paymentDate?: string | undefined;
    confirmedPaymentAmount?: number | undefined;
    confirmedReferenceNumber?: string | undefined;
    secondApprovalRequired?: boolean;
    secondApprover?: string | undefined;
    secondApprovalDate?: string | undefined;
    secondApproverId?: string | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class PaymentConfirmationFileModel implements IPaymentConfirmationFileModel {
    fileName?: string | undefined;
    paymentConfirmationId?: string | undefined;
    paymentConfirmationFile?: DataFileModel | undefined;

    constructor(data?: IPaymentConfirmationFileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.paymentConfirmationFile = data.paymentConfirmationFile && !(<any>data.paymentConfirmationFile).toJSON ? new DataFileModel(data.paymentConfirmationFile) : <DataFileModel>this.paymentConfirmationFile; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.paymentConfirmationId = _data["paymentConfirmationId"];
            this.paymentConfirmationFile = _data["paymentConfirmationFile"] ? DataFileModel.fromJS(_data["paymentConfirmationFile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentConfirmationFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentConfirmationFileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["paymentConfirmationId"] = this.paymentConfirmationId;
        data["paymentConfirmationFile"] = this.paymentConfirmationFile ? this.paymentConfirmationFile.toJSON() : <any>undefined;
        return data; 
    }

    clone(): PaymentConfirmationFileModel {
        const json = this.toJSON();
        let result = new PaymentConfirmationFileModel();
        result.init(json);
        return result;
    }
}

export interface IPaymentConfirmationFileModel {
    fileName?: string | undefined;
    paymentConfirmationId?: string | undefined;
    paymentConfirmationFile?: IDataFileModel | undefined;
}

export class ApplicationSignatureModel implements IApplicationSignatureModel {
    accountHolderName?: string | undefined;
    accountHolderId?: string | undefined;
    signatureFileId?: string | undefined;
    signatureFile?: DataFileModel | undefined;

    constructor(data?: IApplicationSignatureModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.signatureFile = data.signatureFile && !(<any>data.signatureFile).toJSON ? new DataFileModel(data.signatureFile) : <DataFileModel>this.signatureFile; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountHolderName = _data["accountHolderName"];
            this.accountHolderId = _data["accountHolderId"];
            this.signatureFileId = _data["signatureFileId"];
            this.signatureFile = _data["signatureFile"] ? DataFileModel.fromJS(_data["signatureFile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicationSignatureModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationSignatureModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountHolderName"] = this.accountHolderName;
        data["accountHolderId"] = this.accountHolderId;
        data["signatureFileId"] = this.signatureFileId;
        data["signatureFile"] = this.signatureFile ? this.signatureFile.toJSON() : <any>undefined;
        return data; 
    }

    clone(): ApplicationSignatureModel {
        const json = this.toJSON();
        let result = new ApplicationSignatureModel();
        result.init(json);
        return result;
    }
}

export interface IApplicationSignatureModel {
    accountHolderName?: string | undefined;
    accountHolderId?: string | undefined;
    signatureFileId?: string | undefined;
    signatureFile?: IDataFileModel | undefined;
}

export class ApplicataionDocumentViewModel implements IApplicataionDocumentViewModel {
    id?: string;
    document?: OfferingDocumentModel | undefined;
    uploadedFile?: DataFileModel | undefined;

    constructor(data?: IApplicataionDocumentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.document = data.document && !(<any>data.document).toJSON ? new OfferingDocumentModel(data.document) : <OfferingDocumentModel>this.document; 
            this.uploadedFile = data.uploadedFile && !(<any>data.uploadedFile).toJSON ? new DataFileModel(data.uploadedFile) : <DataFileModel>this.uploadedFile; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.document = _data["document"] ? OfferingDocumentModel.fromJS(_data["document"]) : <any>undefined;
            this.uploadedFile = _data["uploadedFile"] ? DataFileModel.fromJS(_data["uploadedFile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicataionDocumentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicataionDocumentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["uploadedFile"] = this.uploadedFile ? this.uploadedFile.toJSON() : <any>undefined;
        return data; 
    }

    clone(): ApplicataionDocumentViewModel {
        const json = this.toJSON();
        let result = new ApplicataionDocumentViewModel();
        result.init(json);
        return result;
    }
}

export interface IApplicataionDocumentViewModel {
    id?: string;
    document?: IOfferingDocumentModel | undefined;
    uploadedFile?: IDataFileModel | undefined;
}

export class GuestUser implements IGuestUser {
    userId?: string;
    user?: User | undefined;
    firstName?: string | undefined;
    middleInitial?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    trn?: string | undefined;
    accountNumber?: string | undefined;
    brokerId?: string;
    broker?: Broker | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IGuestUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user; 
            this.broker = data.broker && !(<any>data.broker).toJSON ? new Broker(data.broker) : <Broker>this.broker; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.firstName = _data["firstName"];
            this.middleInitial = _data["middleInitial"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.trn = _data["trn"];
            this.accountNumber = _data["accountNumber"];
            this.brokerId = _data["brokerId"];
            this.broker = _data["broker"] ? Broker.fromJS(_data["broker"]) : <any>undefined;
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): GuestUser {
        data = typeof data === 'object' ? data : {};
        let result = new GuestUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["firstName"] = this.firstName;
        data["middleInitial"] = this.middleInitial;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["trn"] = this.trn;
        data["accountNumber"] = this.accountNumber;
        data["brokerId"] = this.brokerId;
        data["broker"] = this.broker ? this.broker.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): GuestUser {
        const json = this.toJSON();
        let result = new GuestUser();
        result.init(json);
        return result;
    }
}

export interface IGuestUser {
    userId?: string;
    user?: IUser | undefined;
    firstName?: string | undefined;
    middleInitial?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    trn?: string | undefined;
    accountNumber?: string | undefined;
    brokerId?: string;
    broker?: IBroker | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class ApplicationViewModel implements IApplicationViewModel {
    applicationId?: string | undefined;
    sharePoolId?: string | undefined;
    offeringId?: string | undefined;
    accountId?: string | undefined;
    userId?: string | undefined;
    applicationNumber?: string | undefined;
    referenceNumber?: string | undefined;
    paymentMethod?: PaymentMethod | undefined;
    bankName?: string | undefined;
    branchName?: string | undefined;
    paymentComment?: string | undefined;
    proofOfPayment?: DataFile | undefined;
    proofOfPaymentFile?: DataFileModel | undefined;
    proofOfPaymentId?: string | undefined;
    sharesRequested?: number;
    amountDue?: number;
    dateSubmitted?: string | undefined;
    internalComment?: string | undefined;
    rejectionReason?: string | undefined;
    dateRejected?: string | undefined;
    paymentConfirmation?: PaymentConfirmation | undefined;
    paymentConfirmationFile?: PaymentConfirmationFileModel | undefined;
    clientName?: string | undefined;
    status?: ApplicationStatus;
    user?: User | undefined;
    offering?: Offering | undefined;
    account?: Account | undefined;
    sharePool?: SharePool | undefined;
    signatures?: ApplicationSignatureModel[] | undefined;
    uploadedDocuments?: ApplicataionDocumentViewModel[] | undefined;
    paymentMandate?: PaymentMandate | undefined;
    isGuestApplication?: boolean;
    guestUser?: GuestUser | undefined;
    clientInfo?: ClientInfo | undefined;

    constructor(data?: IApplicationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.proofOfPayment = data.proofOfPayment && !(<any>data.proofOfPayment).toJSON ? new DataFile(data.proofOfPayment) : <DataFile>this.proofOfPayment; 
            this.proofOfPaymentFile = data.proofOfPaymentFile && !(<any>data.proofOfPaymentFile).toJSON ? new DataFileModel(data.proofOfPaymentFile) : <DataFileModel>this.proofOfPaymentFile; 
            this.paymentConfirmation = data.paymentConfirmation && !(<any>data.paymentConfirmation).toJSON ? new PaymentConfirmation(data.paymentConfirmation) : <PaymentConfirmation>this.paymentConfirmation; 
            this.paymentConfirmationFile = data.paymentConfirmationFile && !(<any>data.paymentConfirmationFile).toJSON ? new PaymentConfirmationFileModel(data.paymentConfirmationFile) : <PaymentConfirmationFileModel>this.paymentConfirmationFile; 
            this.user = data.user && !(<any>data.user).toJSON ? new User(data.user) : <User>this.user; 
            this.offering = data.offering && !(<any>data.offering).toJSON ? new Offering(data.offering) : <Offering>this.offering; 
            this.account = data.account && !(<any>data.account).toJSON ? new Account(data.account) : <Account>this.account; 
            this.sharePool = data.sharePool && !(<any>data.sharePool).toJSON ? new SharePool(data.sharePool) : <SharePool>this.sharePool; 
            if (data.signatures) {
                this.signatures = [];
                for (let i = 0; i < data.signatures.length; i++) {
                    let item = data.signatures[i];
                    this.signatures[i] = item && !(<any>item).toJSON ? new ApplicationSignatureModel(item) : <ApplicationSignatureModel>item;
                }
            }
            if (data.uploadedDocuments) {
                this.uploadedDocuments = [];
                for (let i = 0; i < data.uploadedDocuments.length; i++) {
                    let item = data.uploadedDocuments[i];
                    this.uploadedDocuments[i] = item && !(<any>item).toJSON ? new ApplicataionDocumentViewModel(item) : <ApplicataionDocumentViewModel>item;
                }
            }
            this.paymentMandate = data.paymentMandate && !(<any>data.paymentMandate).toJSON ? new PaymentMandate(data.paymentMandate) : <PaymentMandate>this.paymentMandate; 
            this.guestUser = data.guestUser && !(<any>data.guestUser).toJSON ? new GuestUser(data.guestUser) : <GuestUser>this.guestUser; 
            this.clientInfo = data.clientInfo && !(<any>data.clientInfo).toJSON ? new ClientInfo(data.clientInfo) : <ClientInfo>this.clientInfo; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.sharePoolId = _data["sharePoolId"];
            this.offeringId = _data["offeringId"];
            this.accountId = _data["accountId"];
            this.userId = _data["userId"];
            this.applicationNumber = _data["applicationNumber"];
            this.referenceNumber = _data["referenceNumber"];
            this.paymentMethod = _data["paymentMethod"];
            this.bankName = _data["bankName"];
            this.branchName = _data["branchName"];
            this.paymentComment = _data["paymentComment"];
            this.proofOfPayment = _data["proofOfPayment"] ? DataFile.fromJS(_data["proofOfPayment"]) : <any>undefined;
            this.proofOfPaymentFile = _data["proofOfPaymentFile"] ? DataFileModel.fromJS(_data["proofOfPaymentFile"]) : <any>undefined;
            this.proofOfPaymentId = _data["proofOfPaymentId"];
            this.sharesRequested = _data["sharesRequested"];
            this.amountDue = _data["amountDue"];
            this.dateSubmitted = _data["dateSubmitted"];
            this.internalComment = _data["internalComment"];
            this.rejectionReason = _data["rejectionReason"];
            this.dateRejected = _data["dateRejected"];
            this.paymentConfirmation = _data["paymentConfirmation"] ? PaymentConfirmation.fromJS(_data["paymentConfirmation"]) : <any>undefined;
            this.paymentConfirmationFile = _data["paymentConfirmationFile"] ? PaymentConfirmationFileModel.fromJS(_data["paymentConfirmationFile"]) : <any>undefined;
            this.clientName = _data["clientName"];
            this.status = _data["status"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.offering = _data["offering"] ? Offering.fromJS(_data["offering"]) : <any>undefined;
            this.account = _data["account"] ? Account.fromJS(_data["account"]) : <any>undefined;
            this.sharePool = _data["sharePool"] ? SharePool.fromJS(_data["sharePool"]) : <any>undefined;
            if (Array.isArray(_data["signatures"])) {
                this.signatures = [] as any;
                for (let item of _data["signatures"])
                    this.signatures!.push(ApplicationSignatureModel.fromJS(item));
            }
            if (Array.isArray(_data["uploadedDocuments"])) {
                this.uploadedDocuments = [] as any;
                for (let item of _data["uploadedDocuments"])
                    this.uploadedDocuments!.push(ApplicataionDocumentViewModel.fromJS(item));
            }
            this.paymentMandate = _data["paymentMandate"] ? PaymentMandate.fromJS(_data["paymentMandate"]) : <any>undefined;
            this.isGuestApplication = _data["isGuestApplication"];
            this.guestUser = _data["guestUser"] ? GuestUser.fromJS(_data["guestUser"]) : <any>undefined;
            this.clientInfo = _data["clientInfo"] ? ClientInfo.fromJS(_data["clientInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["sharePoolId"] = this.sharePoolId;
        data["offeringId"] = this.offeringId;
        data["accountId"] = this.accountId;
        data["userId"] = this.userId;
        data["applicationNumber"] = this.applicationNumber;
        data["referenceNumber"] = this.referenceNumber;
        data["paymentMethod"] = this.paymentMethod;
        data["bankName"] = this.bankName;
        data["branchName"] = this.branchName;
        data["paymentComment"] = this.paymentComment;
        data["proofOfPayment"] = this.proofOfPayment ? this.proofOfPayment.toJSON() : <any>undefined;
        data["proofOfPaymentFile"] = this.proofOfPaymentFile ? this.proofOfPaymentFile.toJSON() : <any>undefined;
        data["proofOfPaymentId"] = this.proofOfPaymentId;
        data["sharesRequested"] = this.sharesRequested;
        data["amountDue"] = this.amountDue;
        data["dateSubmitted"] = this.dateSubmitted;
        data["internalComment"] = this.internalComment;
        data["rejectionReason"] = this.rejectionReason;
        data["dateRejected"] = this.dateRejected;
        data["paymentConfirmation"] = this.paymentConfirmation ? this.paymentConfirmation.toJSON() : <any>undefined;
        data["paymentConfirmationFile"] = this.paymentConfirmationFile ? this.paymentConfirmationFile.toJSON() : <any>undefined;
        data["clientName"] = this.clientName;
        data["status"] = this.status;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["offering"] = this.offering ? this.offering.toJSON() : <any>undefined;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["sharePool"] = this.sharePool ? this.sharePool.toJSON() : <any>undefined;
        if (Array.isArray(this.signatures)) {
            data["signatures"] = [];
            for (let item of this.signatures)
                data["signatures"].push(item.toJSON());
        }
        if (Array.isArray(this.uploadedDocuments)) {
            data["uploadedDocuments"] = [];
            for (let item of this.uploadedDocuments)
                data["uploadedDocuments"].push(item.toJSON());
        }
        data["paymentMandate"] = this.paymentMandate ? this.paymentMandate.toJSON() : <any>undefined;
        data["isGuestApplication"] = this.isGuestApplication;
        data["guestUser"] = this.guestUser ? this.guestUser.toJSON() : <any>undefined;
        data["clientInfo"] = this.clientInfo ? this.clientInfo.toJSON() : <any>undefined;
        return data; 
    }

    clone(): ApplicationViewModel {
        const json = this.toJSON();
        let result = new ApplicationViewModel();
        result.init(json);
        return result;
    }
}

export interface IApplicationViewModel {
    applicationId?: string | undefined;
    sharePoolId?: string | undefined;
    offeringId?: string | undefined;
    accountId?: string | undefined;
    userId?: string | undefined;
    applicationNumber?: string | undefined;
    referenceNumber?: string | undefined;
    paymentMethod?: PaymentMethod | undefined;
    bankName?: string | undefined;
    branchName?: string | undefined;
    paymentComment?: string | undefined;
    proofOfPayment?: IDataFile | undefined;
    proofOfPaymentFile?: IDataFileModel | undefined;
    proofOfPaymentId?: string | undefined;
    sharesRequested?: number;
    amountDue?: number;
    dateSubmitted?: string | undefined;
    internalComment?: string | undefined;
    rejectionReason?: string | undefined;
    dateRejected?: string | undefined;
    paymentConfirmation?: IPaymentConfirmation | undefined;
    paymentConfirmationFile?: IPaymentConfirmationFileModel | undefined;
    clientName?: string | undefined;
    status?: ApplicationStatus;
    user?: IUser | undefined;
    offering?: IOffering | undefined;
    account?: IAccount | undefined;
    sharePool?: ISharePool | undefined;
    signatures?: IApplicationSignatureModel[] | undefined;
    uploadedDocuments?: IApplicataionDocumentViewModel[] | undefined;
    paymentMandate?: IPaymentMandate | undefined;
    isGuestApplication?: boolean;
    guestUser?: IGuestUser | undefined;
    clientInfo?: IClientInfo | undefined;
}

export class CancelApplicationCommandResponse implements ICancelApplicationCommandResponse {
    success?: boolean;
    application?: ApplicationViewModel | undefined;

    constructor(data?: ICancelApplicationCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.application = data.application && !(<any>data.application).toJSON ? new ApplicationViewModel(data.application) : <ApplicationViewModel>this.application; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.application = _data["application"] ? ApplicationViewModel.fromJS(_data["application"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CancelApplicationCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CancelApplicationCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        return data; 
    }

    clone(): CancelApplicationCommandResponse {
        const json = this.toJSON();
        let result = new CancelApplicationCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ICancelApplicationCommandResponse {
    success?: boolean;
    application?: IApplicationViewModel | undefined;
}

export class GetApplicationsByFilterForCustomerQueryRequest implements IGetApplicationsByFilterForCustomerQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetApplicationsByFilterForCustomerQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetApplicationsByFilterForCustomerQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetApplicationsByFilterForCustomerQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetApplicationsByFilterForCustomerQueryRequest {
        const json = this.toJSON();
        let result = new GetApplicationsByFilterForCustomerQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetApplicationsByFilterForCustomerQueryRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetApplicationsByFilterForCustomerQueryResponse implements IGetApplicationsByFilterForCustomerQueryResponse {
    results?: SlimApplication[] | undefined;
    count?: number;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IGetApplicationsByFilterForCustomerQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new SlimApplication(item) : <SlimApplication>item;
                }
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SlimApplication.fromJS(item));
            }
            this.count = _data["count"];
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetApplicationsByFilterForCustomerQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetApplicationsByFilterForCustomerQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetApplicationsByFilterForCustomerQueryResponse {
        const json = this.toJSON();
        let result = new GetApplicationsByFilterForCustomerQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetApplicationsByFilterForCustomerQueryResponse {
    results?: ISlimApplication[] | undefined;
    count?: number;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetApplicationByIdForCustomerQueryRequest implements IGetApplicationByIdForCustomerQueryRequest {
    id?: string | undefined;
    isGuestApplication?: boolean;

    constructor(data?: IGetApplicationByIdForCustomerQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isGuestApplication = _data["isGuestApplication"];
        }
    }

    static fromJS(data: any): GetApplicationByIdForCustomerQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetApplicationByIdForCustomerQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isGuestApplication"] = this.isGuestApplication;
        return data; 
    }

    clone(): GetApplicationByIdForCustomerQueryRequest {
        const json = this.toJSON();
        let result = new GetApplicationByIdForCustomerQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetApplicationByIdForCustomerQueryRequest {
    id?: string | undefined;
    isGuestApplication?: boolean;
}

export class CreateFiservPaymentCommandRequest implements ICreateFiservPaymentCommandRequest {
    chargeTotal?: number;
    currencyCode?: string | undefined;
    applicationNumber?: string | undefined;

    constructor(data?: ICreateFiservPaymentCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chargeTotal = _data["chargeTotal"];
            this.currencyCode = _data["currencyCode"];
            this.applicationNumber = _data["applicationNumber"];
        }
    }

    static fromJS(data: any): CreateFiservPaymentCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFiservPaymentCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chargeTotal"] = this.chargeTotal;
        data["currencyCode"] = this.currencyCode;
        data["applicationNumber"] = this.applicationNumber;
        return data; 
    }

    clone(): CreateFiservPaymentCommandRequest {
        const json = this.toJSON();
        let result = new CreateFiservPaymentCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateFiservPaymentCommandRequest {
    chargeTotal?: number;
    currencyCode?: string | undefined;
    applicationNumber?: string | undefined;
}

export class PaymentFormParameter implements IPaymentFormParameter {
    ponumber?: string | undefined;
    chargetotal?: string | undefined;
    checkoutoption?: string | undefined;
    currency?: string | undefined;
    hash_algorithm?: string | undefined;
    language?: string | undefined;
    oid?: string | undefined;
    responseFailURL?: string | undefined;
    responseSuccessURL?: string | undefined;
    storename?: string | undefined;
    timezone?: string | undefined;
    txndatetime?: string | undefined;
    txntype?: string | undefined;

    constructor(data?: IPaymentFormParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ponumber = _data["ponumber"];
            this.chargetotal = _data["chargetotal"];
            this.checkoutoption = _data["checkoutoption"];
            this.currency = _data["currency"];
            this.hash_algorithm = _data["hash_algorithm"];
            this.language = _data["language"];
            this.oid = _data["oid"];
            this.responseFailURL = _data["responseFailURL"];
            this.responseSuccessURL = _data["responseSuccessURL"];
            this.storename = _data["storename"];
            this.timezone = _data["timezone"];
            this.txndatetime = _data["txndatetime"];
            this.txntype = _data["txntype"];
        }
    }

    static fromJS(data: any): PaymentFormParameter {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentFormParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ponumber"] = this.ponumber;
        data["chargetotal"] = this.chargetotal;
        data["checkoutoption"] = this.checkoutoption;
        data["currency"] = this.currency;
        data["hash_algorithm"] = this.hash_algorithm;
        data["language"] = this.language;
        data["oid"] = this.oid;
        data["responseFailURL"] = this.responseFailURL;
        data["responseSuccessURL"] = this.responseSuccessURL;
        data["storename"] = this.storename;
        data["timezone"] = this.timezone;
        data["txndatetime"] = this.txndatetime;
        data["txntype"] = this.txntype;
        return data; 
    }

    clone(): PaymentFormParameter {
        const json = this.toJSON();
        let result = new PaymentFormParameter();
        result.init(json);
        return result;
    }
}

export interface IPaymentFormParameter {
    ponumber?: string | undefined;
    chargetotal?: string | undefined;
    checkoutoption?: string | undefined;
    currency?: string | undefined;
    hash_algorithm?: string | undefined;
    language?: string | undefined;
    oid?: string | undefined;
    responseFailURL?: string | undefined;
    responseSuccessURL?: string | undefined;
    storename?: string | undefined;
    timezone?: string | undefined;
    txndatetime?: string | undefined;
    txntype?: string | undefined;
}

export class PaymentInfoModel implements IPaymentInfoModel {
    fiservUrl?: string | undefined;
    hashExtended?: string | undefined;
    notificationUrl?: string | undefined;
    orderId?: string | undefined;
    formParameter?: PaymentFormParameter | undefined;

    constructor(data?: IPaymentInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.formParameter = data.formParameter && !(<any>data.formParameter).toJSON ? new PaymentFormParameter(data.formParameter) : <PaymentFormParameter>this.formParameter; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fiservUrl = _data["fiservUrl"];
            this.hashExtended = _data["hashExtended"];
            this.notificationUrl = _data["notificationUrl"];
            this.orderId = _data["orderId"];
            this.formParameter = _data["formParameter"] ? PaymentFormParameter.fromJS(_data["formParameter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fiservUrl"] = this.fiservUrl;
        data["hashExtended"] = this.hashExtended;
        data["notificationUrl"] = this.notificationUrl;
        data["orderId"] = this.orderId;
        data["formParameter"] = this.formParameter ? this.formParameter.toJSON() : <any>undefined;
        return data; 
    }

    clone(): PaymentInfoModel {
        const json = this.toJSON();
        let result = new PaymentInfoModel();
        result.init(json);
        return result;
    }
}

export interface IPaymentInfoModel {
    fiservUrl?: string | undefined;
    hashExtended?: string | undefined;
    notificationUrl?: string | undefined;
    orderId?: string | undefined;
    formParameter?: IPaymentFormParameter | undefined;
}

export class CreateFiservPaymentCommandResponse implements ICreateFiservPaymentCommandResponse {
    paymentInfo?: PaymentInfoModel | undefined;

    constructor(data?: ICreateFiservPaymentCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.paymentInfo = data.paymentInfo && !(<any>data.paymentInfo).toJSON ? new PaymentInfoModel(data.paymentInfo) : <PaymentInfoModel>this.paymentInfo; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentInfo = _data["paymentInfo"] ? PaymentInfoModel.fromJS(_data["paymentInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateFiservPaymentCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFiservPaymentCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentInfo"] = this.paymentInfo ? this.paymentInfo.toJSON() : <any>undefined;
        return data; 
    }

    clone(): CreateFiservPaymentCommandResponse {
        const json = this.toJSON();
        let result = new CreateFiservPaymentCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ICreateFiservPaymentCommandResponse {
    paymentInfo?: IPaymentInfoModel | undefined;
}

export class FiservSuccessResponseModel implements IFiservSuccessResponseModel {
    txndate_processed?: string | undefined;
    ccbin?: string | undefined;
    timezone?: string | undefined;
    ponumber?: string | undefined;
    processor_network_information?: string | undefined;
    oid?: string | undefined;
    extended_response_hash?: string | undefined;
    cccountry?: string | undefined;
    expmonth?: string | undefined;
    hash_algorithm?: string | undefined;
    endpointTransactionId?: string | undefined;
    currency?: string | undefined;
    processor_response_code?: string | undefined;
    chargetotal?: string | undefined;
    terminal_id?: string | undefined;
    associationResponseCode?: string | undefined;
    approval_code?: string | undefined;
    expyear?: string | undefined;
    response_hash?: string | undefined;
    response_code_3dsecure?: string | undefined;
    schemeTransactionId?: string | undefined;
    tdate?: string | undefined;
    installments_interest?: string | undefined;
    bname?: string | undefined;
    ccbrand?: string | undefined;
    refnumber?: string | undefined;
    txntype?: string | undefined;
    paymentMethod?: string | undefined;
    txndatetime?: string | undefined;
    cardnumber?: string | undefined;
    ipgTransactionId?: string | undefined;
    status?: string | undefined;
    fail_rc?: string | undefined;
    fail_reason?: string | undefined;

    constructor(data?: IFiservSuccessResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.txndate_processed = _data["txndate_processed"];
            this.ccbin = _data["ccbin"];
            this.timezone = _data["timezone"];
            this.ponumber = _data["ponumber"];
            this.processor_network_information = _data["processor_network_information"];
            this.oid = _data["oid"];
            this.extended_response_hash = _data["extended_response_hash"];
            this.cccountry = _data["cccountry"];
            this.expmonth = _data["expmonth"];
            this.hash_algorithm = _data["hash_algorithm"];
            this.endpointTransactionId = _data["endpointTransactionId"];
            this.currency = _data["currency"];
            this.processor_response_code = _data["processor_response_code"];
            this.chargetotal = _data["chargetotal"];
            this.terminal_id = _data["terminal_id"];
            this.associationResponseCode = _data["associationResponseCode"];
            this.approval_code = _data["approval_code"];
            this.expyear = _data["expyear"];
            this.response_hash = _data["response_hash"];
            this.response_code_3dsecure = _data["response_code_3dsecure"];
            this.schemeTransactionId = _data["schemeTransactionId"];
            this.tdate = _data["tdate"];
            this.installments_interest = _data["installments_interest"];
            this.bname = _data["bname"];
            this.ccbrand = _data["ccbrand"];
            this.refnumber = _data["refnumber"];
            this.txntype = _data["txntype"];
            this.paymentMethod = _data["paymentMethod"];
            this.txndatetime = _data["txndatetime"];
            this.cardnumber = _data["cardnumber"];
            this.ipgTransactionId = _data["ipgTransactionId"];
            this.status = _data["status"];
            this.fail_rc = _data["fail_rc"];
            this.fail_reason = _data["fail_reason"];
        }
    }

    static fromJS(data: any): FiservSuccessResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new FiservSuccessResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["txndate_processed"] = this.txndate_processed;
        data["ccbin"] = this.ccbin;
        data["timezone"] = this.timezone;
        data["ponumber"] = this.ponumber;
        data["processor_network_information"] = this.processor_network_information;
        data["oid"] = this.oid;
        data["extended_response_hash"] = this.extended_response_hash;
        data["cccountry"] = this.cccountry;
        data["expmonth"] = this.expmonth;
        data["hash_algorithm"] = this.hash_algorithm;
        data["endpointTransactionId"] = this.endpointTransactionId;
        data["currency"] = this.currency;
        data["processor_response_code"] = this.processor_response_code;
        data["chargetotal"] = this.chargetotal;
        data["terminal_id"] = this.terminal_id;
        data["associationResponseCode"] = this.associationResponseCode;
        data["approval_code"] = this.approval_code;
        data["expyear"] = this.expyear;
        data["response_hash"] = this.response_hash;
        data["response_code_3dsecure"] = this.response_code_3dsecure;
        data["schemeTransactionId"] = this.schemeTransactionId;
        data["tdate"] = this.tdate;
        data["installments_interest"] = this.installments_interest;
        data["bname"] = this.bname;
        data["ccbrand"] = this.ccbrand;
        data["refnumber"] = this.refnumber;
        data["txntype"] = this.txntype;
        data["paymentMethod"] = this.paymentMethod;
        data["txndatetime"] = this.txndatetime;
        data["cardnumber"] = this.cardnumber;
        data["ipgTransactionId"] = this.ipgTransactionId;
        data["status"] = this.status;
        data["fail_rc"] = this.fail_rc;
        data["fail_reason"] = this.fail_reason;
        return data; 
    }

    clone(): FiservSuccessResponseModel {
        const json = this.toJSON();
        let result = new FiservSuccessResponseModel();
        result.init(json);
        return result;
    }
}

export interface IFiservSuccessResponseModel {
    txndate_processed?: string | undefined;
    ccbin?: string | undefined;
    timezone?: string | undefined;
    ponumber?: string | undefined;
    processor_network_information?: string | undefined;
    oid?: string | undefined;
    extended_response_hash?: string | undefined;
    cccountry?: string | undefined;
    expmonth?: string | undefined;
    hash_algorithm?: string | undefined;
    endpointTransactionId?: string | undefined;
    currency?: string | undefined;
    processor_response_code?: string | undefined;
    chargetotal?: string | undefined;
    terminal_id?: string | undefined;
    associationResponseCode?: string | undefined;
    approval_code?: string | undefined;
    expyear?: string | undefined;
    response_hash?: string | undefined;
    response_code_3dsecure?: string | undefined;
    schemeTransactionId?: string | undefined;
    tdate?: string | undefined;
    installments_interest?: string | undefined;
    bname?: string | undefined;
    ccbrand?: string | undefined;
    refnumber?: string | undefined;
    txntype?: string | undefined;
    paymentMethod?: string | undefined;
    txndatetime?: string | undefined;
    cardnumber?: string | undefined;
    ipgTransactionId?: string | undefined;
    status?: string | undefined;
    fail_rc?: string | undefined;
    fail_reason?: string | undefined;
}

export class FiservFailureResponseModel implements IFiservFailureResponseModel {
    approval_code?: string | undefined;
    ccbin?: string | undefined;
    ponumber?: string | undefined;
    timezone?: string | undefined;
    expyear?: string | undefined;
    response_hash?: string | undefined;
    fail_rc?: string | undefined;
    oid?: string | undefined;
    extended_response_hash?: string | undefined;
    installments_interest?: string | undefined;
    cccountry?: string | undefined;
    bname?: string | undefined;
    ccbrand?: string | undefined;
    hash_algorithm?: string | undefined;
    txntype?: string | undefined;
    paymentMethod?: string | undefined;
    currency?: string | undefined;
    txndatetime?: string | undefined;
    ipgTransactionId?: string | undefined;
    fail_reason?: string | undefined;
    chargetotal?: string | undefined;
    status?: string | undefined;
    txndate_processed?: string | undefined;
    processor_network_information?: string | undefined;
    expmonth?: string | undefined;
    endpointTransactionId?: string | undefined;
    processor_response_code?: string | undefined;
    terminal_id?: string | undefined;
    associationResponseCode?: string | undefined;
    response_code_3dsecure?: string | undefined;
    schemeTransactionId?: string | undefined;
    tdate?: string | undefined;
    refnumber?: string | undefined;
    cardnumber?: string | undefined;

    constructor(data?: IFiservFailureResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approval_code = _data["approval_code"];
            this.ccbin = _data["ccbin"];
            this.ponumber = _data["ponumber"];
            this.timezone = _data["timezone"];
            this.expyear = _data["expyear"];
            this.response_hash = _data["response_hash"];
            this.fail_rc = _data["fail_rc"];
            this.oid = _data["oid"];
            this.extended_response_hash = _data["extended_response_hash"];
            this.installments_interest = _data["installments_interest"];
            this.cccountry = _data["cccountry"];
            this.bname = _data["bname"];
            this.ccbrand = _data["ccbrand"];
            this.hash_algorithm = _data["hash_algorithm"];
            this.txntype = _data["txntype"];
            this.paymentMethod = _data["paymentMethod"];
            this.currency = _data["currency"];
            this.txndatetime = _data["txndatetime"];
            this.ipgTransactionId = _data["ipgTransactionId"];
            this.fail_reason = _data["fail_reason"];
            this.chargetotal = _data["chargetotal"];
            this.status = _data["status"];
            this.txndate_processed = _data["txndate_processed"];
            this.processor_network_information = _data["processor_network_information"];
            this.expmonth = _data["expmonth"];
            this.endpointTransactionId = _data["endpointTransactionId"];
            this.processor_response_code = _data["processor_response_code"];
            this.terminal_id = _data["terminal_id"];
            this.associationResponseCode = _data["associationResponseCode"];
            this.response_code_3dsecure = _data["response_code_3dsecure"];
            this.schemeTransactionId = _data["schemeTransactionId"];
            this.tdate = _data["tdate"];
            this.refnumber = _data["refnumber"];
            this.cardnumber = _data["cardnumber"];
        }
    }

    static fromJS(data: any): FiservFailureResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new FiservFailureResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approval_code"] = this.approval_code;
        data["ccbin"] = this.ccbin;
        data["ponumber"] = this.ponumber;
        data["timezone"] = this.timezone;
        data["expyear"] = this.expyear;
        data["response_hash"] = this.response_hash;
        data["fail_rc"] = this.fail_rc;
        data["oid"] = this.oid;
        data["extended_response_hash"] = this.extended_response_hash;
        data["installments_interest"] = this.installments_interest;
        data["cccountry"] = this.cccountry;
        data["bname"] = this.bname;
        data["ccbrand"] = this.ccbrand;
        data["hash_algorithm"] = this.hash_algorithm;
        data["txntype"] = this.txntype;
        data["paymentMethod"] = this.paymentMethod;
        data["currency"] = this.currency;
        data["txndatetime"] = this.txndatetime;
        data["ipgTransactionId"] = this.ipgTransactionId;
        data["fail_reason"] = this.fail_reason;
        data["chargetotal"] = this.chargetotal;
        data["status"] = this.status;
        data["txndate_processed"] = this.txndate_processed;
        data["processor_network_information"] = this.processor_network_information;
        data["expmonth"] = this.expmonth;
        data["endpointTransactionId"] = this.endpointTransactionId;
        data["processor_response_code"] = this.processor_response_code;
        data["terminal_id"] = this.terminal_id;
        data["associationResponseCode"] = this.associationResponseCode;
        data["response_code_3dsecure"] = this.response_code_3dsecure;
        data["schemeTransactionId"] = this.schemeTransactionId;
        data["tdate"] = this.tdate;
        data["refnumber"] = this.refnumber;
        data["cardnumber"] = this.cardnumber;
        return data; 
    }

    clone(): FiservFailureResponseModel {
        const json = this.toJSON();
        let result = new FiservFailureResponseModel();
        result.init(json);
        return result;
    }
}

export interface IFiservFailureResponseModel {
    approval_code?: string | undefined;
    ccbin?: string | undefined;
    ponumber?: string | undefined;
    timezone?: string | undefined;
    expyear?: string | undefined;
    response_hash?: string | undefined;
    fail_rc?: string | undefined;
    oid?: string | undefined;
    extended_response_hash?: string | undefined;
    installments_interest?: string | undefined;
    cccountry?: string | undefined;
    bname?: string | undefined;
    ccbrand?: string | undefined;
    hash_algorithm?: string | undefined;
    txntype?: string | undefined;
    paymentMethod?: string | undefined;
    currency?: string | undefined;
    txndatetime?: string | undefined;
    ipgTransactionId?: string | undefined;
    fail_reason?: string | undefined;
    chargetotal?: string | undefined;
    status?: string | undefined;
    txndate_processed?: string | undefined;
    processor_network_information?: string | undefined;
    expmonth?: string | undefined;
    endpointTransactionId?: string | undefined;
    processor_response_code?: string | undefined;
    terminal_id?: string | undefined;
    associationResponseCode?: string | undefined;
    response_code_3dsecure?: string | undefined;
    schemeTransactionId?: string | undefined;
    tdate?: string | undefined;
    refnumber?: string | undefined;
    cardnumber?: string | undefined;
}

export class GetAllReportsQueryResponse implements IGetAllReportsQueryResponse {
    reports?: string[] | undefined;

    constructor(data?: IGetAllReportsQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reports"])) {
                this.reports = [] as any;
                for (let item of _data["reports"])
                    this.reports!.push(item);
            }
        }
    }

    static fromJS(data: any): GetAllReportsQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllReportsQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reports)) {
            data["reports"] = [];
            for (let item of this.reports)
                data["reports"].push(item);
        }
        return data; 
    }

    clone(): GetAllReportsQueryResponse {
        const json = this.toJSON();
        let result = new GetAllReportsQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllReportsQueryResponse {
    reports?: string[] | undefined;
}

export class GetReportByQueryRequest implements IGetReportByQueryRequest {
    reportName?: string | undefined;
    format?: string | undefined;
    inline?: boolean;
    parameter?: string | undefined;
    offeringId?: string | undefined;

    constructor(data?: IGetReportByQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportName = _data["reportName"];
            this.format = _data["format"];
            this.inline = _data["inline"];
            this.parameter = _data["parameter"];
            this.offeringId = _data["offeringId"];
        }
    }

    static fromJS(data: any): GetReportByQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportByQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportName"] = this.reportName;
        data["format"] = this.format;
        data["inline"] = this.inline;
        data["parameter"] = this.parameter;
        data["offeringId"] = this.offeringId;
        return data; 
    }

    clone(): GetReportByQueryRequest {
        const json = this.toJSON();
        let result = new GetReportByQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetReportByQueryRequest {
    reportName?: string | undefined;
    format?: string | undefined;
    inline?: boolean;
    parameter?: string | undefined;
    offeringId?: string | undefined;
}

export class GetReportByQueryResponse implements IGetReportByQueryResponse {
    stream?: string | undefined;
    mime?: string | undefined;
    file?: string | undefined;

    constructor(data?: IGetReportByQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stream = _data["stream"];
            this.mime = _data["mime"];
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): GetReportByQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetReportByQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stream"] = this.stream;
        data["mime"] = this.mime;
        data["file"] = this.file;
        return data; 
    }

    clone(): GetReportByQueryResponse {
        const json = this.toJSON();
        let result = new GetReportByQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetReportByQueryResponse {
    stream?: string | undefined;
    mime?: string | undefined;
    file?: string | undefined;
}

export class LoginCommandRequest implements ILoginCommandRequest {
    username?: string | undefined;
    password?: string | undefined;
    verificationCode?: string | undefined;

    constructor(data?: ILoginCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.verificationCode = _data["verificationCode"];
        }
    }

    static fromJS(data: any): LoginCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["verificationCode"] = this.verificationCode;
        return data; 
    }

    clone(): LoginCommandRequest {
        const json = this.toJSON();
        let result = new LoginCommandRequest();
        result.init(json);
        return result;
    }
}

export interface ILoginCommandRequest {
    username?: string | undefined;
    password?: string | undefined;
    verificationCode?: string | undefined;
}

export class SlimUser implements ISlimUser {
    id?: string;
    shortId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    sessionId?: string | undefined;
    status?: UserStatus;
    username?: string | undefined;
    emailAddress?: string | undefined;
    operations?: Operations[] | undefined;
    roles?: string[] | undefined;
    jurisdictionName?: string | undefined;
    jurisdictionId?: string | undefined;
    roleId?: string | undefined;

    constructor(data?: ISlimUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shortId = _data["shortId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.sessionId = _data["sessionId"];
            this.status = _data["status"];
            this.username = _data["username"];
            this.emailAddress = _data["emailAddress"];
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(item);
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            this.jurisdictionName = _data["jurisdictionName"];
            this.jurisdictionId = _data["jurisdictionId"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): SlimUser {
        data = typeof data === 'object' ? data : {};
        let result = new SlimUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shortId"] = this.shortId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["sessionId"] = this.sessionId;
        data["status"] = this.status;
        data["username"] = this.username;
        data["emailAddress"] = this.emailAddress;
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["jurisdictionName"] = this.jurisdictionName;
        data["jurisdictionId"] = this.jurisdictionId;
        data["roleId"] = this.roleId;
        return data; 
    }

    clone(): SlimUser {
        const json = this.toJSON();
        let result = new SlimUser();
        result.init(json);
        return result;
    }
}

export interface ISlimUser {
    id?: string;
    shortId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    sessionId?: string | undefined;
    status?: UserStatus;
    username?: string | undefined;
    emailAddress?: string | undefined;
    operations?: Operations[] | undefined;
    roles?: string[] | undefined;
    jurisdictionName?: string | undefined;
    jurisdictionId?: string | undefined;
    roleId?: string | undefined;
}

export class LoginCommandResponse implements ILoginCommandResponse {
    readonly username?: string | undefined;
    readonly fullname?: string | undefined;
    readonly loggedIn?: boolean;
    readonly accessTokenExpiresIn?: number;
    readonly accessToken?: string | undefined;
    readonly user?: SlimUser | undefined;

    constructor(data?: ILoginCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new SlimUser(data.user) : <SlimUser>this.user; 
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).username = _data["username"];
            (<any>this).fullname = _data["fullname"];
            (<any>this).loggedIn = _data["loggedIn"];
            (<any>this).accessTokenExpiresIn = _data["accessTokenExpiresIn"];
            (<any>this).accessToken = _data["accessToken"];
            (<any>this).user = _data["user"] ? SlimUser.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LoginCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LoginCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["fullname"] = this.fullname;
        data["loggedIn"] = this.loggedIn;
        data["accessTokenExpiresIn"] = this.accessTokenExpiresIn;
        data["accessToken"] = this.accessToken;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }

    clone(): LoginCommandResponse {
        const json = this.toJSON();
        let result = new LoginCommandResponse();
        result.init(json);
        return result;
    }
}

export interface ILoginCommandResponse {
    username?: string | undefined;
    fullname?: string | undefined;
    loggedIn?: boolean;
    accessTokenExpiresIn?: number;
    accessToken?: string | undefined;
    user?: ISlimUser | undefined;
}

export class VerifyLoginCommandRequest implements IVerifyLoginCommandRequest {
    username?: string | undefined;
    password?: string | undefined;

    constructor(data?: IVerifyLoginCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): VerifyLoginCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyLoginCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data; 
    }

    clone(): VerifyLoginCommandRequest {
        const json = this.toJSON();
        let result = new VerifyLoginCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IVerifyLoginCommandRequest {
    username?: string | undefined;
    password?: string | undefined;
}

export class VerifyLoginCommandResponse implements IVerifyLoginCommandResponse {
    readonly username?: string | undefined;
    readonly loggedIn?: boolean;

    constructor(data?: IVerifyLoginCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).username = _data["username"];
            (<any>this).loggedIn = _data["loggedIn"];
        }
    }

    static fromJS(data: any): VerifyLoginCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyLoginCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["loggedIn"] = this.loggedIn;
        return data; 
    }

    clone(): VerifyLoginCommandResponse {
        const json = this.toJSON();
        let result = new VerifyLoginCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IVerifyLoginCommandResponse {
    username?: string | undefined;
    loggedIn?: boolean;
}

export class RegisterUserCommandRequest implements IRegisterUserCommandRequest {
    firstName?: string | undefined;
    lastName?: string | undefined;
    clientType?: ClientType;
    businessName?: string | undefined;
    contactFirstName?: string | undefined;
    contactLastName?: string | undefined;
    trn?: string | undefined;
    emailAddress?: string | undefined;
    confirmEmail?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    dateOfBirth?: string | undefined;
    idType?: string | undefined;
    idNumber?: string | undefined;
    question1?: string | undefined;
    answer1?: string | undefined;
    question2?: string | undefined;
    answer2?: string | undefined;
    question3?: string | undefined;
    answer3?: string | undefined;
    telephone?: string | undefined;

    constructor(data?: IRegisterUserCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.clientType = _data["clientType"];
            this.businessName = _data["businessName"];
            this.contactFirstName = _data["contactFirstName"];
            this.contactLastName = _data["contactLastName"];
            this.trn = _data["trn"];
            this.emailAddress = _data["emailAddress"];
            this.confirmEmail = _data["confirmEmail"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.idType = _data["idType"];
            this.idNumber = _data["idNumber"];
            this.question1 = _data["question1"];
            this.answer1 = _data["answer1"];
            this.question2 = _data["question2"];
            this.answer2 = _data["answer2"];
            this.question3 = _data["question3"];
            this.answer3 = _data["answer3"];
            this.telephone = _data["telephone"];
        }
    }

    static fromJS(data: any): RegisterUserCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterUserCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["clientType"] = this.clientType;
        data["businessName"] = this.businessName;
        data["contactFirstName"] = this.contactFirstName;
        data["contactLastName"] = this.contactLastName;
        data["trn"] = this.trn;
        data["emailAddress"] = this.emailAddress;
        data["confirmEmail"] = this.confirmEmail;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        data["dateOfBirth"] = this.dateOfBirth;
        data["idType"] = this.idType;
        data["idNumber"] = this.idNumber;
        data["question1"] = this.question1;
        data["answer1"] = this.answer1;
        data["question2"] = this.question2;
        data["answer2"] = this.answer2;
        data["question3"] = this.question3;
        data["answer3"] = this.answer3;
        data["telephone"] = this.telephone;
        return data; 
    }

    clone(): RegisterUserCommandRequest {
        const json = this.toJSON();
        let result = new RegisterUserCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IRegisterUserCommandRequest {
    firstName?: string | undefined;
    lastName?: string | undefined;
    clientType?: ClientType;
    businessName?: string | undefined;
    contactFirstName?: string | undefined;
    contactLastName?: string | undefined;
    trn?: string | undefined;
    emailAddress?: string | undefined;
    confirmEmail?: string | undefined;
    password?: string | undefined;
    confirmPassword?: string | undefined;
    dateOfBirth?: string | undefined;
    idType?: string | undefined;
    idNumber?: string | undefined;
    question1?: string | undefined;
    answer1?: string | undefined;
    question2?: string | undefined;
    answer2?: string | undefined;
    question3?: string | undefined;
    answer3?: string | undefined;
    telephone?: string | undefined;
}

export class RegisterUserCommandResponse implements IRegisterUserCommandResponse {
    readonly newUser?: SlimUser | undefined;

    constructor(data?: IRegisterUserCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.newUser = data.newUser && !(<any>data.newUser).toJSON ? new SlimUser(data.newUser) : <SlimUser>this.newUser; 
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).newUser = _data["newUser"] ? SlimUser.fromJS(_data["newUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RegisterUserCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterUserCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newUser"] = this.newUser ? this.newUser.toJSON() : <any>undefined;
        return data; 
    }

    clone(): RegisterUserCommandResponse {
        const json = this.toJSON();
        let result = new RegisterUserCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IRegisterUserCommandResponse {
    newUser?: ISlimUser | undefined;
}

export class RegisterGuestCommandRequest implements IRegisterGuestCommandRequest {
    firstName?: string | undefined;
    middleInitial?: string | undefined;
    lastName?: string | undefined;
    trn?: string | undefined;
    emailAddress?: string | undefined;
    confirmEmail?: string | undefined;
    dateOfBirth?: string | undefined;
    telephone?: string | undefined;
    accountNumber?: string | undefined;
    brokerId?: string | undefined;

    constructor(data?: IRegisterGuestCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.middleInitial = _data["middleInitial"];
            this.lastName = _data["lastName"];
            this.trn = _data["trn"];
            this.emailAddress = _data["emailAddress"];
            this.confirmEmail = _data["confirmEmail"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.telephone = _data["telephone"];
            this.accountNumber = _data["accountNumber"];
            this.brokerId = _data["brokerId"];
        }
    }

    static fromJS(data: any): RegisterGuestCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterGuestCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["middleInitial"] = this.middleInitial;
        data["lastName"] = this.lastName;
        data["trn"] = this.trn;
        data["emailAddress"] = this.emailAddress;
        data["confirmEmail"] = this.confirmEmail;
        data["dateOfBirth"] = this.dateOfBirth;
        data["telephone"] = this.telephone;
        data["accountNumber"] = this.accountNumber;
        data["brokerId"] = this.brokerId;
        return data; 
    }

    clone(): RegisterGuestCommandRequest {
        const json = this.toJSON();
        let result = new RegisterGuestCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IRegisterGuestCommandRequest {
    firstName?: string | undefined;
    middleInitial?: string | undefined;
    lastName?: string | undefined;
    trn?: string | undefined;
    emailAddress?: string | undefined;
    confirmEmail?: string | undefined;
    dateOfBirth?: string | undefined;
    telephone?: string | undefined;
    accountNumber?: string | undefined;
    brokerId?: string | undefined;
}

export class RegisterGuestCommandResponse implements IRegisterGuestCommandResponse {
    acctInUse?: boolean;
    readonly newUser?: SlimUser | undefined;

    constructor(data?: IRegisterGuestCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.newUser = data.newUser && !(<any>data.newUser).toJSON ? new SlimUser(data.newUser) : <SlimUser>this.newUser; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acctInUse = _data["acctInUse"];
            (<any>this).newUser = _data["newUser"] ? SlimUser.fromJS(_data["newUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RegisterGuestCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterGuestCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acctInUse"] = this.acctInUse;
        data["newUser"] = this.newUser ? this.newUser.toJSON() : <any>undefined;
        return data; 
    }

    clone(): RegisterGuestCommandResponse {
        const json = this.toJSON();
        let result = new RegisterGuestCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IRegisterGuestCommandResponse {
    acctInUse?: boolean;
    newUser?: ISlimUser | undefined;
}

export class ValidateGuestOTPCommandRequest implements IValidateGuestOTPCommandRequest {
    guestId?: string;
    otp?: string | undefined;

    constructor(data?: IValidateGuestOTPCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guestId = _data["guestId"];
            this.otp = _data["otp"];
        }
    }

    static fromJS(data: any): ValidateGuestOTPCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateGuestOTPCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guestId"] = this.guestId;
        data["otp"] = this.otp;
        return data; 
    }

    clone(): ValidateGuestOTPCommandRequest {
        const json = this.toJSON();
        let result = new ValidateGuestOTPCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IValidateGuestOTPCommandRequest {
    guestId?: string;
    otp?: string | undefined;
}

export class LoginResponseModel implements ILoginResponseModel {
    username?: string | undefined;
    fullname?: string | undefined;
    loggedIn?: boolean;
    accessTokenExpiresIn?: number;
    user?: SlimUser | undefined;

    constructor(data?: ILoginResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.user = data.user && !(<any>data.user).toJSON ? new SlimUser(data.user) : <SlimUser>this.user; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.fullname = _data["fullname"];
            this.loggedIn = _data["loggedIn"];
            this.accessTokenExpiresIn = _data["accessTokenExpiresIn"];
            this.user = _data["user"] ? SlimUser.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LoginResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new LoginResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["fullname"] = this.fullname;
        data["loggedIn"] = this.loggedIn;
        data["accessTokenExpiresIn"] = this.accessTokenExpiresIn;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }

    clone(): LoginResponseModel {
        const json = this.toJSON();
        let result = new LoginResponseModel();
        result.init(json);
        return result;
    }
}

export interface ILoginResponseModel {
    username?: string | undefined;
    fullname?: string | undefined;
    loggedIn?: boolean;
    accessTokenExpiresIn?: number;
    user?: ISlimUser | undefined;
}

export class ResendOTPCommandRequest implements IResendOTPCommandRequest {
    guestId?: string;

    constructor(data?: IResendOTPCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guestId = _data["guestId"];
        }
    }

    static fromJS(data: any): ResendOTPCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResendOTPCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guestId"] = this.guestId;
        return data; 
    }

    clone(): ResendOTPCommandRequest {
        const json = this.toJSON();
        let result = new ResendOTPCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IResendOTPCommandRequest {
    guestId?: string;
}

export class ResendOTPCommandResponse implements IResendOTPCommandResponse {
    expiryTimeInSeconds?: number;

    constructor(data?: IResendOTPCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expiryTimeInSeconds = _data["expiryTimeInSeconds"];
        }
    }

    static fromJS(data: any): ResendOTPCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResendOTPCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expiryTimeInSeconds"] = this.expiryTimeInSeconds;
        return data; 
    }

    clone(): ResendOTPCommandResponse {
        const json = this.toJSON();
        let result = new ResendOTPCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IResendOTPCommandResponse {
    expiryTimeInSeconds?: number;
}

export class ConfirmRegistrationCommandRequest implements IConfirmRegistrationCommandRequest {
    token?: string | undefined;
    emailAddress?: string | undefined;

    constructor(data?: IConfirmRegistrationCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): ConfirmRegistrationCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmRegistrationCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["emailAddress"] = this.emailAddress;
        return data; 
    }

    clone(): ConfirmRegistrationCommandRequest {
        const json = this.toJSON();
        let result = new ConfirmRegistrationCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IConfirmRegistrationCommandRequest {
    token?: string | undefined;
    emailAddress?: string | undefined;
}

export class IdentityError implements IIdentityError {
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IIdentityError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): IdentityError {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data; 
    }

    clone(): IdentityError {
        const json = this.toJSON();
        let result = new IdentityError();
        result.init(json);
        return result;
    }
}

export interface IIdentityError {
    code?: string | undefined;
    description?: string | undefined;
}

export class IdentityResult implements IIdentityResult {
    readonly succeeded?: boolean;
    readonly errors?: IdentityError[] | undefined;

    constructor(data?: IIdentityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.errors) {
                this.errors = [];
                for (let i = 0; i < data.errors.length; i++) {
                    let item = data.errors[i];
                    this.errors[i] = item && !(<any>item).toJSON ? new IdentityError(item) : <IdentityError>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(IdentityError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IdentityResult {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data; 
    }

    clone(): IdentityResult {
        const json = this.toJSON();
        let result = new IdentityResult();
        result.init(json);
        return result;
    }
}

export interface IIdentityResult {
    succeeded?: boolean;
    errors?: IIdentityError[] | undefined;
}

export class ConfirmRegistrationCommandResponse implements IConfirmRegistrationCommandResponse {
    readonly result?: IdentityResult | undefined;
    readonly user?: SlimUser | undefined;

    constructor(data?: IConfirmRegistrationCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.result = data.result && !(<any>data.result).toJSON ? new IdentityResult(data.result) : <IdentityResult>this.result; 
            this.user = data.user && !(<any>data.user).toJSON ? new SlimUser(data.user) : <SlimUser>this.user; 
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).result = _data["result"] ? IdentityResult.fromJS(_data["result"]) : <any>undefined;
            (<any>this).user = _data["user"] ? SlimUser.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConfirmRegistrationCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmRegistrationCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data; 
    }

    clone(): ConfirmRegistrationCommandResponse {
        const json = this.toJSON();
        let result = new ConfirmRegistrationCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IConfirmRegistrationCommandResponse {
    result?: IIdentityResult | undefined;
    user?: ISlimUser | undefined;
}

export class ResetPasswordCommandRequest implements IResetPasswordCommandRequest {
    emailAddress?: string | undefined;
    token?: string | undefined;
    password?: string | undefined;
    confirmationPassword?: string | undefined;

    constructor(data?: IResetPasswordCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.token = _data["token"];
            this.password = _data["password"];
            this.confirmationPassword = _data["confirmationPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["token"] = this.token;
        data["password"] = this.password;
        data["confirmationPassword"] = this.confirmationPassword;
        return data; 
    }

    clone(): ResetPasswordCommandRequest {
        const json = this.toJSON();
        let result = new ResetPasswordCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordCommandRequest {
    emailAddress?: string | undefined;
    token?: string | undefined;
    password?: string | undefined;
    confirmationPassword?: string | undefined;
}

export class GetSecurityQuestionsQueryRequest implements IGetSecurityQuestionsQueryRequest {

    constructor(data?: IGetSecurityQuestionsQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetSecurityQuestionsQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSecurityQuestionsQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): GetSecurityQuestionsQueryRequest {
        const json = this.toJSON();
        let result = new GetSecurityQuestionsQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetSecurityQuestionsQueryRequest {
}

export class SecurityQuestionModel implements ISecurityQuestionModel {
    id?: string;
    question?: string | undefined;
    answer?: string | undefined;
    clientId?: string;
    clientInfo?: ClientInfo | undefined;

    constructor(data?: ISecurityQuestionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.clientInfo = data.clientInfo && !(<any>data.clientInfo).toJSON ? new ClientInfo(data.clientInfo) : <ClientInfo>this.clientInfo; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.question = _data["question"];
            this.answer = _data["answer"];
            this.clientId = _data["clientId"];
            this.clientInfo = _data["clientInfo"] ? ClientInfo.fromJS(_data["clientInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SecurityQuestionModel {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityQuestionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["question"] = this.question;
        data["answer"] = this.answer;
        data["clientId"] = this.clientId;
        data["clientInfo"] = this.clientInfo ? this.clientInfo.toJSON() : <any>undefined;
        return data; 
    }

    clone(): SecurityQuestionModel {
        const json = this.toJSON();
        let result = new SecurityQuestionModel();
        result.init(json);
        return result;
    }
}

export interface ISecurityQuestionModel {
    id?: string;
    question?: string | undefined;
    answer?: string | undefined;
    clientId?: string;
    clientInfo?: IClientInfo | undefined;
}

export class GetSecurityQuestionsQueryResponse implements IGetSecurityQuestionsQueryResponse {
    questions?: SecurityQuestionModel[] | undefined;

    constructor(data?: IGetSecurityQuestionsQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.questions) {
                this.questions = [];
                for (let i = 0; i < data.questions.length; i++) {
                    let item = data.questions[i];
                    this.questions[i] = item && !(<any>item).toJSON ? new SecurityQuestionModel(item) : <SecurityQuestionModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(SecurityQuestionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSecurityQuestionsQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSecurityQuestionsQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetSecurityQuestionsQueryResponse {
        const json = this.toJSON();
        let result = new GetSecurityQuestionsQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetSecurityQuestionsQueryResponse {
    questions?: ISecurityQuestionModel[] | undefined;
}

export class UpdateSecurityQuestionsCommandRequest implements IUpdateSecurityQuestionsCommandRequest {
    questions?: SecurityQuestionModel[] | undefined;

    constructor(data?: IUpdateSecurityQuestionsCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.questions) {
                this.questions = [];
                for (let i = 0; i < data.questions.length; i++) {
                    let item = data.questions[i];
                    this.questions[i] = item && !(<any>item).toJSON ? new SecurityQuestionModel(item) : <SecurityQuestionModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(SecurityQuestionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSecurityQuestionsCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSecurityQuestionsCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data; 
    }

    clone(): UpdateSecurityQuestionsCommandRequest {
        const json = this.toJSON();
        let result = new UpdateSecurityQuestionsCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateSecurityQuestionsCommandRequest {
    questions?: ISecurityQuestionModel[] | undefined;
}

export class UpdateSecurityQuestionsCommandResponse implements IUpdateSecurityQuestionsCommandResponse {
    success?: boolean;

    constructor(data?: IUpdateSecurityQuestionsCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): UpdateSecurityQuestionsCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSecurityQuestionsCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data; 
    }

    clone(): UpdateSecurityQuestionsCommandResponse {
        const json = this.toJSON();
        let result = new UpdateSecurityQuestionsCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateSecurityQuestionsCommandResponse {
    success?: boolean;
}

export class CountryFilterRequest implements ICountryFilterRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: ICountryFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountryFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CountryFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CountryFilterRequest {
        const json = this.toJSON();
        let result = new CountryFilterRequest();
        result.init(json);
        return result;
    }
}

export interface ICountryFilterRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class Country implements ICountry {
    name?: string | undefined;
    twoLetterCode?: string | undefined;
    threeLetterCode?: string | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.twoLetterCode = _data["twoLetterCode"];
            this.threeLetterCode = _data["threeLetterCode"];
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["twoLetterCode"] = this.twoLetterCode;
        data["threeLetterCode"] = this.threeLetterCode;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): Country {
        const json = this.toJSON();
        let result = new Country();
        result.init(json);
        return result;
    }
}

export interface ICountry {
    name?: string | undefined;
    twoLetterCode?: string | undefined;
    threeLetterCode?: string | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class CountryFilterResponse implements ICountryFilterResponse {
    results?: Country[] | undefined;
    count?: number;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: ICountryFilterResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new Country(item) : <Country>item;
                }
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(Country.fromJS(item));
            }
            this.count = _data["count"];
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountryFilterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CountryFilterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CountryFilterResponse {
        const json = this.toJSON();
        let result = new CountryFilterResponse();
        result.init(json);
        return result;
    }
}

export interface ICountryFilterResponse {
    results?: ICountry[] | undefined;
    count?: number;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class GetPaymentMethodDescriptionCommandRequest implements IGetPaymentMethodDescriptionCommandRequest {
    currency?: string | undefined;

    constructor(data?: IGetPaymentMethodDescriptionCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): GetPaymentMethodDescriptionCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentMethodDescriptionCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currency"] = this.currency;
        return data; 
    }

    clone(): GetPaymentMethodDescriptionCommandRequest {
        const json = this.toJSON();
        let result = new GetPaymentMethodDescriptionCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IGetPaymentMethodDescriptionCommandRequest {
    currency?: string | undefined;
}

export class PaymentMethodDescriptionModel implements IPaymentMethodDescriptionModel {
    paymentType?: string | undefined;
    description?: string | undefined;
    bankDetailJMD?: string | undefined;
    bankDetailUSD?: string | undefined;
    wireTransferDetails?: string | undefined;

    constructor(data?: IPaymentMethodDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentType = _data["paymentType"];
            this.description = _data["description"];
            this.bankDetailJMD = _data["bankDetailJMD"];
            this.bankDetailUSD = _data["bankDetailUSD"];
            this.wireTransferDetails = _data["wireTransferDetails"];
        }
    }

    static fromJS(data: any): PaymentMethodDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentType"] = this.paymentType;
        data["description"] = this.description;
        data["bankDetailJMD"] = this.bankDetailJMD;
        data["bankDetailUSD"] = this.bankDetailUSD;
        data["wireTransferDetails"] = this.wireTransferDetails;
        return data; 
    }

    clone(): PaymentMethodDescriptionModel {
        const json = this.toJSON();
        let result = new PaymentMethodDescriptionModel();
        result.init(json);
        return result;
    }
}

export interface IPaymentMethodDescriptionModel {
    paymentType?: string | undefined;
    description?: string | undefined;
    bankDetailJMD?: string | undefined;
    bankDetailUSD?: string | undefined;
    wireTransferDetails?: string | undefined;
}

export class GetPaymentMethodDescriptionCommandResponse implements IGetPaymentMethodDescriptionCommandResponse {
    paymentDescriptions?: PaymentMethodDescriptionModel[] | undefined;

    constructor(data?: IGetPaymentMethodDescriptionCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.paymentDescriptions) {
                this.paymentDescriptions = [];
                for (let i = 0; i < data.paymentDescriptions.length; i++) {
                    let item = data.paymentDescriptions[i];
                    this.paymentDescriptions[i] = item && !(<any>item).toJSON ? new PaymentMethodDescriptionModel(item) : <PaymentMethodDescriptionModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["paymentDescriptions"])) {
                this.paymentDescriptions = [] as any;
                for (let item of _data["paymentDescriptions"])
                    this.paymentDescriptions!.push(PaymentMethodDescriptionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPaymentMethodDescriptionCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentMethodDescriptionCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.paymentDescriptions)) {
            data["paymentDescriptions"] = [];
            for (let item of this.paymentDescriptions)
                data["paymentDescriptions"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetPaymentMethodDescriptionCommandResponse {
        const json = this.toJSON();
        let result = new GetPaymentMethodDescriptionCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPaymentMethodDescriptionCommandResponse {
    paymentDescriptions?: IPaymentMethodDescriptionModel[] | undefined;
}

export class BrokerFilterRequest implements IBrokerFilterRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IBrokerFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BrokerFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BrokerFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): BrokerFilterRequest {
        const json = this.toJSON();
        let result = new BrokerFilterRequest();
        result.init(json);
        return result;
    }
}

export interface IBrokerFilterRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class BrokerFilterResponse implements IBrokerFilterResponse {
    results?: Broker[] | undefined;
    count?: number;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IBrokerFilterResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new Broker(item) : <Broker>item;
                }
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(Broker.fromJS(item));
            }
            this.count = _data["count"];
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BrokerFilterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BrokerFilterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): BrokerFilterResponse {
        const json = this.toJSON();
        let result = new BrokerFilterResponse();
        result.init(json);
        return result;
    }
}

export interface IBrokerFilterResponse {
    results?: IBroker[] | undefined;
    count?: number;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class BankFilterRequest implements IBankFilterRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IBankFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BankFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BankFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): BankFilterRequest {
        const json = this.toJSON();
        let result = new BankFilterRequest();
        result.init(json);
        return result;
    }
}

export interface IBankFilterRequest {
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class BankBranch implements IBankBranch {
    name?: string | undefined;
    address?: string | undefined;
    branchCode?: string | undefined;
    bankCode?: string | undefined;
    active?: boolean;
    bankId?: string;
    bank?: Bank | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IBankBranch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.bank = data.bank && !(<any>data.bank).toJSON ? new Bank(data.bank) : <Bank>this.bank; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"];
            this.branchCode = _data["branchCode"];
            this.bankCode = _data["bankCode"];
            this.active = _data["active"];
            this.bankId = _data["bankId"];
            this.bank = _data["bank"] ? Bank.fromJS(_data["bank"]) : <any>undefined;
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): BankBranch {
        data = typeof data === 'object' ? data : {};
        let result = new BankBranch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address;
        data["branchCode"] = this.branchCode;
        data["bankCode"] = this.bankCode;
        data["active"] = this.active;
        data["bankId"] = this.bankId;
        data["bank"] = this.bank ? this.bank.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): BankBranch {
        const json = this.toJSON();
        let result = new BankBranch();
        result.init(json);
        return result;
    }
}

export interface IBankBranch {
    name?: string | undefined;
    address?: string | undefined;
    branchCode?: string | undefined;
    bankCode?: string | undefined;
    active?: boolean;
    bankId?: string;
    bank?: IBank | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class Bank implements IBank {
    name?: string | undefined;
    shortName?: string | undefined;
    bankCode?: string | undefined;
    active?: boolean;
    bankBranches?: BankBranch[] | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;

    constructor(data?: IBank) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.bankBranches) {
                this.bankBranches = [];
                for (let i = 0; i < data.bankBranches.length; i++) {
                    let item = data.bankBranches[i];
                    this.bankBranches[i] = item && !(<any>item).toJSON ? new BankBranch(item) : <BankBranch>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.bankCode = _data["bankCode"];
            this.active = _data["active"];
            if (Array.isArray(_data["bankBranches"])) {
                this.bankBranches = [] as any;
                for (let item of _data["bankBranches"])
                    this.bankBranches!.push(BankBranch.fromJS(item));
            }
            this.id = _data["id"];
            this.createdBy = _data["createdBy"];
            this.createdById = _data["createdById"];
            this.creationDate = _data["creationDate"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedById = _data["modifiedById"];
            this.modificationDate = _data["modificationDate"];
            this.rowVersion = _data["rowVersion"];
        }
    }

    static fromJS(data: any): Bank {
        data = typeof data === 'object' ? data : {};
        let result = new Bank();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["bankCode"] = this.bankCode;
        data["active"] = this.active;
        if (Array.isArray(this.bankBranches)) {
            data["bankBranches"] = [];
            for (let item of this.bankBranches)
                data["bankBranches"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["createdBy"] = this.createdBy;
        data["createdById"] = this.createdById;
        data["creationDate"] = this.creationDate;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedById"] = this.modifiedById;
        data["modificationDate"] = this.modificationDate;
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): Bank {
        const json = this.toJSON();
        let result = new Bank();
        result.init(json);
        return result;
    }
}

export interface IBank {
    name?: string | undefined;
    shortName?: string | undefined;
    bankCode?: string | undefined;
    active?: boolean;
    bankBranches?: IBankBranch[] | undefined;
    id?: string;
    createdBy?: string | undefined;
    createdById?: string | undefined;
    creationDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedById?: string | undefined;
    modificationDate?: string | undefined;
    rowVersion?: string | undefined;
}

export class BankFilterResponse implements IBankFilterResponse {
    results?: Bank[] | undefined;
    count?: number;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: Filter[] | undefined;
    orderBy?: OrderBy[] | undefined;

    constructor(data?: IBankFilterResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.results) {
                this.results = [];
                for (let i = 0; i < data.results.length; i++) {
                    let item = data.results[i];
                    this.results[i] = item && !(<any>item).toJSON ? new Bank(item) : <Bank>item;
                }
            }
            if (data.filters) {
                this.filters = [];
                for (let i = 0; i < data.filters.length; i++) {
                    let item = data.filters[i];
                    this.filters[i] = item && !(<any>item).toJSON ? new Filter(item) : <Filter>item;
                }
            }
            if (data.orderBy) {
                this.orderBy = [];
                for (let i = 0; i < data.orderBy.length; i++) {
                    let item = data.orderBy[i];
                    this.orderBy[i] = item && !(<any>item).toJSON ? new OrderBy(item) : <OrderBy>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(Bank.fromJS(item));
            }
            this.count = _data["count"];
            this.pageNumber = _data["pageNumber"];
            this.amountPerPage = _data["amountPerPage"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(Filter.fromJS(item));
            }
            if (Array.isArray(_data["orderBy"])) {
                this.orderBy = [] as any;
                for (let item of _data["orderBy"])
                    this.orderBy!.push(OrderBy.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BankFilterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BankFilterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        data["count"] = this.count;
        data["pageNumber"] = this.pageNumber;
        data["amountPerPage"] = this.amountPerPage;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        if (Array.isArray(this.orderBy)) {
            data["orderBy"] = [];
            for (let item of this.orderBy)
                data["orderBy"].push(item.toJSON());
        }
        return data; 
    }

    clone(): BankFilterResponse {
        const json = this.toJSON();
        let result = new BankFilterResponse();
        result.init(json);
        return result;
    }
}

export interface IBankFilterResponse {
    results?: IBank[] | undefined;
    count?: number;
    pageNumber?: number;
    amountPerPage?: number;
    filters?: IFilter[] | undefined;
    orderBy?: IOrderBy[] | undefined;
}

export class RequestPasswordResetCommandRequest implements IRequestPasswordResetCommandRequest {
    emailAddress?: string | undefined;

    constructor(data?: IRequestPasswordResetCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): RequestPasswordResetCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPasswordResetCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data; 
    }

    clone(): RequestPasswordResetCommandRequest {
        const json = this.toJSON();
        let result = new RequestPasswordResetCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IRequestPasswordResetCommandRequest {
    emailAddress?: string | undefined;
}

export class ResendActivationEmailCommandRequest implements IResendActivationEmailCommandRequest {
    emailAddress?: string | undefined;

    constructor(data?: IResendActivationEmailCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): ResendActivationEmailCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResendActivationEmailCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data; 
    }

    clone(): ResendActivationEmailCommandRequest {
        const json = this.toJSON();
        let result = new ResendActivationEmailCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IResendActivationEmailCommandRequest {
    emailAddress?: string | undefined;
}

export class ChangePasswordCommandRequest implements IChangePasswordCommandRequest {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    confirmPassword?: string | undefined;

    constructor(data?: IChangePasswordCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        data["confirmPassword"] = this.confirmPassword;
        return data; 
    }

    clone(): ChangePasswordCommandRequest {
        const json = this.toJSON();
        let result = new ChangePasswordCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordCommandRequest {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    confirmPassword?: string | undefined;
}

export class GetMyUserProfileQueryRequest implements IGetMyUserProfileQueryRequest {

    constructor(data?: IGetMyUserProfileQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetMyUserProfileQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyUserProfileQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): GetMyUserProfileQueryRequest {
        const json = this.toJSON();
        let result = new GetMyUserProfileQueryRequest();
        result.init(json);
        return result;
    }
}

export interface IGetMyUserProfileQueryRequest {
}

export class SlimDocument implements ISlimDocument {
    id?: string;
    documentType?: ClientDocumentType;
    documentId?: string | undefined;
    documentMime?: string | undefined;
    documentUrl?: string | undefined;
    dateUploaded?: string | undefined;
    comments?: string | undefined;

    constructor(data?: ISlimDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentType = _data["documentType"];
            this.documentId = _data["documentId"];
            this.documentMime = _data["documentMime"];
            this.documentUrl = _data["documentUrl"];
            this.dateUploaded = _data["dateUploaded"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): SlimDocument {
        data = typeof data === 'object' ? data : {};
        let result = new SlimDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentType"] = this.documentType;
        data["documentId"] = this.documentId;
        data["documentMime"] = this.documentMime;
        data["documentUrl"] = this.documentUrl;
        data["dateUploaded"] = this.dateUploaded;
        data["comments"] = this.comments;
        return data; 
    }

    clone(): SlimDocument {
        const json = this.toJSON();
        let result = new SlimDocument();
        result.init(json);
        return result;
    }
}

export interface ISlimDocument {
    id?: string;
    documentType?: ClientDocumentType;
    documentId?: string | undefined;
    documentMime?: string | undefined;
    documentUrl?: string | undefined;
    dateUploaded?: string | undefined;
    comments?: string | undefined;
}

export class GetMyUserProfileQueryResponse implements IGetMyUserProfileQueryResponse {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    clientSideConfig?: string | undefined;
    trn?: string | undefined;
    dateOfBirth?: string | undefined;
    idType?: string | undefined;
    idNumber?: string | undefined;
    documents?: SlimDocument[] | undefined;

    constructor(data?: IGetMyUserProfileQueryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.documents) {
                this.documents = [];
                for (let i = 0; i < data.documents.length; i++) {
                    let item = data.documents[i];
                    this.documents[i] = item && !(<any>item).toJSON ? new SlimDocument(item) : <SlimDocument>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.clientSideConfig = _data["clientSideConfig"];
            this.trn = _data["trn"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.idType = _data["idType"];
            this.idNumber = _data["idNumber"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(SlimDocument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMyUserProfileQueryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMyUserProfileQueryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["clientSideConfig"] = this.clientSideConfig;
        data["trn"] = this.trn;
        data["dateOfBirth"] = this.dateOfBirth;
        data["idType"] = this.idType;
        data["idNumber"] = this.idNumber;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetMyUserProfileQueryResponse {
        const json = this.toJSON();
        let result = new GetMyUserProfileQueryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetMyUserProfileQueryResponse {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    clientSideConfig?: string | undefined;
    trn?: string | undefined;
    dateOfBirth?: string | undefined;
    idType?: string | undefined;
    idNumber?: string | undefined;
    documents?: ISlimDocument[] | undefined;
}

export class UserEditOwnProfileCommandRequest implements IUserEditOwnProfileCommandRequest {
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: string | undefined;
    idType?: string | undefined;
    idNumber?: string | undefined;
    clientSideConfig?: string | undefined;

    constructor(data?: IUserEditOwnProfileCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.idType = _data["idType"];
            this.idNumber = _data["idNumber"];
            this.clientSideConfig = _data["clientSideConfig"];
        }
    }

    static fromJS(data: any): UserEditOwnProfileCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserEditOwnProfileCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        data["dateOfBirth"] = this.dateOfBirth;
        data["idType"] = this.idType;
        data["idNumber"] = this.idNumber;
        data["clientSideConfig"] = this.clientSideConfig;
        return data; 
    }

    clone(): UserEditOwnProfileCommandRequest {
        const json = this.toJSON();
        let result = new UserEditOwnProfileCommandRequest();
        result.init(json);
        return result;
    }
}

export interface IUserEditOwnProfileCommandRequest {
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
    dateOfBirth?: string | undefined;
    idType?: string | undefined;
    idNumber?: string | undefined;
    clientSideConfig?: string | undefined;
}

export class UserEditOwnProfileCommandResponse implements IUserEditOwnProfileCommandResponse {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;

    constructor(data?: IUserEditOwnProfileCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): UserEditOwnProfileCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserEditOwnProfileCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phoneNumber"] = this.phoneNumber;
        return data; 
    }

    clone(): UserEditOwnProfileCommandResponse {
        const json = this.toJSON();
        let result = new UserEditOwnProfileCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IUserEditOwnProfileCommandResponse {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phoneNumber?: string | undefined;
}

export class ClientDocumentModel implements IClientDocumentModel {
    documentType?: ClientDocumentType;
    documents?: string | undefined;
    comments?: string | undefined;

    constructor(data?: IClientDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentType = _data["documentType"];
            this.documents = _data["documents"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): ClientDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["documents"] = this.documents;
        data["comments"] = this.comments;
        return data; 
    }

    clone(): ClientDocumentModel {
        const json = this.toJSON();
        let result = new ClientDocumentModel();
        result.init(json);
        return result;
    }
}

export interface IClientDocumentModel {
    documentType?: ClientDocumentType;
    documents?: string | undefined;
    comments?: string | undefined;
}

export class UploadUserDocumentsCommandResponse implements IUploadUserDocumentsCommandResponse {
    success?: boolean;

    constructor(data?: IUploadUserDocumentsCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): UploadUserDocumentsCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadUserDocumentsCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        return data; 
    }

    clone(): UploadUserDocumentsCommandResponse {
        const json = this.toJSON();
        let result = new UploadUserDocumentsCommandResponse();
        result.init(json);
        return result;
    }
}

export interface IUploadUserDocumentsCommandResponse {
    success?: boolean;
}

export class ClientDocumentViewModel implements IClientDocumentViewModel {
    document?: ClientDocumentModel[] | undefined;

    constructor(data?: IClientDocumentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.document) {
                this.document = [];
                for (let i = 0; i < data.document.length; i++) {
                    let item = data.document[i];
                    this.document[i] = item && !(<any>item).toJSON ? new ClientDocumentModel(item) : <ClientDocumentModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["document"])) {
                this.document = [] as any;
                for (let item of _data["document"])
                    this.document!.push(ClientDocumentModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientDocumentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDocumentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.document)) {
            data["document"] = [];
            for (let item of this.document)
                data["document"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ClientDocumentViewModel {
        const json = this.toJSON();
        let result = new ClientDocumentViewModel();
        result.init(json);
        return result;
    }
}

export interface IClientDocumentViewModel {
    document?: IClientDocumentModel[] | undefined;
}

export enum Operations {
    Create_Role = "Create Role",
    Is_Authenticated = "Is Authenticated",
    View_Roles = "View Roles",
    Activate_User = "Activate User",
    Deactivate_User = "Deactivate User",
    View_Admin_User = "View Admin User",
    View_Client_User = "View Client User",
    Edit_Role = "Edit Role",
    Edit_User = "Edit User",
    Add_User = "Add User",
    View_Audit = "View Audit",
    View_Offerings = "View Offerings",
    View_Applications = "View Applications",
    Create_Offering = "Create Offering",
    Create_Jcsd_Account = "Create Jcsd Account",
    View_Account = "View Account",
    Edit_Offering = "Edit Offering",
    Approve_Offering = "Approve Offering",
    Publish_Offering = "Publish Offering",
    Suspend_Offering = "Suspend Offering",
    Close_Offering = "Close Offering",
    Reject_Offering = "Reject Offering",
    View_Application_By_Broker_Report = "View Application By Broker Report",
    View_Exception_Report = "View Exception Report",
    View_Ipo_Master_Report = "View Ipo Master Report",
    View_Settlement_Report = "View Settlement Report",
    View_Allocation_Report = "View Allocation Report",
    Client = "Client",
    Guest_Login = "Guest Login",
    Confirm_Payment = "Confirm Payment",
    Upload_Allocation = "Upload Allocation",
    Payment_Approval = "Payment Approval",
    View_Payment_Report = "View Payment Report",
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}